

import type { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { gql } from 'graphql-tag'

/* tslint:disable */
/* eslint-disable */

const VariableName = ' $1fcbcbff-3e78-462f-b45c-668a3e09bfd8'

const ScalarBrandingField = ' $1fcbcbff-3e78-462f-b45c-668a3e09bfd9'

type CustomScalar<T> = { [ScalarBrandingField]: T }

class Variable<T, Name extends string> {
  private [VariableName]: Name
  // @ts-ignore
  private _type?: T

  // @ts-ignore
  constructor(name: Name, private readonly isRequired?: boolean) {
    this[VariableName] = name
  }
}

type ArrayInput<I> = [I] extends [$Atomic] ? never : ReadonlyArray<VariabledInput<I>>

type AllowedInlineScalars<S> = S extends string | number ? S : never

export type UnwrapCustomScalars<T> = T extends CustomScalar<infer S>
  ? S
  : T extends ReadonlyArray<infer I>
  ? ReadonlyArray<UnwrapCustomScalars<I>>
  : T extends Record<string, any>
  ? { [K in keyof T]: UnwrapCustomScalars<T[K]> }
  : T

type VariableWithoutScalars<T, Str extends string> = Variable<UnwrapCustomScalars<T>, Str>

// the array wrapper prevents distributive conditional types
// https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#distributive-conditional-types
type VariabledInput<T> = [T] extends [CustomScalar<infer S> | null | undefined]
  ? // scalars only support variable input
    Variable<S | null | undefined, any> | AllowedInlineScalars<S> | null | undefined
  : [T] extends [CustomScalar<infer S>]
  ? Variable<S, any> | AllowedInlineScalars<S>
  : [T] extends [$Atomic]
  ? Variable<T, any> | T
  : T extends ReadonlyArray<infer I>
  ? VariableWithoutScalars<T, any> | T | ArrayInput<I>
  : T extends Record<string, any> | null | undefined
  ?
      | VariableWithoutScalars<T | null | undefined, any>
      | null
      | undefined
      | { [K in keyof T]: VariabledInput<T[K]> }
      | T
  : T extends Record<string, any>
  ? VariableWithoutScalars<T, any> | { [K in keyof T]: VariabledInput<T[K]> } | T
  : never

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never

/**
 * Creates a new query variable
 *
 * @param name The variable name
 */
export const $ = <Type, Name extends string>(name: Name): Variable<Type, Name> => {
  return new Variable(name)
}

/**
 * Creates a new query variable. A value will be required even if the input is optional
 *
 * @param name The variable name
 */
export const $$ = <Type, Name extends string>(name: Name): Variable<NonNullable<Type>, Name> => {
  return new Variable(name, true)
}

type SelectOptions = {
  argTypes?: { [key: string]: string }
  args?: { [key: string]: any }
  selection?: Selection<any>
}

class $Field<Name extends string, Type, Vars = {}> {
  public kind: 'field' = 'field'
  public type!: Type

  public vars!: Vars
  public alias: string | null = null

  constructor(public name: Name, public options: SelectOptions) {}

  as<Rename extends string>(alias: Rename): $Field<Rename, Type, Vars> {
    const f = new $Field(this.name, this.options)
    f.alias = alias
    return f as any
  }
}

class $Base<Name extends string> {
  // @ts-ignore
  constructor(private $$name: Name) {}

  protected $_select<Key extends string>(
    name: Key,
    options: SelectOptions = {}
  ): $Field<Key, any, any> {
    return new $Field(name, options)
  }
}

// @ts-ignore
class $Union<T, Name extends String> extends $Base<Name> {
  // @ts-ignore
  private $$type!: T
  // @ts-ignore
  private $$name!: Name

  constructor(private selectorClasses: { [K in keyof T]: { new (): T[K] } }, $$name: Name) {
    super($$name)
  }

  $on<Type extends keyof T, Sel extends Selection<T[Type]>>(
    alternative: Type,
    selectorFn: (selector: T[Type]) => [...Sel]
  ): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
    const selection = selectorFn(new this.selectorClasses[alternative]())

    return new $UnionSelection(alternative as string, selection)
  }
}

// @ts-ignore
class $Interface<T, Name extends string> extends $Base<Name> {
  // @ts-ignore
  private $$type!: T
  // @ts-ignore
  private $$name!: Name

  constructor(private selectorClasses: { [K in keyof T]: { new (): T[K] } }, $$name: Name) {
    super($$name)
  }
  $on<Type extends keyof T, Sel extends Selection<T[Type]>>(
    alternative: Type,
    selectorFn: (selector: T[Type]) => [...Sel]
  ): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
    const selection = selectorFn(new this.selectorClasses[alternative]())

    return new $UnionSelection(alternative as string, selection)
  }
}

class $UnionSelection<T, Vars> {
  public kind: 'union' = 'union'
  // @ts-ignore
  private vars!: Vars
  constructor(public alternativeName: string, public alternativeSelection: Selection<T>) {}
}

type Selection<_any> = ReadonlyArray<$Field<any, any, any> | $UnionSelection<any, any>>

type NeverNever<T> = [T] extends [never] ? {} : T

type Simplify<T> = { [K in keyof T]: T[K] } & {}

type LeafType<T> = T extends CustomScalar<infer S> ? S : T

export type GetOutput<X extends Selection<any>> = Simplify<
  UnionToIntersection<
    {
      [I in keyof X]: X[I] extends $Field<infer Name, infer Type, any>
        ? { [K in Name]: LeafType<Type> }
        : never
    }[keyof X & number]
  > &
    NeverNever<
      {
        [I in keyof X]: X[I] extends $UnionSelection<infer Type, any> ? LeafType<Type> : never
      }[keyof X & number]
    >
>

type PossiblyOptionalVar<VName extends string, VType> = undefined extends VType
  ? { [key in VName]?: VType }
  : null extends VType
  ? { [key in VName]?: VType }
  : { [key in VName]: VType }

type ExtractInputVariables<Inputs> = Inputs extends Variable<infer VType, infer VName>
  ? PossiblyOptionalVar<VName, VType>
  : // Avoid generating an index signature for possibly undefined or null inputs.
  // The compiler incorrectly infers null or undefined, and we must force access the Inputs
  // type to convince the compiler its "never", while still retaining {} as the result
  // for null and undefined cases
  // Works around issue 79
  Inputs extends null | undefined
  ? { [K in keyof Inputs]: Inputs[K] }
  : Inputs extends $Atomic
  ? {}
  : Inputs extends any[] | readonly any[]
  ? UnionToIntersection<
      { [K in keyof Inputs]: ExtractInputVariables<Inputs[K]> }[keyof Inputs & number]
    >
  : UnionToIntersection<{ [K in keyof Inputs]: ExtractInputVariables<Inputs[K]> }[keyof Inputs]>

export type GetVariables<Sel extends Selection<any>, ExtraVars = {}> = UnionToIntersection<
  {
    [I in keyof Sel]: Sel[I] extends $Field<any, any, infer Vars>
      ? Vars
      : Sel[I] extends $UnionSelection<any, infer Vars>
      ? Vars
      : never
  }[keyof Sel & number]
> &
  ExtractInputVariables<ExtraVars>

type ArgVarType = {
  type: string
  isRequired: boolean
  array: {
    isRequired: boolean
  } | null
}

const arrRegex = /\[(.*?)\]/

/**
 * Converts graphql string type to `ArgVarType`
 * @param input
 * @returns
 */
function getArgVarType(input: string): ArgVarType {
  const array = input.includes('[')
    ? {
        isRequired: input.endsWith('!'),
      }
    : null

  const type = array ? arrRegex.exec(input)![1]! : input
  const isRequired = type.endsWith('!')

  return {
    array,
    isRequired: isRequired,
    type: type.replace('!', ''),
  }
}

function fieldToQuery(prefix: string, field: $Field<any, any, any>) {
  const variables = new Map<string, { variable: Variable<any, any>; type: ArgVarType }>()

  function stringifyArgs(
    args: any,
    argTypes: { [key: string]: string },
    argVarType?: ArgVarType
  ): string {
    switch (typeof args) {
      case 'string':
        const cleanType = argVarType!.type
        if ($Enums.has(cleanType!)) return args
        else return JSON.stringify(args)
      case 'number':
      case 'boolean':
        return JSON.stringify(args)
      default:
        if (args == null) return 'null'
        if (VariableName in (args as any)) {
          if (!argVarType)
            throw new globalThis.Error('Cannot use variabe as sole unnamed field argument')
          const variable = args as Variable<any, any>
          const argVarName = variable[VariableName]
          variables.set(argVarName, { type: argVarType, variable: variable })
          return '$' + argVarName
        }
        if (Array.isArray(args))
          return '[' + args.map(arg => stringifyArgs(arg, argTypes, argVarType)).join(',') + ']'
        const wrapped = (content: string) => (argVarType ? '{' + content + '}' : content)
        return wrapped(
          Array.from(Object.entries(args))
            .map(([key, val]) => {
              let argTypeForKey = argTypes[key]
              if (!argTypeForKey) {
                throw new globalThis.Error(`Argument type for ${key} not found`)
              }
              const cleanType = argTypeForKey.replace('[', '').replace(']', '').replace(/!/g, '')
              return (
                key +
                ':' +
                stringifyArgs(val, $InputTypes[cleanType]!, getArgVarType(argTypeForKey))
              )
            })
            .join(',')
        )
    }
  }

  function extractTextAndVars(field: $Field<any, any, any> | $UnionSelection<any, any>) {
    if (field.kind === 'field') {
      let retVal = field.name
      if (field.alias) retVal = field.alias + ':' + retVal
      const args = field.options.args,
        argTypes = field.options.argTypes
      if (args && Object.keys(args).length > 0) {
        retVal += '(' + stringifyArgs(args, argTypes!) + ')'
      }
      let sel = field.options.selection
      if (sel) {
        retVal += '{'
        for (let subField of sel) {
          retVal += extractTextAndVars(subField)
        }
        retVal += '}'
      }
      return retVal + ' '
    } else if (field.kind === 'union') {
      let retVal = '... on ' + field.alternativeName + ' {'
      for (let subField of field.alternativeSelection) {
        retVal += extractTextAndVars(subField)
      }
      retVal += '}'

      return retVal + ' '
    } else {
      throw new globalThis.Error('Uknown field kind')
    }
  }

  const queryRaw = extractTextAndVars(field)!

  const queryBody = queryRaw.substring(queryRaw.indexOf('{'))

  const varList = Array.from(variables.entries())
  let ret = prefix
  if (varList.length) {
    ret +=
      '(' +
      varList
        .map(([name, { type: kind, variable }]) => {
          let type = kind.array ? '[' : ''
          type += kind.type
          if (kind.isRequired) type += '!'
          if (kind.array) type += kind.array.isRequired ? ']!' : ']'

          if (!type.endsWith('!') && (variable as any).isRequired === true) {
            type += '!'
          }

          return '$' + name + ':' + type
        })
        .join(',') +
      ')'
  }
  ret += queryBody

  return ret
}

export type OutputTypeOf<T> = T extends $Interface<infer Subtypes, any>
  ? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
  : T extends $Union<infer Subtypes, any>
  ? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
  : T extends $Base<any>
  ? { [K in keyof T]?: OutputTypeOf<T[K]> }
  : [T] extends [$Field<any, infer FieldType, any>]
  ? FieldType
  : [T] extends [(selFn: (arg: infer Inner) => any) => any]
  ? OutputTypeOf<Inner>
  : [T] extends [(args: any, selFn: (arg: infer Inner) => any) => any]
  ? OutputTypeOf<Inner>
  : never

export type QueryOutputType<T extends TypedDocumentNode<any>> = T extends TypedDocumentNode<
  infer Out
>
  ? Out
  : never

export type QueryInputType<T extends TypedDocumentNode<any>> = T extends TypedDocumentNode<
  any,
  infer In
>
  ? In
  : never

export function fragment<T, Sel extends Selection<T>>(
  GQLType: { new (): T },
  selectFn: (selector: T) => [...Sel]
) {
  return selectFn(new GQLType())
}

type LastOf<T> = UnionToIntersection<T extends any ? () => T : never> extends () => infer R
  ? R
  : never

// TS4.0+
type Push<T extends any[], V> = [...T, V]

// TS4.1+
type TuplifyUnion<T, L = LastOf<T>, N = [T] extends [never] ? true : false> = true extends N
  ? []
  : Push<TuplifyUnion<Exclude<T, L>>, L>

type AllFieldProperties<I> = {
  [K in keyof I]: I[K] extends $Field<infer Name, infer Type, any> ? $Field<Name, Type, any> : never
}

type ValueOf<T> = T[keyof T]

export type AllFields<T> = TuplifyUnion<ValueOf<AllFieldProperties<T>>>

export function all<I extends $Base<any>>(instance: I) {
  const prototype = Object.getPrototypeOf(instance)
  const allFields = Object.getOwnPropertyNames(prototype)
    .map(k => prototype[k])
    .filter(o => o?.kind === 'field')
    .map(o => o?.name) as (keyof typeof instance)[]
  return allFields.map(fieldName => instance?.[fieldName]) as any as AllFields<I>
}

// We use a dummy conditional type that involves GenericType to defer the compiler's inference of
// any possible variables nested in this type. This addresses a problem where variables are
// inferred with type unknown
type ExactArgNames<GenericType, Constraint> = GenericType extends never
  ? never
  : [Constraint] extends [$Atomic | CustomScalar<any>]
  ? GenericType
  : Constraint extends ReadonlyArray<infer InnerConstraint>
  ? GenericType extends ReadonlyArray<infer Inner>
    ? ReadonlyArray<ExactArgNames<Inner, InnerConstraint>>
    : GenericType
  : GenericType & {
      [Key in keyof GenericType]: Key extends keyof Constraint
        ? ExactArgNames<GenericType[Key], Constraint[Key]>
        : never
    }

type $Atomic = AppMetricEntityType | AppMetricEventType | BugReportClosureReason | BugReportModerationStatus | BugReportStatus | CollectionStatus | CommentModerationStatus | CommentThreadModerationStatus | CsamDeletionRequestStatus | DonationReport | ExternalVideoPlatform | FilterComparisonOperator | FilterComparisonOperatorEqualsMatches | FilterComparisonOperatorEqualsWildcard | FilterComparisonOperatorExists | FilterComparisonOperatorNumeric | FilterLogicalOperator | FormalOrInformalWarning | GameArtworkSchema | ImageTypes | MediaStatus | ModAffiliation | ModAnalyticsByMonthSortBy | ModAnalyticsForMonthSortBy | ModFileCategory | ModSource | Moderatable | ModerationFixStatus | ModerationRestrictions | ModerationWarningCategoryEnum | ModerationWarningRestrictionFeatureEnum | NewsCategoryEnum | PreferencesCommentsEnum | PreferencesDefaultMediaTabEnum | PreferencesDefaultModsTabEnum | PreferencesDefaultSearchViewEnum | PreferencesDefaultSortEnum | PreferencesDlLocationEnum | PreferencesDownloadMethodEnum | PreferencesImageShowcaseEnum | PreferencesReminderEnum | PreferencesResultsEnum | PreferencesSearchTypeEnum | PreferencesTimeRangeEnum | Ratable | RatingOptions | ReorderLocation | SortDirection | ThumbnailSize | UpdatePolicy | VirusScanStatus | number | string | boolean | null | undefined

let $Enums = new Set<string>(["AppMetricEntityType","AppMetricEventType","BugReportClosureReason","BugReportModerationStatus","BugReportStatus","CollectionStatus","CommentModerationStatus","CommentThreadModerationStatus","CsamDeletionRequestStatus","DonationReport","ExternalVideoPlatform","FilterComparisonOperator","FilterComparisonOperatorEqualsMatches","FilterComparisonOperatorEqualsWildcard","FilterComparisonOperatorExists","FilterComparisonOperatorNumeric","FilterLogicalOperator","FormalOrInformalWarning","GameArtworkSchema","ImageTypes","MediaStatus","ModAffiliation","ModAnalyticsByMonthSortBy","ModAnalyticsForMonthSortBy","ModFileCategory","ModSource","Moderatable","ModerationFixStatus","ModerationRestrictions","ModerationWarningCategoryEnum","ModerationWarningRestrictionFeatureEnum","NewsCategoryEnum","PreferencesCommentsEnum","PreferencesDefaultMediaTabEnum","PreferencesDefaultModsTabEnum","PreferencesDefaultSearchViewEnum","PreferencesDefaultSortEnum","PreferencesDlLocationEnum","PreferencesDownloadMethodEnum","PreferencesImageShowcaseEnum","PreferencesReminderEnum","PreferencesResultsEnum","PreferencesSearchTypeEnum","PreferencesTimeRangeEnum","Ratable","RatingOptions","ReorderLocation","SortDirection","ThumbnailSize","UpdatePolicy","VirusScanStatus"])



/**
 * Autogenerated return type of AbstainFromModEndorsementMutation.
 */
export class AbstainFromModEndorsementMutationPayload extends $Base<"AbstainFromModEndorsementMutationPayload"> {
  constructor() {
    super("AbstainFromModEndorsementMutationPayload")
  }

  
      
/**
 * Endorsement entry.
 */
      endorsement<Sel extends Selection<ModEndorsement>>(selectorFn: (s: ModEndorsement) => [...Sel]):$Field<"endorsement", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModEndorsement)
      };
      return this.$_select("endorsement", options as any) as any
    }
  

      
/**
 * Returns true when abstaining was successful.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of AcceptModerationFixMutation.
 */
export class AcceptModerationFixMutationPayload extends $Base<"AcceptModerationFixMutationPayload"> {
  constructor() {
    super("AcceptModerationFixMutationPayload")
  }

  
      
/**
 * Return the moderation fix
 */
      moderationFix<Sel extends Selection<ModerationFix>>(selectorFn: (s: ModerationFix) => [...Sel]):$Field<"moderationFix", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationFix)
      };
      return this.$_select("moderationFix", options as any) as any
    }
  

      
/**
 * Returns true if the fix was accepted successfully
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of AddBadgeToCollectionMutation.
 */
export class AddBadgeToCollectionMutationPayload extends $Base<"AddBadgeToCollectionMutationPayload"> {
  constructor() {
    super("AddBadgeToCollectionMutationPayload")
  }

  
      
/**
 * True if badge was added to the collection
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of AddFavouriteGameMutation.
 */
export class AddFavouriteGameMutationPayload extends $Base<"AddFavouriteGameMutationPayload"> {
  constructor() {
    super("AddFavouriteGameMutationPayload")
  }

  
      
/**
 * True if the favourite was successfully created
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of AddHeaderImageToCollectionMutation.
 */
export class AddHeaderImageToCollectionMutationPayload extends $Base<"AddHeaderImageToCollectionMutationPayload"> {
  constructor() {
    super("AddHeaderImageToCollectionMutationPayload")
  }

  
      
/**
 * Header image that was added to the collection
 */
      image<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"image", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("image", options as any) as any
    }
  
}


/**
 * Autogenerated return type of AddImageToCollectionMutation.
 */
export class AddImageToCollectionMutationPayload extends $Base<"AddImageToCollectionMutationPayload"> {
  constructor() {
    super("AddImageToCollectionMutationPayload")
  }

  
      
/**
 * Image that was added to the collection
 */
      image<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"image", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("image", options as any) as any
    }
  
}


/**
 * Autogenerated return type of AddTagToCollectionMutation.
 */
export class AddTagToCollectionMutationPayload extends $Base<"AddTagToCollectionMutationPayload"> {
  constructor() {
    super("AddTagToCollectionMutationPayload")
  }

  
      
/**
 * True if all tags were added to the collection
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of AddTileImageToCollectionMutation.
 */
export class AddTileImageToCollectionMutationPayload extends $Base<"AddTileImageToCollectionMutationPayload"> {
  constructor() {
    super("AddTileImageToCollectionMutationPayload")
  }

  
      
/**
 * Tile image that was added to the collection
 */
      image<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"image", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("image", options as any) as any
    }
  
}


/**
 * Autogenerated return type of AddVideoToCollectionMutation.
 */
export class AddVideoToCollectionMutationPayload extends $Base<"AddVideoToCollectionMutationPayload"> {
  constructor() {
    super("AddVideoToCollectionMutationPayload")
  }

  
      
/**
 * Video that was added to the collection
 */
      video<Sel extends Selection<CollectionVideo>>(selectorFn: (s: CollectionVideo) => [...Sel]):$Field<"video", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionVideo)
      };
      return this.$_select("video", options as any) as any
    }
  
}


/**
 * An age verification ID and created at date pair.
 */
export class AgeVerificationId extends $Base<"AgeVerificationId"> {
  constructor() {
    super("AgeVerificationId")
  }

  
      
/**
 * The date the external verification ID was created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * An external age verification ID.
 */
      get externalVerificationId(): $Field<"externalVerificationId", string>  {
       return this.$_select("externalVerificationId") as any
      }
}


/**
 * An age verification log entry for a user.
 */
export class AgeVerificationInfo extends $Base<"AgeVerificationInfo"> {
  constructor() {
    super("AgeVerificationInfo")
  }

  
      
/**
 * An array of external age verification. Newest first.
 */
      externalVerificationIds<Sel extends Selection<AgeVerificationId>>(selectorFn: (s: AgeVerificationId) => [...Sel]):$Field<"externalVerificationIds", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new AgeVerificationId)
      };
      return this.$_select("externalVerificationIds", options as any) as any
    }
  

      
/**
 * Indicates if the user has successfully verified their age.
 */
      get verified(): $Field<"verified", boolean>  {
       return this.$_select("verified") as any
      }
}


/**
 * Autogenerated return type of AmendModerationMutation.
 */
export class AmendModerationMutationPayload extends $Base<"AmendModerationMutationPayload"> {
  constructor() {
    super("AmendModerationMutationPayload")
  }

  
      
/**
 * Return Types::Objects::Moderation::ModerationType
 */
      moderation<Sel extends Selection<Moderation>>(selectorFn: (s: Moderation) => [...Sel]):$Field<"moderation", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Moderation)
      };
      return this.$_select("moderation", options as any) as any
    }
  

      
/**
 * Boolean determining success or failure of the request.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A modding application (or "integration") accessed with an API key
 */
export class ApiApplication extends $Base<"ApiApplication"> {
  constructor() {
    super("ApiApplication")
  }

  
      
/**
 * If true, this application is active
 */
      get active(): $Field<"active", boolean>  {
       return this.$_select("active") as any
      }

      
/**
 * Application ID
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Application image URL
 */
      get image(): $Field<"image", string>  {
       return this.$_select("image") as any
      }

      
/**
 * The API key for the logged in user, if one exists
 */
      get key(): $Field<"key", string | null | undefined>  {
       return this.$_select("key") as any
      }

      
/**
 * Application name
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Machine-readable application name
 */
      get slug(): $Field<"slug", string>  {
       return this.$_select("slug") as any
      }

      
/**
 * Application summary
 */
      get summary(): $Field<"summary", string>  {
       return this.$_select("summary") as any
      }
}


/**
 * An API key for a modding application (or "integration")
 */
export class ApiKey extends $Base<"ApiKey"> {
  constructor() {
    super("ApiKey")
  }

  
      
/**
 * The application which this key is for
 */
      get applicationId(): $Field<"applicationId", string | null | undefined>  {
       return this.$_select("applicationId") as any
      }

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The API key itself
 */
      get key(): $Field<"key", string>  {
       return this.$_select("key") as any
      }

      
/**
 * The user whose key this is
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * Application metric event
 */
export class AppMetric extends $Base<"AppMetric"> {
  constructor() {
    super("AppMetric")
  }

  
      
/**
 * Client identifier
 */
      get clientString(): $Field<"clientString", string | null | undefined>  {
       return this.$_select("clientString") as any
      }

      
/**
 * When the metric was recorded
 */
      get createdAt(): $Field<"createdAt", ISO8601DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Unique identifier for the entity, e.g., collection ID
 */
      get entityId(): $Field<"entityId", string>  {
       return this.$_select("entityId") as any
      }

      
/**
 * Type of entity associated with the event, e.g., "collection"
 */
      get entityType(): $Field<"entityType", string>  {
       return this.$_select("entityType") as any
      }

      
/**
 * Type of event that was tracked
 */
      get eventType(): $Field<"eventType", AppMetricEventType>  {
       return this.$_select("eventType") as any
      }

      
/**
 * Unique identifier for the metric event
 */
      get id(): $Field<"id", BigInt>  {
       return this.$_select("id") as any
      }

      
/**
 * Additional metadata as JSON object
 */
      get metadata(): $Field<"metadata", JSON | null | undefined>  {
       return this.$_select("metadata") as any
      }

      
/**
 * ID of the user who triggered the event
 */
      get userId(): $Field<"userId", BigInt | null | undefined>  {
       return this.$_select("userId") as any
      }
}

  
/**
 * Application metric entity types
 */
export enum AppMetricEntityType {
  
/**
 * Collection
 */
  collection = "collection"
}
  

  
/**
 * Application metric event types
 */
export enum AppMetricEventType {
  
/**
 * Collection installation completed
 */
  collection_completed = "collection_completed",

/**
 * Collection installation started
 */
  collection_started = "collection_started"
}
  


/**
 * Artwork schema using one tile image, additionally blurred for background use.
 */
export class ArtworkSchemaV1 extends $Base<"ArtworkSchemaV1"> {
  constructor() {
    super("ArtworkSchemaV1")
  }

  
      
/**
 * URI template for primary game image.
 */
      get tile(): $Field<"tile", string>  {
       return this.$_select("tile") as any
      }

      
/**
 * URI template for blurred image e.g. for background use.
 */
      get tileBlurred(): $Field<"tileBlurred", string>  {
       return this.$_select("tileBlurred") as any
      }
}


/**
 * Artwork schema introduced in May 2025, comprising tile, hero, and thumbnail images.
 */
export class ArtworkSchemaV2 extends $Base<"ArtworkSchemaV2"> {
  constructor() {
    super("ArtworkSchemaV2")
  }

  
      
/**
 * URI template for hero e.g. for backgrounds, minimum 1920x620.
 */
      get hero(): $Field<"hero", string>  {
       return this.$_select("hero") as any
      }

      
/**
 * URI template for thumbnail e.g. for icons, minimum 80x80.
 */
      get thumbnail(): $Field<"thumbnail", string>  {
       return this.$_select("thumbnail") as any
      }

      
/**
 * URI template for tile e.g. for listings, minimum 400x267.
 */
      get tile(): $Field<"tile", string>  {
       return this.$_select("tile") as any
      }
}


/**
 * Something that can have files attached to it
 */
export class Attachable extends $Interface<{CollectionBugReport: CollectionBugReport,Comment: Comment}, "Attachable"> {
  constructor() {
    super({CollectionBugReport: CollectionBugReport,Comment: Comment}, "Attachable")
  }
  
      
/**
 * The attachment filename and IDs
 */
      attachments<Sel extends Selection<Attachment>>(selectorFn: (s: Attachment) => [...Sel]):$Field<"attachments", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Attachment)
      };
      return this.$_select("attachments", options as any) as any
    }
  
}


/**
 * Type that exposes the attachment urls
 */
export class Attachment extends $Base<"Attachment"> {
  constructor() {
    super("Attachment")
  }

  
      
/**
 * The attachment filename
 */
      get filename(): $Field<"filename", string>  {
       return this.$_select("filename") as any
      }

      
/**
 * A unique ID for this attachment. This is a signed ID that will change between requests. This
is expected behaviour and is to avoid tampering.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The attachment URL
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }
}


/**
 * Average rating for a single revision and total number of votes
 */
export class AverageRating extends $Base<"AverageRating"> {
  constructor() {
    super("AverageRating")
  }

  
      
/**
 * Average rating for this revision
 */
      get average(): $Field<"average", number>  {
       return this.$_select("average") as any
      }

      
/**
 * Number of positive votes
 */
      get positive(): $Field<"positive", number>  {
       return this.$_select("positive") as any
      }

      
/**
 * Total number of votes
 */
      get total(): $Field<"total", number>  {
       return this.$_select("total") as any
      }
}


/**
 * A badge
 */
export class Badge extends $Base<"Badge"> {
  constructor() {
    super("Badge")
  }

  
      
/**
 * Whether the badge is automated.
 */
      get automated(): $Field<"automated", boolean>  {
       return this.$_select("automated") as any
      }

      
/**
 * Description of the badge.
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * ID of the badge.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of the badge.
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }
}


export type BaseFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: string
}
    


export type BaseFilterValueEqualsMatches = {
  op?: FilterComparisonOperatorEqualsMatches | null | undefined,
value: string
}
    


export type BaseFilterValueEqualsWildcard = {
  op?: FilterComparisonOperatorEqualsWildcard | null | undefined,
value: string
}
    


export type BaseFilterValueNumeric = {
  op?: FilterComparisonOperatorNumeric | null | undefined,
value: string
}
    


export type BaseSortValue = {
  direction: SortDirection
}
    


/**
 * Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string.
 */
export type BigInt = string



/**
 * Autogenerated return type of BlockModsFromEarningDpMutation.
 */
export class BlockModsFromEarningDpMutationPayload extends $Base<"BlockModsFromEarningDpMutationPayload"> {
  constructor() {
    super("BlockModsFromEarningDpMutationPayload")
  }

  
      
/**
 * True if the mods were successfully blocked
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of BlockTagMutation.
 */
export class BlockTagMutationPayload extends $Base<"BlockTagMutationPayload"> {
  constructor() {
    super("BlockTagMutationPayload")
  }

  
      
/**
 * If true, the tag is blocked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of BlockUserMutation.
 */
export class BlockUserMutationPayload extends $Base<"BlockUserMutationPayload"> {
  constructor() {
    super("BlockUserMutationPayload")
  }

  
      
/**
 * If true, the user is blocked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A mod blocked from earning donation points
 */
export class BlockedMod extends $Base<"BlockedMod"> {
  constructor() {
    super("BlockedMod")
  }

  
      
/**
 * The database ID for this blocked_mod.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * True if the mod is blocked from earning donation points
 */
      get isBlocked(): $Field<"isBlocked", boolean>  {
       return this.$_select("isBlocked") as any
      }
}


/**
 * A page of data
 */
export class BlockedModsPage extends $Base<"BlockedModsPage"> {
  constructor() {
    super("BlockedModsPage")
  }

  
      
/**
 * A list of entries
 */
      nodes<Sel extends Selection<BlockedMod>>(selectorFn: (s: BlockedMod) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new BlockedMod)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information about the page
 */
      pageInfo<Sel extends Selection<BlockedModsPageInfo>>(selectorFn: (s: BlockedModsPageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new BlockedModsPageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  
}


/**
 * Information about a page
 */
export class BlockedModsPageInfo extends $Base<"BlockedModsPageInfo"> {
  constructor() {
    super("BlockedModsPageInfo")
  }

  
      
/**
 * The total number of entries
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A boolean value E.g. true or false
 */
export type BooleanFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: boolean
}
    

  
/**
 * Acceptable bug report closure reasons
 */
export enum BugReportClosureReason {
  
/**
 * None
 */
  none = "none",

/**
 * Resolved
 */
  resolved = "resolved",

/**
 * Not a bug
 */
  not_a_bug = "not_a_bug",

/**
 * Wont fix
 */
  wont_fix = "wont_fix"
}
  

  
/**
 * Moderation Status of a Bug Report
 */
export enum BugReportModerationStatus {
  
/**
 * None
 */
  none = "none",

/**
 * Hidden
 */
  hidden = "hidden"
}
  

  
/**
 * Acceptable bug report statuses
 */
export enum BugReportStatus {
  
/**
 * Open
 */
  open = "open",

/**
 * Closed
 */
  closed = "closed"
}
  


/**
 * A category into which related entities may fall
 */
export class Category extends $Base<"Category"> {
  constructor() {
    super("Category")
  }

  
      
/**
 * Whether the category has been approved
 */
      get approved(): $Field<"approved", boolean>  {
       return this.$_select("approved") as any
      }

      
/**
 * The id of the user who approved the category
 */
      get approvedBy(): $Field<"approvedBy", number | null | undefined>  {
       return this.$_select("approvedBy") as any
      }

      
/**
 * A list of games for which this category is used
 */
      categoryGames<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"categoryGames", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("categoryGames", options as any) as any
    }
  

      
/**
 * Time of when this category was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * A brief description of the category's purpose
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * Time of when this category was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The database ID for this category.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * The name of the category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * The id of the parent category
 */
      get parentId(): $Field<"parentId", number>  {
       return this.$_select("parentId") as any
      }

      
/**
 * The id of the user who suggested the category
 */
      get suggestedBy(): $Field<"suggestedBy", number>  {
       return this.$_select("suggestedBy") as any
      }

      
/**
 * Time of when this category was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * Autogenerated return type of ChangeCollectionOwner.
 */
export class ChangeCollectionOwnerPayload extends $Base<"ChangeCollectionOwnerPayload"> {
  constructor() {
    super("ChangeCollectionOwnerPayload")
  }

  
      
/**
 * Updated collection
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of ClearCollectionBugReportModerationStatusMutation.
 */
export class ClearCollectionBugReportModerationStatusMutationPayload extends $Base<"ClearCollectionBugReportModerationStatusMutationPayload"> {
  constructor() {
    super("ClearCollectionBugReportModerationStatusMutationPayload")
  }

  
      
/**
 * Collection bug report whose status was cleared
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * Autogenerated return type of ClearCommentModerationStatusMutation.
 */
export class ClearCommentModerationStatusMutationPayload extends $Base<"ClearCommentModerationStatusMutationPayload"> {
  constructor() {
    super("ClearCommentModerationStatusMutationPayload")
  }

  
      
/**
 * The comment that had its moderation status cleared.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of ClearThreadModerationStatusMutation.
 */
export class ClearThreadModerationStatusMutationPayload extends $Base<"ClearThreadModerationStatusMutationPayload"> {
  constructor() {
    super("ClearThreadModerationStatusMutationPayload")
  }

  
      
/**
 * The comment thread that had its moderation status cleared.
 */
      commentThread<Sel extends Selection<CommentThread>>(selectorFn: (s: CommentThread) => [...Sel]):$Field<"commentThread", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentThread)
      };
      return this.$_select("commentThread", options as any) as any
    }
  
}


/**
 * Autogenerated return type of CloseCollectionBugReportMutation.
 */
export class CloseCollectionBugReportMutationPayload extends $Base<"CloseCollectionBugReportMutationPayload"> {
  constructor() {
    super("CloseCollectionBugReportMutationPayload")
  }

  
      
/**
 * Collection bug report which was closed
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * A curated collection of mods
 */
export class Collection extends $Base<"Collection"> {
  constructor() {
    super("Collection")
  }

  
      
/**
 * Indicates whether the collection contains adult content
 */
      get adultContent(): $Field<"adultContent", boolean | null | undefined>  {
       return this.$_select("adultContent") as any
      }

      
/**
 * Whether to allow non-curator users to upload media
 */
      get allowUserMedia(): $Field<"allowUserMedia", boolean | null | undefined>  {
       return this.$_select("allowUserMedia") as any
      }

      
/**
 * Badges on the collection and latest published revision
 */
      badges<Sel extends Selection<Badge>>(selectorFn: (s: Badge) => [...Sel]):$Field<"badges", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Badge)
      };
      return this.$_select("badges", options as any) as any
    }
  

      
/**
 * Fetch a bug report for this collection by its id
 */
      bugReport<Args extends VariabledInput<{
        bugReportId: string,
      }>,Sel extends Selection<CollectionBugReport>>(args: ExactArgNames<Args, {
        bugReportId: string,
      }>, selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"bugReport", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!"
            },
        args,

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("bugReport", options as any) as any
    }
  

      
/**
 * A list of bug reports raised for the collection
 */
      bugReports<Args extends VariabledInput<{
        status: BugReportStatus
sortBy?: string | null | undefined
sortDirection?: string | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<CollectionBugReportConnection>>(args: ExactArgNames<Args, {
        status: BugReportStatus
sortBy?: string | null | undefined
sortDirection?: string | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: CollectionBugReportConnection) => [...Sel]):$Field<"bugReports", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              status: "BugReportStatus!",
sortBy: "String",
sortDirection: "String",
after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new CollectionBugReportConnection)
      };
      return this.$_select("bugReports", options as any) as any
    }
  

      
/**
 * A category into which related entities may fall
 */
      category<Sel extends Selection<Category>>(selectorFn: (s: Category) => [...Sel]):$Field<"category", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Category)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * A list of changelogs created for the revisions of this collection
 */
      collectionChangelogs<Sel extends Selection<CollectionChangelog>>(selectorFn: (s: CollectionChangelog) => [...Sel]):$Field<"collectionChangelogs", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionChangelog)
      };
      return this.$_select("collectionChangelogs", options as any) as any
    }
  

      
/**
 * Available collection statuses
 */
      get collectionStatus(): $Field<"collectionStatus", CollectionStatus | null | undefined>  {
       return this.$_select("collectionStatus") as any
      }

      
/**
 * A link to the forum thread containing comments
 */
      get commentLink(): $Field<"commentLink", string | null | undefined>  {
       return this.$_select("commentLink") as any
      }

      
/**
 * The comment thread for this collection.
 */
      commentThread<Sel extends Selection<CommentThread>>(selectorFn: (s: CommentThread) => [...Sel]):$Field<"commentThread", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentThread)
      };
      return this.$_select("commentThread", options as any) as any
    }
  

      
/**
 * Time of when this collection was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Latest published revision
 */
      currentRevision<Args extends VariabledInput<{
        revision?: number | null | undefined,
      }>,Sel extends Selection<CollectionRevision>>(args: ExactArgNames<Args, {
        revision?: number | null | undefined,
      }>, selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"currentRevision", GetOutput<Sel> , GetVariables<Sel, Args>>
currentRevision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"currentRevision", GetOutput<Sel> , GetVariables<Sel>>
currentRevision(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              revision: "Int"
            },
        args,

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("currentRevision", options as any) as any
    }
  

      
/**
 * A description of the collection in Markdown format
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * A reason why the collection was discarded
 */
      discardReason<Sel extends Selection<CollectionDiscardReason>>(selectorFn: (s: CollectionDiscardReason) => [...Sel]):$Field<"discardReason", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionDiscardReason)
      };
      return this.$_select("discardReason", options as any) as any
    }
  

      
/**
 * Time of when this collection was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * If there is a draft revision in this collection, this will return the revisionNumber
for that revision. If there are no draft revisions, this will simply be null
 */
      get draftRevisionNumber(): $Field<"draftRevisionNumber", number | null | undefined>  {
       return this.$_select("draftRevisionNumber") as any
      }

      
/**
 * Users who have permission to edit this collection.
 */
      editors<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"editors", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("editors", options as any) as any
    }
  

      
/**
 * The number of endorsements given to the collection
 */
      get endorsements(): $Field<"endorsements", number>  {
       return this.$_select("endorsements") as any
      }

      
/**
 * Time of when the first of this collection's revisions
was first published
 */
      get firstPublishedAt(): $Field<"firstPublishedAt", DateTime | null | undefined>  {
       return this.$_select("firstPublishedAt") as any
      }

      
/**
 * The forum topic created to hold comments for this collection
 */
      forumTopic<Sel extends Selection<ForumTopic>>(selectorFn: (s: ForumTopic) => [...Sel]):$Field<"forumTopic", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ForumTopic)
      };
      return this.$_select("forumTopic", options as any) as any
    }
  

      
/**
 * The game for which the collection was created
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * The id of the game for which the collection was created
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The image used as the background of the header on the collection's page
 */
      headerImage<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"headerImage", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("headerImage", options as any) as any
    }
  

      
/**
 * The database ID for this collection.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Time of when one of this collection's revisions
was last published
 */
      get lastPublishedAt(): $Field<"lastPublishedAt", DateTime | null | undefined>  {
       return this.$_select("lastPublishedAt") as any
      }

      
/**
 * The latest published revision for this collection. This will be
null for collections with no published revisions
 */
      latestPublishedRevision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"latestPublishedRevision", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("latestPublishedRevision", options as any) as any
    }
  

      
/**
 * Rating of the latest published revision
 */
      get latestPublishedRevisionRating(): $Field<"latestPublishedRevisionRating", string | null | undefined>  {
       return this.$_select("latestPublishedRevisionRating") as any
      }

      
/**
 * Time of when this collection was first listed
 */
      get listedAt(): $Field<"listedAt", DateTime | null | undefined>  {
       return this.$_select("listedAt") as any
      }

      
/**
 * Whether uploaded media requires verification before being displayed
 */
      get manuallyVerifyMedia(): $Field<"manuallyVerifyMedia", boolean | null | undefined>  {
       return this.$_select("manuallyVerifyMedia") as any
      }

      
/**
 * A list of media uploaded to the collection, including images and videos
 */
      media<Sel extends Selection<CollectionMediaUnion>>(selectorFn: (s: CollectionMediaUnion) => [...Sel]):$Field<"media", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionMediaUnion)
      };
      return this.$_select("media", options as any) as any
    }
  

      
/**
 * Metadata information about a collection
 */
      metadata<Sel extends Selection<CollectionMetadata>>(selectorFn: (s: CollectionMetadata) => [...Sel]):$Field<"metadata", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionMetadata)
      };
      return this.$_select("metadata", options as any) as any
    }
  

      
/**
 * JWT token for submitting moderation reports
 */
      get moderationJwt(): $Field<"moderationJwt", string>  {
       return this.$_select("moderationJwt") as any
      }

      
/**
 * A list of moderation actions taken against this collection
 */
      moderations<Sel extends Selection<Moderation>>(selectorFn: (s: Moderation) => [...Sel]):$Field<"moderations", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Moderation)
      };
      return this.$_select("moderations", options as any) as any
    }
  

      
/**
 * The collection name
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * An average taken from all revision ratings
 */
      get overallRating(): $Field<"overallRating", string | null | undefined>  {
       return this.$_select("overallRating") as any
      }

      
/**
 * Total number of ratings given across all revisions
 */
      get overallRatingCount(): $Field<"overallRatingCount", number | null | undefined>  {
       return this.$_select("overallRatingCount") as any
      }

      
/**
 * The list of permissions granted to the requesting user against this collection.
 */
      permissions<Sel extends Selection<Permission>>(selectorFn: (s: Permission) => [...Sel]):$Field<"permissions", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Permission)
      };
      return this.$_select("permissions", options as any) as any
    }
  

      
/**
 * Returns "sanitized" collection revisions. Safe to use with discarded revisions.
 */
      publicRevisions<Sel extends Selection<PublicCollectionRevision>>(selectorFn: (s: PublicCollectionRevision) => [...Sel]):$Field<"publicRevisions", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PublicCollectionRevision)
      };
      return this.$_select("publicRevisions", options as any) as any
    }
  

      
/**
 * Time of when one of this collection's revisions
was last published
 */
      get publishedAt(): $Field<"publishedAt", DateTime | null | undefined>  {
       return this.$_select("publishedAt") as any
      }

      
/**
 * A 30 day average of all revision ratings
 */
      get recentRating(): $Field<"recentRating", string | null | undefined>  {
       return this.$_select("recentRating") as any
      }

      
/**
 * Total number of ratings given in the last 30 days
 */
      get recentRatingCount(): $Field<"recentRatingCount", number | null | undefined>  {
       return this.$_select("recentRatingCount") as any
      }

      
/**
 * A list of revisions for the collection
 */
      revisions<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"revisions", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("revisions", options as any) as any
    }
  

      
/**
 * A random string of characters identifying the collection. This is the identifier used in
a collection page url.
 */
      get slug(): $Field<"slug", string>  {
       return this.$_select("slug") as any
      }

      
/**
 * A brief summary of the collection
 */
      get summary(): $Field<"summary", string>  {
       return this.$_select("summary") as any
      }

      
/**
 * A list of tags attached to the collection, used to surface the collection in search results
 */
      tags<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"tags", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("tags", options as any) as any
    }
  

      
/**
 * The image used to identify the collection in list views
 */
      tileImage<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"tileImage", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("tileImage", options as any) as any
    }
  

      
/**
 * The total number of times this collection has been downloaded
 */
      get totalDownloads(): $Field<"totalDownloads", number>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * The total number of unique users who have downloaded this collection
 */
      get uniqueDownloads(): $Field<"uniqueDownloads", number>  {
       return this.$_select("uniqueDownloads") as any
      }

      
/**
 * Time of when this collection was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * The curating user
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * The id of the collection curator
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }

      
/**
 * Whether the viewer has ignored the content owner.
 */
      get viewerBlocked(): $Field<"viewerBlocked", boolean>  {
       return this.$_select("viewerBlocked") as any
      }

      
/**
 * Whether the viewer has ignored the content owner.
 */
      get viewerHasIgnored(): $Field<"viewerHasIgnored", boolean>  {
       return this.$_select("viewerHasIgnored") as any
      }

      
/**
 * Whether the viewer is blocked by the content owner.
 */
      get viewerIsBlocked(): $Field<"viewerIsBlocked", boolean | null | undefined>  {
       return this.$_select("viewerIsBlocked") as any
      }
}


/**
 * A collection bug report.
 */
export class CollectionBugReport extends $Base<"CollectionBugReport"> {
  constructor() {
    super("CollectionBugReport")
  }

  
      
/**
 * The attachment filename and IDs
 */
      attachments<Sel extends Selection<Attachment>>(selectorFn: (s: Attachment) => [...Sel]):$Field<"attachments", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Attachment)
      };
      return this.$_select("attachments", options as any) as any
    }
  

      
/**
 * Date that this report was changed to closed
 */
      get closedAt(): $Field<"closedAt", DateTime | null | undefined>  {
       return this.$_select("closedAt") as any
      }

      
/**
 * If closed, what was the reason for closing the report
 */
      get closureReason(): $Field<"closureReason", BugReportClosureReason | null | undefined>  {
       return this.$_select("closureReason") as any
      }

      
/**
 * A curated collection of mods
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * The collection revision number.
 */
      get collectionRevisionNumber(): $Field<"collectionRevisionNumber", number>  {
       return this.$_select("collectionRevisionNumber") as any
      }

      
/**
 * The comment thread for this collection bug report.
 */
      commentThread<Sel extends Selection<CommentThread>>(selectorFn: (s: CommentThread) => [...Sel]):$Field<"commentThread", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentThread)
      };
      return this.$_select("commentThread", options as any) as any
    }
  

      
/**
 * Date that this report was created
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * User-provided summary of the Bug Report
 */
      get description(): $Field<"description", string | null | undefined>  {
       return this.$_select("description") as any
      }

      
/**
 * User that hid this Bug Report from public view
 */
      hiddenBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"hiddenBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("hiddenBy", options as any) as any
    }
  

      
/**
 * If hidden, this will provide a reason. This is intended for moderators, admins and
collection curators
 */
      get hiddenInternalReason(): $Field<"hiddenInternalReason", string | null | undefined>  {
       return this.$_select("hiddenInternalReason") as any
      }

      
/**
 * If hidden, this will provide the reason
 */
      get hiddenReason(): $Field<"hiddenReason", string | null | undefined>  {
       return this.$_select("hiddenReason") as any
      }

      
/**
 * The database ID for this collection bug report.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * JWT token for submitting moderation reports
 */
      get moderationJwt(): $Field<"moderationJwt", string>  {
       return this.$_select("moderationJwt") as any
      }

      
/**
 * If under moderation, can be none or hidden
 */
      get moderationStatus(): $Field<"moderationStatus", BugReportModerationStatus>  {
       return this.$_select("moderationStatus") as any
      }

      
/**
 * Date that this report was changed to open
 */
      get openedAt(): $Field<"openedAt", DateTime | null | undefined>  {
       return this.$_select("openedAt") as any
      }

      
/**
 * Provides a list of all permissions for this report, using the context of the current user
 */
      permissions<Sel extends Selection<Permission>>(selectorFn: (s: Permission) => [...Sel]):$Field<"permissions", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Permission)
      };
      return this.$_select("permissions", options as any) as any
    }
  

      
/**
 * User that reported this Bug Report
 */
      reporter<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"reporter", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("reporter", options as any) as any
    }
  

      
/**
 * Status, can be Open or Closed
 */
      get status(): $Field<"status", BugReportStatus>  {
       return this.$_select("status") as any
      }

      
/**
 * Title of the bug report
 */
      get title(): $Field<"title", string>  {
       return this.$_select("title") as any
      }

      
/**
 * Date that this report was last updated
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Whether the viewer has ignored the content owner.
 */
      get viewerHasIgnored(): $Field<"viewerHasIgnored", boolean>  {
       return this.$_select("viewerHasIgnored") as any
      }
}


/**
 * The connection type for CollectionBugReport.
 */
export class CollectionBugReportConnection extends $Base<"CollectionBugReportConnection"> {
  constructor() {
    super("CollectionBugReportConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<CollectionBugReportEdge>>(selectorFn: (s: CollectionBugReportEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReportEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class CollectionBugReportEdge extends $Base<"CollectionBugReportEdge"> {
  constructor() {
    super("CollectionBugReportEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("node", options as any) as any
    }
  
}


/**
 * A changelog attached to a collection revision
 */
export class CollectionChangelog extends $Base<"CollectionChangelog"> {
  constructor() {
    super("CollectionChangelog")
  }

  
      
/**
 * The id of the collection revision for which this changelog was created
 */
      get collectionRevisionId(): $Field<"collectionRevisionId", number>  {
       return this.$_select("collectionRevisionId") as any
      }

      
/**
 * Time of when this collection changelog was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The content of the collection changelog, in Markdown format
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * The database ID for this collection changelog.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * The revision number of the collection revision for which this changelog was created
 */
      get revisionNumber(): $Field<"revisionNumber", number>  {
       return this.$_select("revisionNumber") as any
      }

      
/**
 * Time of when this collection changelog was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * A reason for which a revision has been retracted.
 */
export class CollectionDiscardReason extends $Base<"CollectionDiscardReason"> {
  constructor() {
    super("CollectionDiscardReason")
  }

  
      
/**
 * The id of the collection which was discarded
 */
      get collectionId(): $Field<"collectionId", number>  {
       return this.$_select("collectionId") as any
      }

      
/**
 * Time of when this collection discard reason was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The database ID for this collection discard reason.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * The reason why the collection was discarded
 */
      get reason(): $Field<"reason", string>  {
       return this.$_select("reason") as any
      }

      
/**
 * Time of when this collection discard reason was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


export type CollectionGeneralSearchFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: string
}
    


/**
 * Images related to a collection
 */
export class CollectionImage extends $Base<"CollectionImage"> {
  constructor() {
    super("CollectionImage")
  }

  
      
/**
 * The alt text describing the image for screen readers
 */
      get altText(): $Field<"altText", string | null | undefined>  {
       return this.$_select("altText") as any
      }

      
/**
 * The collection for which the image was uploaded
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * Time of when this collection image was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this collection image was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The global ID for this entity.
 */
      get globalId(): $Field<"globalId", string | null | undefined>  {
       return this.$_select("globalId") as any
      }

      
/**
 * The database ID for this collection image.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Determines where the image is displayed
 */
      get imageType(): $Field<"imageType", ImageTypes>  {
       return this.$_select("imageType") as any
      }

      
/**
 * The order of this entity in the list.
 */
      get order(): $Field<"order", string>  {
       return this.$_select("order") as any
      }

      
/**
 * The collection revision for which the image was uploaded
 */
      revision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"revision", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("revision", options as any) as any
    }
  

      
/**
 * Can be used to select a scaled down/compressed version of the image
 */
      thumbnailUrl<Args extends VariabledInput<{
        size: ThumbnailSize,
      }>>(args: ExactArgNames<Args, {
        size: ThumbnailSize,
      }>):$Field<"thumbnailUrl", string , GetVariables<[], Args>> {
      
      const options = {
        argTypes: {
              size: "ThumbnailSize!"
            },
        args,

        
      };
      return this.$_select("thumbnailUrl", options as any) as any
    }
  

      
/**
 * The image title
 */
      get title(): $Field<"title", string | null | undefined>  {
       return this.$_select("title") as any
      }

      
/**
 * Time of when this collection image was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * The image resource url
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }

      
/**
 * The user who uploaded the image
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  
}


/**
 * The JSON manifest that defines a collection
 */
export type CollectionManifest = {
  info: CollectionManifestInfo,
mods: Readonly<Array<CollectionManifestMod>>
}
    


/**
 * The info section of the JSON manifest
 */
export type CollectionManifestInfo = {
  author: string,
authorUrl?: string | null | undefined,
description?: string | null | undefined,
domainName: string,
gameVersions?: Readonly<Array<string>> | null | undefined,
name: string,
summary?: string | null | undefined
}
    


/**
 * Defines a mod to be used in a collection as part of the manifest
 */
export type CollectionManifestMod = {
  author?: string | null | undefined,
domainName: string,
name: string,
optional: boolean,
source: CollectionManifestModSource,
version: string
}
    


/**
 * Source information for a mod (nexus or other) as part of the manifest
 */
export type CollectionManifestModSource = {
  adultContent?: boolean | null | undefined,
fileExpression?: string | null | undefined,
fileId?: number | null | undefined,
fileSize?: number | null | undefined,
logicalFilename?: string | null | undefined,
md5?: string | null | undefined,
modId?: number | null | undefined,
type: ModSource,
updatePolicy?: UpdatePolicy | null | undefined,
url?: string | null | undefined
}
    


/**
 * Collection Media
 */
export class CollectionMediaUnion extends $Union<{CollectionImage: CollectionImage,CollectionVideo: CollectionVideo,GloballyIdentifiable: GloballyIdentifiable,Reorderable: Reorderable}, "CollectionMediaUnion"> {
  constructor() {
    super({CollectionImage: CollectionImage,CollectionVideo: CollectionVideo,GloballyIdentifiable: GloballyIdentifiable,Reorderable: Reorderable}, "CollectionMediaUnion")
  }
}


/**
 * Metadata information about a collection
 */
export class CollectionMetadata extends $Base<"CollectionMetadata"> {
  constructor() {
    super("CollectionMetadata")
  }

  
      
/**
 * A timestamp indicating the first time the user downloaded this collection
 */
      get downloadedAt(): $Field<"downloadedAt", DateTime | null | undefined>  {
       return this.$_select("downloadedAt") as any
      }

      
/**
 * A positive value indicates an endorsement by the user, while a negative value
indicates abstention (will be null if the user has not endorsed the collection)
 */
      get endorsementValue(): $Field<"endorsementValue", number | null | undefined>  {
       return this.$_select("endorsementValue") as any
      }

      
/**
 * The latest revision number downloaded by the user for this collection
 */
      get latestDownloadedRevisionNumber(): $Field<"latestDownloadedRevisionNumber", number | null | undefined>  {
       return this.$_select("latestDownloadedRevisionNumber") as any
      }
}


export class CollectionPage extends $Base<"CollectionPage"> {
  constructor() {
    super("CollectionPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * The data payload used to create a collection revision
 */
export type CollectionPayload = {
  adultContent: boolean,
collectionManifest: CollectionManifest,
collectionSchemaId: number
}
    


/**
 * An immutable revision of a collection
 */
export class CollectionRevision extends $Base<"CollectionRevision"> {
  constructor() {
    super("CollectionRevision")
  }

  
      
/**
 * If true, this revision could contain adult content and needs to be treated accordingly
 */
      get adultContent(): $Field<"adultContent", boolean>  {
       return this.$_select("adultContent") as any
      }

      
/**
 * The size of bundled assets within the revision in bytes
 */
      get assetsSizeBytes(): $Field<"assetsSizeBytes", BigInt>  {
       return this.$_select("assetsSizeBytes") as any
      }

      
/**
 * Badges associated with this collection revision
 */
      badges<Sel extends Selection<Badge>>(selectorFn: (s: Badge) => [...Sel]):$Field<"badges", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Badge)
      };
      return this.$_select("badges", options as any) as any
    }
  

      
/**
 * Gets the collection that this revision belongs to. This will ignore adult_content flags.
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * A changelog attached to a collection revision
 */
      collectionChangelog<Sel extends Selection<CollectionChangelog>>(selectorFn: (s: CollectionChangelog) => [...Sel]):$Field<"collectionChangelog", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionChangelog)
      };
      return this.$_select("collectionChangelog", options as any) as any
    }
  

      
/**
 * The database ID for this collection.
 */
      get collectionId(): $Field<"collectionId", number>  {
       return this.$_select("collectionId") as any
      }

      
/**
 * A model of the expected structure for a collection manifest
 */
      collectionSchema<Sel extends Selection<CollectionSchema>>(selectorFn: (s: CollectionSchema) => [...Sel]):$Field<"collectionSchema", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionSchema)
      };
      return this.$_select("collectionSchema", options as any) as any
    }
  

      
/**
 * The database ID for this collection schema.
 */
      get collectionSchemaId(): $Field<"collectionSchemaId", number>  {
       return this.$_select("collectionSchemaId") as any
      }

      
/**
 * The link to generate a content preview for the revision
 */
      get contentPreviewLink(): $Field<"contentPreviewLink", string>  {
       return this.$_select("contentPreviewLink") as any
      }

      
/**
 * Time of when this revision was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this revision was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The download link for the revision
 */
      get downloadLink(): $Field<"downloadLink", string>  {
       return this.$_select("downloadLink") as any
      }

      
/**
 * Array of external resources referenced by this revision
 */
      externalResources<Sel extends Selection<ExternalResource>>(selectorFn: (s: ExternalResource) => [...Sel]):$Field<"externalResources", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ExternalResource)
      };
      return this.$_select("externalResources", options as any) as any
    }
  

      
/**
 * The total size of the revision in bytes
 */
      get fileSize(): $Field<"fileSize", BigInt>  {
       return this.$_select("fileSize") as any
      }

      
/**
 * A list of game versions for which the revision has been confirmed to work (usually the
game version for which the revision was created)
 */
      gameVersions<Sel extends Selection<GameVersion>>(selectorFn: (s: GameVersion) => [...Sel]):$Field<"gameVersions", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new GameVersion)
      };
      return this.$_select("gameVersions", options as any) as any
    }
  

      
/**
 * The database ID for this revision.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Additional information about the installation process of this revision
 */
      get installationInfo(): $Field<"installationInfo", string | null | undefined>  {
       return this.$_select("installationInfo") as any
      }

      
/**
 * Will be true if the revision is the latest published for the collection
 */
      get latest(): $Field<"latest", boolean>  {
       return this.$_select("latest") as any
      }

      
/**
 * Metadata information about a collection revision
 */
      metadata<Sel extends Selection<CollectionRevisionMetadata>>(selectorFn: (s: CollectionRevisionMetadata) => [...Sel]):$Field<"metadata", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevisionMetadata)
      };
      return this.$_select("metadata", options as any) as any
    }
  

      
/**
 * List of authors of the mods included in this revision ordered (DESC) by the number of
mods in the revision.
 */
      modAuthors<Args extends VariabledInput<{
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<UserConnection>>(args: ExactArgNames<Args, {
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: UserConnection) => [...Sel]):$Field<"modAuthors", GetOutput<Sel> , GetVariables<Sel, Args>>
modAuthors<Sel extends Selection<UserConnection>>(selectorFn: (s: UserConnection) => [...Sel]):$Field<"modAuthors", GetOutput<Sel> , GetVariables<Sel>>
modAuthors(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new UserConnection)
      };
      return this.$_select("modAuthors", options as any) as any
    }
  

      
/**
 * The number of mods and external resources in this collection
 */
      get modCount(): $Field<"modCount", number>  {
       return this.$_select("modCount") as any
      }

      
/**
 * A list of mod files included in the revision
 */
      modFiles<Sel extends Selection<CollectionRevisionMod>>(selectorFn: (s: CollectionRevisionMod) => [...Sel]):$Field<"modFiles", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevisionMod)
      };
      return this.$_select("modFiles", options as any) as any
    }
  

      
/**
 * An average taken from all ratings for this revision
 */
      get overallRating(): $Field<"overallRating", string | null | undefined>  {
       return this.$_select("overallRating") as any
      }

      
/**
 * A count of all ratings for this revision
 */
      get overallRatingCount(): $Field<"overallRatingCount", number | null | undefined>  {
       return this.$_select("overallRatingCount") as any
      }

      
/**
 * Average rating for a single revision and total number of votes
 */
      rating<Sel extends Selection<AverageRating>>(selectorFn: (s: AverageRating) => [...Sel]):$Field<"rating", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new AverageRating)
      };
      return this.$_select("rating", options as any) as any
    }
  

      
/**
 * A reason for which a revision has been retracted.
 */
      retractionReason<Sel extends Selection<RetractionReason>>(selectorFn: (s: RetractionReason) => [...Sel]):$Field<"retractionReason", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new RetractionReason)
      };
      return this.$_select("retractionReason", options as any) as any
    }
  

      
/**
 * The revision number
 */
      get revision(): $Field<"revision", number>  {
       return this.$_select("revision") as any
      }

      
/**
 * The revision number
 */
      get revisionNumber(): $Field<"revisionNumber", number>  {
       return this.$_select("revisionNumber") as any
      }

      
/**
 * The status of this revision. Possible values are 'draft', 'published' or 'retracted'
 */
      get revisionStatus(): $Field<"revisionStatus", string>  {
       return this.$_select("revisionStatus") as any
      }

      
/**
 * The status of this revision. Possible values are 'draft', 'published' or 'retracted'
 */
      get status(): $Field<"status", string>  {
       return this.$_select("status") as any
      }

      
/**
 * The total number of times the revision has been downloaded
 */
      get totalDownloads(): $Field<"totalDownloads", number>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * The total size of the revision in bytes
 */
      get totalSize(): $Field<"totalSize", BigInt>  {
       return this.$_select("totalSize") as any
      }

      
/**
 * The number of unique users who have download the revision
 */
      get uniqueDownloads(): $Field<"uniqueDownloads", number>  {
       return this.$_select("uniqueDownloads") as any
      }

      
/**
 * Time of when this revision was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * Metadata information about a collection revision
 */
export class CollectionRevisionMetadata extends $Base<"CollectionRevisionMetadata"> {
  constructor() {
    super("CollectionRevisionMetadata")
  }

  
      
/**
 * A timestamp indicating the first time the user downloaded this revision
 */
      get downloadedAt(): $Field<"downloadedAt", DateTime | null | undefined>  {
       return this.$_select("downloadedAt") as any
      }

      
/**
 * Indicates the rating given by the user to a revision
 */
      get ratingValue(): $Field<"ratingValue", RatingOptions | null | undefined>  {
       return this.$_select("ratingValue") as any
      }
}


/**
 * A mod file included in a collection
 */
export class CollectionRevisionMod extends $Base<"CollectionRevisionMod"> {
  constructor() {
    super("CollectionRevisionMod")
  }

  
      
/**
 * The id of the collection revision including the mod file
 */
      get collectionRevisionId(): $Field<"collectionRevisionId", number>  {
       return this.$_select("collectionRevisionId") as any
      }

      
/**
 * The mod file
 */
      file<Sel extends Selection<ModFile>>(selectorFn: (s: ModFile) => [...Sel]):$Field<"file", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModFile)
      };
      return this.$_select("file", options as any) as any
    }
  

      
/**
 * The mod file's id
 */
      get fileId(): $Field<"fileId", number>  {
       return this.$_select("fileId") as any
      }

      
/**
 * The game id for the mod file
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this collection revision mod.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Whether the mod file is required for the collection
 */
      get optional(): $Field<"optional", boolean>  {
       return this.$_select("optional") as any
      }

      
/**
 * Indicates to mod managers how they should handle automatic updates
 */
      get updatePolicy(): $Field<"updatePolicy", string>  {
       return this.$_select("updatePolicy") as any
      }

      
/**
 * The mod file version
 */
      get version(): $Field<"version", string>  {
       return this.$_select("version") as any
      }
}


/**
 * A model of the expected structure for a collection manifest
 */
export class CollectionSchema extends $Base<"CollectionSchema"> {
  constructor() {
    super("CollectionSchema")
  }

  
      
/**
 * Time of when this collection schema was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The database ID for this collection schema.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Time of when this collection schema was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Schema version for the collection manifest format
 */
      get version(): $Field<"version", string>  {
       return this.$_select("version") as any
      }
}

  
/**
 * Available collection statuses
 */
export enum CollectionStatus {
  
/**
 * Publicly visible
 */
  listed = "listed",

/**
 * Does not appear in lists
 */
  unlisted = "unlisted",

/**
 * Under moderation
 */
  under_moderation = "under_moderation",

/**
 * Discarded
 */
  discarded = "discarded"
}
  


/**
 * Videos related to a collection
 */
export class CollectionVideo extends $Base<"CollectionVideo"> {
  constructor() {
    super("CollectionVideo")
  }

  
      
/**
 * Collection that this video belongs to
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * Time of when this collection video was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this collection video was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The global ID for this entity.
 */
      get globalId(): $Field<"globalId", string | null | undefined>  {
       return this.$_select("globalId") as any
      }

      
/**
 * The database ID for this collection video.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The order of this entity in the list.
 */
      get order(): $Field<"order", string>  {
       return this.$_select("order") as any
      }

      
/**
 * Revision that this video belongs to
 */
      revision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"revision", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("revision", options as any) as any
    }
  

      
/**
 * The thumbnail URL for the video.
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * The title of the video.
 */
      get title(): $Field<"title", string>  {
       return this.$_select("title") as any
      }

      
/**
 * Time of when this collection video was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * URL of this video
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }

      
/**
 * Uploader of this video
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  
}


/**
 * Facet fields specific to the Collections query.
 */
export type CollectionsFacet = {
  adultContent?: Readonly<Array<string>> | null | undefined,
badges?: Readonly<Array<string>> | null | undefined,
categoryName?: Readonly<Array<string>> | null | undefined,
collectionRating?: Readonly<Array<string>> | null | undefined,
collectionStatus?: Readonly<Array<string>> | null | undefined,
gameIds?: Readonly<Array<string>> | null | undefined,
gameName?: Readonly<Array<string>> | null | undefined,
gameVersion?: Readonly<Array<string>> | null | undefined,
tag?: Readonly<Array<string>> | null | undefined
}
    


/**
 * Common filter fields specific to the Collections query
 */
export type CollectionsFilter = {
  adultContent?: Readonly<Array<BooleanFilterValue>> | null | undefined,
categoryId?: Readonly<Array<BaseFilterValue>> | null | undefined,
categoryName?: Readonly<Array<BaseFilterValue>> | null | undefined,
collectionRating?: Readonly<Array<BaseFilterValue>> | null | undefined,
collectionStatus?: Readonly<Array<BaseFilterValue>> | null | undefined,
filter?: Readonly<Array<CollectionsFilter>> | null | undefined,
gameDomain?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameId?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameName?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameVersion?: Readonly<Array<BaseFilterValue>> | null | undefined,
generalSearch?: Readonly<Array<CollectionGeneralSearchFilterValue>> | null | undefined,
hasDraftRevision?: Readonly<Array<BooleanFilterValue>> | null | undefined,
hasPublishedRevision?: Readonly<Array<BooleanFilterValue>> | null | undefined,
modUid?: Readonly<Array<BaseFilterValue>> | null | undefined,
name?: Readonly<Array<BaseFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined,
tag?: Readonly<Array<BaseFilterValue>> | null | undefined
}
    


/**
 * Common filter fields specific to the Collections query
 */
export type CollectionsSearchFilter = {
  adultContent?: Readonly<Array<BooleanFilterValue>> | null | undefined,
badges?: Readonly<Array<ExistsFilter>> | null | undefined,
categoryId?: Readonly<Array<BaseFilterValue>> | null | undefined,
categoryName?: Readonly<Array<BaseFilterValue>> | null | undefined,
collectionRating?: Readonly<Array<BaseFilterValue>> | null | undefined,
collectionStatus?: Readonly<Array<BaseFilterValue>> | null | undefined,
createdAt?: Readonly<Array<BaseFilterValue>> | null | undefined,
filter?: Readonly<Array<CollectionsSearchFilter>> | null | undefined,
gameDomain?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameId?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameName?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameVersion?: Readonly<Array<BaseFilterValue>> | null | undefined,
generalSearch?: Readonly<Array<CollectionGeneralSearchFilterValue>> | null | undefined,
hasDraftRevision?: Readonly<Array<BooleanFilterValue>> | null | undefined,
hasPublishedRevision?: Readonly<Array<BooleanFilterValue>> | null | undefined,
modUid?: Readonly<Array<BaseFilterValue>> | null | undefined,
name?: Readonly<Array<BaseFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined,
recentRating?: Readonly<Array<FloatFilterValue>> | null | undefined,
recentRatingCount?: Readonly<Array<IntFilterValue>> | null | undefined,
tag?: Readonly<Array<BaseFilterValue>> | null | undefined,
updatedAt?: Readonly<Array<BaseFilterValue>> | null | undefined,
userId?: Readonly<Array<BaseFilterValue>> | null | undefined
}
    


/**
 * Sort fields specific to a Collections query.
 */
export type CollectionsSearchSort = {
  createdAt?: BaseSortValue | null | undefined,
downloads?: BaseSortValue | null | undefined,
endorsements?: BaseSortValue | null | undefined,
rating?: BaseSortValue | null | undefined,
recentRating?: BaseSortValue | null | undefined,
relevance?: BaseSortValue | null | undefined,
updatedAt?: BaseSortValue | null | undefined
}
    


/**
 * A comment.
 */
export class Comment extends $Base<"Comment"> {
  constructor() {
    super("Comment")
  }

  
      
/**
 * The attachment filename and IDs
 */
      attachments<Sel extends Selection<Attachment>>(selectorFn: (s: Attachment) => [...Sel]):$Field<"attachments", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Attachment)
      };
      return this.$_select("attachments", options as any) as any
    }
  

      
/**
 * The content of the latest revision for this comment.
 */
      get body(): $Field<"body", string>  {
       return this.$_select("body") as any
      }

      
/**
 * Time of when this comment was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The user that created this comment.
 */
      creator<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"creator", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("creator", options as any) as any
    }
  

      
/**
 * The pagination cursor for this comment.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * Time of when this comment was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The user that discarded this comment.
 */
      discardedBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"discardedBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("discardedBy", options as any) as any
    }
  

      
/**
 * Time of when this comment was hidden.
 */
      get hiddenAt(): $Field<"hiddenAt", DateTime | null | undefined>  {
       return this.$_select("hiddenAt") as any
      }

      
/**
 * The user that hid this comment.
 */
      hiddenBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"hiddenBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("hiddenBy", options as any) as any
    }
  

      
/**
 * The internal reason why this comment was hidden. Only accessible to admins and moderators.
 */
      get hiddenInternalReason(): $Field<"hiddenInternalReason", string | null | undefined>  {
       return this.$_select("hiddenInternalReason") as any
      }

      
/**
 * The public reason why this comment was hidden.
 */
      get hiddenReason(): $Field<"hiddenReason", string | null | undefined>  {
       return this.$_select("hiddenReason") as any
      }

      
/**
 * The database ID for this comment.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Returns a boolean indicating whether this comment is discarded.
 */
      get isDiscarded(): $Field<"isDiscarded", boolean>  {
       return this.$_select("isDiscarded") as any
      }

      
/**
 * Is this a pinned comment
 */
      get isPinned(): $Field<"isPinned", boolean>  {
       return this.$_select("isPinned") as any
      }

      
/**
 * Comment likes count.
 */
      get likesCount(): $Field<"likesCount", number>  {
       return this.$_select("likesCount") as any
      }

      
/**
 * Time of when this comment was locked.
 */
      get lockedAt(): $Field<"lockedAt", DateTime | null | undefined>  {
       return this.$_select("lockedAt") as any
      }

      
/**
 * The user that locked this comment.
 */
      lockedBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"lockedBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("lockedBy", options as any) as any
    }
  

      
/**
 * Returns a boolean indicating whether this comment was moderated by an admin.
 */
      get moderatedByAdmin(): $Field<"moderatedByAdmin", boolean>  {
       return this.$_select("moderatedByAdmin") as any
      }

      
/**
 * JWT token for submitting moderation reports
 */
      get moderationJwt(): $Field<"moderationJwt", string>  {
       return this.$_select("moderationJwt") as any
      }

      
/**
 * The moderation status of this comment.
 */
      get moderationStatus(): $Field<"moderationStatus", CommentModerationStatus>  {
       return this.$_select("moderationStatus") as any
      }

      
/**
 * The parent comment.
 */
      parent<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"parent", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("parent", options as any) as any
    }
  

      
/**
 * The user that pinned this comment.
 */
      get pinPriority(): $Field<"pinPriority", number | null | undefined>  {
       return this.$_select("pinPriority") as any
      }

      
/**
 * User which pinned the comment
 */
      pinnedBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"pinnedBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("pinnedBy", options as any) as any
    }
  

      
/**
 * Returns a boolean indicating whether this comment was pinned by an admin.
 */
      get pinnedByAdmin(): $Field<"pinnedByAdmin", boolean>  {
       return this.$_select("pinnedByAdmin") as any
      }

      
/**
 * A list of replies to this comment.
 */
      replies<Args extends VariabledInput<{
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<CommentConnection>>(args: ExactArgNames<Args, {
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: CommentConnection) => [...Sel]):$Field<"replies", GetOutput<Sel> , GetVariables<Sel, Args>>
replies<Sel extends Selection<CommentConnection>>(selectorFn: (s: CommentConnection) => [...Sel]):$Field<"replies", GetOutput<Sel> , GetVariables<Sel>>
replies(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new CommentConnection)
      };
      return this.$_select("replies", options as any) as any
    }
  

      
/**
 * The revisions of this comment.
 */
      revisions<Sel extends Selection<CommentRevision>>(selectorFn: (s: CommentRevision) => [...Sel]):$Field<"revisions", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentRevision)
      };
      return this.$_select("revisions", options as any) as any
    }
  

      
/**
 * Time of when this comment was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Whether the viewer has ignored the content owner.
 */
      get viewerHasIgnored(): $Field<"viewerHasIgnored", boolean>  {
       return this.$_select("viewerHasIgnored") as any
      }

      
/**
 * Returns a boolean indicating whether the viewing user has liked this comment.
 */
      get viewerHasLiked(): $Field<"viewerHasLiked", boolean>  {
       return this.$_select("viewerHasLiked") as any
      }
}


/**
 * The connection type for Comment.
 */
export class CommentConnection extends $Base<"CommentConnection"> {
  constructor() {
    super("CommentConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<CommentEdge>>(selectorFn: (s: CommentEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class CommentEdge extends $Base<"CommentEdge"> {
  constructor() {
    super("CommentEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("node", options as any) as any
    }
  
}

  
/**
 * Enum for available moderation states: "none", "hidden", "locked"
 */
export enum CommentModerationStatus {
  
/**
 * The comment is not under moderation.
 */
  none = "none",

/**
 * The comment cannot be viewed.
 */
  hidden = "hidden",

/**
 * The comment cannot be interacted with.
 */
  locked = "locked"
}
  


/**
 * A comment revision.
 */
export class CommentRevision extends $Base<"CommentRevision"> {
  constructor() {
    super("CommentRevision")
  }

  
      
/**
 * The content of this revision.
 */
      get body(): $Field<"body", string>  {
       return this.$_select("body") as any
      }

      
/**
 * Time of when this revision was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Time of when this revision was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * The connection type for Comment.
 */
export class CommentSearchResultConnection extends $Base<"CommentSearchResultConnection"> {
  constructor() {
    super("CommentSearchResultConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<CommentSearchResultEdge>>(selectorFn: (s: CommentSearchResultEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentSearchResultEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Time taken to complete the search in milliseconds.
 */
      get timeTaken(): $Field<"timeTaken", number>  {
       return this.$_select("timeTaken") as any
      }

      
/**
 * Total number of results.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A comment search result edge.
 */
export class CommentSearchResultEdge extends $Base<"CommentSearchResultEdge"> {
  constructor() {
    super("CommentSearchResultEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("node", options as any) as any
    }
  

      
/**
 * The relevancy score of the result. Higher scores mean more relevance.
 */
      get relevance(): $Field<"relevance", number>  {
       return this.$_select("relevance") as any
      }
}


/**
 * A comment thread.
 */
export class CommentThread extends $Base<"CommentThread"> {
  constructor() {
    super("CommentThread")
  }

  
      
/**
 * Look up comments.
 */
      comments<Args extends VariabledInput<{
        sortBy?: string | null | undefined
sortDirection?: string | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<CommentConnection>>(args: ExactArgNames<Args, {
        sortBy?: string | null | undefined
sortDirection?: string | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: CommentConnection) => [...Sel]):$Field<"comments", GetOutput<Sel> , GetVariables<Sel, Args>>
comments<Sel extends Selection<CommentConnection>>(selectorFn: (s: CommentConnection) => [...Sel]):$Field<"comments", GetOutput<Sel> , GetVariables<Sel>>
comments(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              sortBy: "String",
sortDirection: "String",
after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new CommentConnection)
      };
      return this.$_select("comments", options as any) as any
    }
  

      
/**
 * The database ID for this comment thread.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Time of when this comment thread was locked.
 */
      get lockedAt(): $Field<"lockedAt", DateTime | null | undefined>  {
       return this.$_select("lockedAt") as any
      }

      
/**
 * The user that locked this comment thread.
 */
      lockedBy<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"lockedBy", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("lockedBy", options as any) as any
    }
  

      
/**
 * Returns a boolean indicating whether this comment thread was moderated by an admin.
 */
      get moderatedByAdmin(): $Field<"moderatedByAdmin", boolean>  {
       return this.$_select("moderatedByAdmin") as any
      }

      
/**
 * The moderation status of this comment thread.
 */
      get moderationStatus(): $Field<"moderationStatus", CommentThreadModerationStatus>  {
       return this.$_select("moderationStatus") as any
      }

      
/**
 * The thread owner
 */
      owner<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"owner", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("owner", options as any) as any
    }
  
}

  
/**
 * Enum for available thread moderation states: "none", "locked"
 */
export enum CommentThreadModerationStatus {
  
/**
 * The comment thread is not under moderation.
 */
  none = "none",

/**
 * The comment thread cannot be interacted with.
 */
  locked = "locked"
}
  


/**
 * Filter fields specific to the comments search query.
 */
export type CommentsSearchFilter = {
  filter?: Readonly<Array<CommentsSearchFilter>> | null | undefined,
op?: FilterLogicalOperator | null | undefined,
query?: Readonly<Array<BaseFilterValue>> | null | undefined,
threadId?: Readonly<Array<BaseFilterValue>> | null | undefined
}
    


/**
 * Sort fields specific to the comments search query.
 */
export type CommentsSearchSort = {
  relevance?: BaseSortValue | null | undefined
}
    


/**
 * Defines a Mod request using Game Domain and Mod ID
 */
export type CompositeDomainWithIdInput = {
  gameDomain: string,
modId: number
}
    


/**
 * Defines a Mod request using Game ID and Mod ID
 */
export type CompositeIdInput = {
  gameId: number,
modId: number
}
    


/**
 * Autogenerated return type of CreateApiKeyMutation.
 */
export class CreateApiKeyMutationPayload extends $Base<"CreateApiKeyMutationPayload"> {
  constructor() {
    super("CreateApiKeyMutationPayload")
  }

  
      
/**
 * The created key
 */
      apiKey<Sel extends Selection<ApiKey>>(selectorFn: (s: ApiKey) => [...Sel]):$Field<"apiKey", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ApiKey)
      };
      return this.$_select("apiKey", options as any) as any
    }
  

      
/**
 * True if the key was successfully created
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateChangelogMutation.
 */
export class CreateChangelogMutationPayload extends $Base<"CreateChangelogMutationPayload"> {
  constructor() {
    super("CreateChangelogMutationPayload")
  }

  
      
/**
 * Updated changelog ID
 */
      get changelogId(): $Field<"changelogId", number>  {
       return this.$_select("changelogId") as any
      }

      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateCollectionBugReportMutation.
 */
export class CreateCollectionBugReportMutationPayload extends $Base<"CreateCollectionBugReportMutationPayload"> {
  constructor() {
    super("CreateCollectionBugReportMutationPayload")
  }

  
      
/**
 * Collection bug report that was created
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * Autogenerated return type of CreateCollectionMutation.
 */
export class CreateCollectionMutationPayload extends $Base<"CreateCollectionMutationPayload"> {
  constructor() {
    super("CreateCollectionMutationPayload")
  }

  
      
/**
 * Returns created collection
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * The database ID for this collection.
 */
      get collectionId(): $Field<"collectionId", number>  {
       return this.$_select("collectionId") as any
      }

      
/**
 * Returns the collection revision which is created alongside the collection
 */
      revision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"revision", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("revision", options as any) as any
    }
  

      
/**
 * The database ID for this collection revision.
 */
      get revisionId(): $Field<"revisionId", number>  {
       return this.$_select("revisionId") as any
      }

      
/**
 * Returns true when collection is successfully created.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateCommentMutation.
 */
export class CreateCommentMutationPayload extends $Base<"CreateCommentMutationPayload"> {
  constructor() {
    super("CreateCommentMutationPayload")
  }

  
      
/**
 * The comment that was created.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of CreateCsamDeletionRequest.
 */
export class CreateCsamDeletionRequestPayload extends $Base<"CreateCsamDeletionRequestPayload"> {
  constructor() {
    super("CreateCsamDeletionRequestPayload")
  }

  
      
/**
 * The created CSAM Deletion Request
 */
      csamDeletionRequest<Sel extends Selection<CsamDeletionRequest>>(selectorFn: (s: CsamDeletionRequest) => [...Sel]):$Field<"csamDeletionRequest", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CsamDeletionRequest)
      };
      return this.$_select("csamDeletionRequest", options as any) as any
    }
  
}


/**
 * Autogenerated return type of CreateEndorsementMutation.
 */
export class CreateEndorsementMutationPayload extends $Base<"CreateEndorsementMutationPayload"> {
  constructor() {
    super("CreateEndorsementMutationPayload")
  }

  
      
/**
 * Endorsement entry.
 */
      endorsement<Sel extends Selection<Endorsement>>(selectorFn: (s: Endorsement) => [...Sel]):$Field<"endorsement", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Endorsement)
      };
      return this.$_select("endorsement", options as any) as any
    }
  

      
/**
 * Returns true when endorsement is created successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateMessage.
 */
export class CreateMessagePayload extends $Base<"CreateMessagePayload"> {
  constructor() {
    super("CreateMessagePayload")
  }

  
      
/**
 * Returns true when message was sent.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateModEndorsementMutation.
 */
export class CreateModEndorsementMutationPayload extends $Base<"CreateModEndorsementMutationPayload"> {
  constructor() {
    super("CreateModEndorsementMutationPayload")
  }

  
      
/**
 * Endorsement entry.
 */
      endorsement<Sel extends Selection<ModEndorsement>>(selectorFn: (s: ModEndorsement) => [...Sel]):$Field<"endorsement", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModEndorsement)
      };
      return this.$_select("endorsement", options as any) as any
    }
  

      
/**
 * Returns true when endorsement is created successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateNoteAboutUserMutation.
 */
export class CreateNoteAboutUserMutationPayload extends $Base<"CreateNoteAboutUserMutationPayload"> {
  constructor() {
    super("CreateNoteAboutUserMutationPayload")
  }

  
      
/**
 * Moderation note created successfully
 */
      get success(): $Field<"success", boolean | null | undefined>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateOrUpdateRevisionMutation.
 */
export class CreateOrUpdateRevisionMutationPayload extends $Base<"CreateOrUpdateRevisionMutationPayload"> {
  constructor() {
    super("CreateOrUpdateRevisionMutationPayload")
  }

  
      
/**
 * Return the collection that was updated
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * The database ID for this collection.
 */
      get collectionId(): $Field<"collectionId", number>  {
       return this.$_select("collectionId") as any
      }

      
/**
 * Return the revision that was updated
 */
      revision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"revision", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("revision", options as any) as any
    }
  

      
/**
 * The database ID for this revision.
 */
      get revisionId(): $Field<"revisionId", number>  {
       return this.$_select("revisionId") as any
      }

      
/**
 * The revision number
 */
      get revisionNumber(): $Field<"revisionNumber", number>  {
       return this.$_select("revisionNumber") as any
      }

      
/**
 * Return true if the revision was updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateRatingMutation.
 */
export class CreateRatingMutationPayload extends $Base<"CreateRatingMutationPayload"> {
  constructor() {
    super("CreateRatingMutationPayload")
  }

  
      
/**
 * Average rating value of the entity the rating was created for.
 */
      averageRating<Sel extends Selection<AverageRating>>(selectorFn: (s: AverageRating) => [...Sel]):$Field<"averageRating", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new AverageRating)
      };
      return this.$_select("averageRating", options as any) as any
    }
  

      
/**
 * Rating entry.
 */
      rating<Sel extends Selection<Rating>>(selectorFn: (s: Rating) => [...Sel]):$Field<"rating", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Rating)
      };
      return this.$_select("rating", options as any) as any
    }
  

      
/**
 * Returns true when rating is created successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of CreateTagMutation.
 */
export class CreateTagMutationPayload extends $Base<"CreateTagMutationPayload"> {
  constructor() {
    super("CreateTagMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }

      
/**
 * Created Tag
 */
      tag<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"tag", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("tag", options as any) as any
    }
  
}


/**
 * A CSAM Deletion Request
 */
export class CsamDeletionRequest extends $Base<"CsamDeletionRequest"> {
  constructor() {
    super("CsamDeletionRequest")
  }

  
      
/**
 * Timestamp when the request was created
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * List of CSAM URL IDs to be deleted
 */
      get csamUrls(): $Field<"csamUrls", string>  {
       return this.$_select("csamUrls") as any
      }

      
/**
 * ID of the CSAM Deletion Request
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * ID of the user who made the request
 */
      get requesterMemberId(): $Field<"requesterMemberId", string>  {
       return this.$_select("requesterMemberId") as any
      }

      
/**
 * Current status of the request
 */
      get status(): $Field<"status", CsamDeletionRequestStatus>  {
       return this.$_select("status") as any
      }
}


/**
 * A CSAM Deletion Request file path result from a CDN
 */
export type CsamDeletionRequestCDNFilePathResult = {
  message: string,
path: string,
status: string
}
    


/**
 * A CSAM Deletion Request status update from a CDN
 */
export type CsamDeletionRequestCDNResult = {
  hostname: string,
processedAt: DateTime,
results: Readonly<Array<CsamDeletionRequestCDNUrlResult>>,
summary: CsamDeletionRequestCDNSummary
}
    


/**
 * A summary of the results from a CSAM Deletion Request processed by a CDN
 */
export type CsamDeletionRequestCDNSummary = {
  failed: number,
succeeded: number,
total: number
}
    


/**
 * A CSAM Deletion Request status update for a url from a CDN
 */
export type CsamDeletionRequestCDNUrlResult = {
  deletedCount: number,
failedCount: number,
filePaths: Readonly<Array<CsamDeletionRequestCDNFilePathResult>>,
foundCount: number,
message: string,
success: boolean,
url: string
}
    

  
/**
 * Status of a CSAM Deletion Request
 */
export enum CsamDeletionRequestStatus {
  
  PENDING = "PENDING",

  IN_PROGRESS_BACKBLAZE = "IN_PROGRESS_BACKBLAZE",

  IN_PROGRESS_CDN = "IN_PROGRESS_CDN",

  IN_PROGRESS_CLOUDFLARE_CACHE = "IN_PROGRESS_CLOUDFLARE_CACHE",

  COMPLETED_SUCCESSFULLY = "COMPLETED_SUCCESSFULLY",

  COMPLETED_WITH_FAILURES = "COMPLETED_WITH_FAILURES"
}
  


/**
 * Scalar Type to parse and handle DateTimes in iso8601 format
 */
export type DateTime = string



/**
 * Autogenerated return type of DeleteApiKeyMutation.
 */
export class DeleteApiKeyMutationPayload extends $Base<"DeleteApiKeyMutationPayload"> {
  constructor() {
    super("DeleteApiKeyMutationPayload")
  }

  
      
/**
 * Output message
 */
      get message(): $Field<"message", string | null | undefined>  {
       return this.$_select("message") as any
      }

      
/**
 * True if the key was successfully removed
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of DeletePersonalApiKeyMutation.
 */
export class DeletePersonalApiKeyMutationPayload extends $Base<"DeletePersonalApiKeyMutationPayload"> {
  constructor() {
    super("DeletePersonalApiKeyMutationPayload")
  }

  
      
/**
 * Output message
 */
      get message(): $Field<"message", string | null | undefined>  {
       return this.$_select("message") as any
      }

      
/**
 * True if the key was successfully removed
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of DiscardCollectionMutation.
 */
export class DiscardCollectionMutationPayload extends $Base<"DiscardCollectionMutationPayload"> {
  constructor() {
    super("DiscardCollectionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of DiscardCommentMutation.
 */
export class DiscardCommentMutationPayload extends $Base<"DiscardCommentMutationPayload"> {
  constructor() {
    super("DiscardCommentMutationPayload")
  }

  
      
/**
 * The comment that was discarded.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of DiscardRevisionMutation.
 */
export class DiscardRevisionMutationPayload extends $Base<"DiscardRevisionMutationPayload"> {
  constructor() {
    super("DiscardRevisionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of DiscardTagMutation.
 */
export class DiscardTagMutationPayload extends $Base<"DiscardTagMutationPayload"> {
  constructor() {
    super("DiscardTagMutationPayload")
  }

  
      
/**
 * Returns true if tag was discarded
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}

  
/**
 * Report Type defined by the Wallet app.
 */
export enum DonationReport {
  
/**
 * Unique Download report
 */
  UNIQUE_DOWNLOADS = "UNIQUE_DOWNLOADS",

/**
 * Interaction-based, game-adjusted report
 */
  I20_GAME_ADJUSTED = "I20_GAME_ADJUSTED",

/**
 * Interaction-based report with DP bucketed by game
 */
  I20_GAME_POOLS = "I20_GAME_POOLS"
}
  


/**
 * Autogenerated return type of EditCollectionMutation.
 */
export class EditCollectionMutationPayload extends $Base<"EditCollectionMutationPayload"> {
  constructor() {
    super("EditCollectionMutationPayload")
  }

  
      
/**
 * Return collection object
 */
      collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * Returns true if collection was updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * An Endorsement
 */
export class Endorsement extends $Base<"Endorsement"> {
  constructor() {
    super("Endorsement")
  }

  
      
/**
 * Id of endorsed entity
 */
      get modelId(): $Field<"modelId", BigInt>  {
       return this.$_select("modelId") as any
      }

      
/**
 * Type of endorsed entity
 */
      get modelType(): $Field<"modelType", string>  {
       return this.$_select("modelType") as any
      }

      
/**
 * Endorsement status: abstained/endorsed
 */
      get status(): $Field<"status", string>  {
       return this.$_select("status") as any
      }

      
/**
 * The database ID for this endorsement.
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * Filter for checking if a field exists (is not null) or does not exist (is null)
 */
export type ExistsFilter = {
  op: FilterComparisonOperatorExists
}
    


/**
 * A mod file that is not hosted on Nexus Mods
 */
export class ExternalResource extends $Base<"ExternalResource"> {
  constructor() {
    super("ExternalResource")
  }

  
      
/**
 * Similar to the author field in the mod details. So this is not
the uploader and may not be an actual user account on the page. Will often be unassigned for external resources
 */
      get author(): $Field<"author", string | null | undefined>  {
       return this.$_select("author") as any
      }

      
/**
 * The database ID for this revision.
 */
      get collectionRevisionId(): $Field<"collectionRevisionId", number>  {
       return this.$_select("collectionRevisionId") as any
      }

      
/**
 * Glob pattern that must then match the archive file name. In cases where the collection asks
for a non-exact version (e.g.: 1.2.4 or newer) where we can't look at the hash of the expected file, this can be used
to determine if the mod is already installed/downloaded locally.
 */
      get fileExpression(): $Field<"fileExpression", string>  {
       return this.$_select("fileExpression") as any
      }

      
/**
 * The database ID for this external resource.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Deprecated
 */
      get instructions(): $Field<"instructions", string | null | undefined>  {
       return this.$_select("instructions") as any
      }

      
/**
 * Name of this resource
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * If true, this is an optional resource
 */
      get optional(): $Field<"optional", boolean>  {
       return this.$_select("optional") as any
      }

      
/**
 * Resource type. This can be one of "direct" (A url to
download directly from), "browse" (A website url for the user to browse and manually select the right file on), "manual"
 (Vortex will just show instructions for the user to create/acquire the mod manually).
 */
      get resourceType(): $Field<"resourceType", string>  {
       return this.$_select("resourceType") as any
      }

      
/**
 * Only set in the "browse"/"direct" types, contains the url
to browse to/download from
 */
      get resourceUrl(): $Field<"resourceUrl", string | null | undefined>  {
       return this.$_select("resourceUrl") as any
      }

      
/**
 * The version of the mod that the curator had installed at the
time of uploading the collection.
 */
      get version(): $Field<"version", string | null | undefined>  {
       return this.$_select("version") as any
      }
}


/**
 * An external video.
 */
export class ExternalVideo extends $Base<"ExternalVideo"> {
  constructor() {
    super("ExternalVideo")
  }

  
      
/**
 * The embed URL for the video.
 */
      get embedUrl(): $Field<"embedUrl", string>  {
       return this.$_select("embedUrl") as any
      }

      
/**
 * The external video ID.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The platform where the video is hosted.
 */
      get platform(): $Field<"platform", ExternalVideoPlatform>  {
       return this.$_select("platform") as any
      }

      
/**
 * The thumbnail URL for the video.
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * The title of the video.
 */
      get title(): $Field<"title", string>  {
       return this.$_select("title") as any
      }
}

  
/**
 * Supported external video platforms.
 */
export enum ExternalVideoPlatform {
  
/**
 * https://www.youtube.com
 */
  youtube = "youtube"
}
  


/**
 * A Mod File Hash
 */
export class FileHash extends $Base<"FileHash"> {
  constructor() {
    super("FileHash")
  }

  
      
/**
 * Time of when this file was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Name of the file
 */
      get fileName(): $Field<"fileName", string>  {
       return this.$_select("fileName") as any
      }

      
/**
 * Filesize in bytes
 */
      get fileSize(): $Field<"fileSize", BigInt>  {
       return this.$_select("fileSize") as any
      }

      
/**
 * Type of file
 */
      get fileType(): $Field<"fileType", string>  {
       return this.$_select("fileType") as any
      }

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * MD5 Checksum of the file
 */
      get md5(): $Field<"md5", string>  {
       return this.$_select("md5") as any
      }

      
/**
 * Mod file object
 */
      modFile<Sel extends Selection<ModFile>>(selectorFn: (s: ModFile) => [...Sel]):$Field<"modFile", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModFile)
      };
      return this.$_select("modFile", options as any) as any
    }
  

      
/**
 * The database ID for this file.
 */
      get modFileId(): $Field<"modFileId", number>  {
       return this.$_select("modFileId") as any
      }
}

  
/**
 * Filter comparison operators for elastic search queries.
 */
export enum FilterComparisonOperator {
  
  EQUALS = "EQUALS",

  NOT_EQUALS = "NOT_EQUALS",

/**
 * Matches if all terms in the value are present (in any order). No wildcarding, though stems may match.
 */
  MATCHES = "MATCHES",

/**
 * Matches if all terms in the value are present (in any order), with leading/trailing wildcards applied.
 */
  WILDCARD = "WILDCARD",

/**
 * Greater than
 */
  GT = "GT",

/**
 * Greater than or equal to
 */
  GTE = "GTE",

/**
 * Less than
 */
  LT = "LT",

/**
 * Less than or equal to
 */
  LTE = "LTE"
}
  

  
/**
 * Filter comparison equals and matches operators for elastic search queries.
 */
export enum FilterComparisonOperatorEqualsMatches {
  
  EQUALS = "EQUALS",

  NOT_EQUALS = "NOT_EQUALS",

/**
 * Matches if all terms in the value are present (in any order). No wildcarding, though stems may match.
 */
  MATCHES = "MATCHES"
}
  

  
/**
 * Filter comparison equals and matches operators for elastic search queries.
 */
export enum FilterComparisonOperatorEqualsWildcard {
  
  EQUALS = "EQUALS",

  NOT_EQUALS = "NOT_EQUALS",

/**
 * Matches if all terms in the value are present (in any order), with leading/trailing wildcards applied.
 */
  WILDCARD = "WILDCARD"
}
  

  
/**
 * Filter comparison operator for exists elastic search queries.
 */
export enum FilterComparisonOperatorExists {
  
/**
 * Matches if the field contains any non-null value.
 */
  EXISTS = "EXISTS",

/**
 * Matches if the field is null or does not exist.
 */
  NOT_EXISTS = "NOT_EXISTS"
}
  

  
/**
 * Filter comparison equals and matches operators for elastic search queries.
 */
export enum FilterComparisonOperatorNumeric {
  
  EQUALS = "EQUALS",

  NOT_EQUALS = "NOT_EQUALS",

/**
 * Greater than
 */
  GT = "GT",

/**
 * Greater than or equal to
 */
  GTE = "GTE",

/**
 * Less than
 */
  LT = "LT",

/**
 * Less than or equal to
 */
  LTE = "LTE"
}
  

  
/**
 * Filter logical operators for elastic search queries.
 */
export enum FilterLogicalOperator {
  
/**
 * Logical AND
 */
  AND = "AND",

/**
 * Logical OR
 */
  OR = "OR"
}
  


/**
 * A float value
 */
export type FloatFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: number
}
    

  
/**
 * Formal or informal moderation warning
 */
export enum FormalOrInformalWarning {
  
  INFORMAL_WARNING = "INFORMAL_WARNING",

  FORMAL_WARNING = "FORMAL_WARNING"
}
  


/**
 * A forum post
 */
export class ForumPost extends $Base<"ForumPost"> {
  constructor() {
    super("ForumPost")
  }

  
      
/**
 * Author ID of the forum post
 */
      get authorId(): $Field<"authorId", number>  {
       return this.$_select("authorId") as any
      }

      
/**
 * Author name of the forum post
 */
      get authorName(): $Field<"authorName", string>  {
       return this.$_select("authorName") as any
      }

      
/**
 * The database ID for this forum post.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Post contents
 */
      get post(): $Field<"post", string>  {
       return this.$_select("post") as any
      }

      
/**
 * Post date and time
 */
      get postDate(): $Field<"postDate", number>  {
       return this.$_select("postDate") as any
      }

      
/**
 * Post author details
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  
}


/**
 * A forum topic
 */
export class ForumTopic extends $Base<"ForumTopic"> {
  constructor() {
    super("ForumTopic")
  }

  
      
/**
 * If true, this topic has been approved
 */
      get approved(): $Field<"approved", boolean>  {
       return this.$_select("approved") as any
      }

      
/**
 * Description
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * The database ID for this forum.
 */
      get forumId(): $Field<"forumId", number>  {
       return this.$_select("forumId") as any
      }

      
/**
 * The database ID for this forum topic.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * If true, this topic is pinned and should appear above all
non-pinned topics
 */
      get pinned(): $Field<"pinned", boolean>  {
       return this.$_select("pinned") as any
      }

      
/**
 * List of all posts within this topic
 */
      posts<Sel extends Selection<ForumPost>>(selectorFn: (s: ForumPost) => [...Sel]):$Field<"posts", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ForumPost)
      };
      return this.$_select("posts", options as any) as any
    }
  

      
/**
 * Number of posts in the topic
 */
      get postsCount(): $Field<"postsCount", number>  {
       return this.$_select("postsCount") as any
      }

      
/**
 * State of this topic, can be open or closed
 */
      get state(): $Field<"state", string>  {
       return this.$_select("state") as any
      }

      
/**
 * Title for this topic
 */
      get title(): $Field<"title", string>  {
       return this.$_select("title") as any
      }

      
/**
 * SEO-specific title for this topic
 */
      get titleSeo(): $Field<"titleSeo", string>  {
       return this.$_select("titleSeo") as any
      }

      
/**
 * URL for this topic
 */
      get topicUrl(): $Field<"topicUrl", string | null | undefined>  {
       return this.$_select("topicUrl") as any
      }

      
/**
 * Number of views this topic has received
 */
      get views(): $Field<"views", number>  {
       return this.$_select("views") as any
      }

      
/**
 * TODO
 */
      get visible(): $Field<"visible", string>  {
       return this.$_select("visible") as any
      }
}


/**
 * A Game
 */
export class Game extends $Base<"Game"> {
  constructor() {
    super("Game")
  }

  
      
/**
 * Time that this game was approved, after being submitted by a community member
 */
      get approvedAt(): $Field<"approvedAt", DateTime | null | undefined>  {
       return this.$_select("approvedAt") as any
      }

      
/**
 * Schema for game artwork (V1 for game tile only, V2 for multiple artwork assets).
 */
      get artworkSchema(): $Field<"artworkSchema", GameArtworkSchema | null | undefined>  {
       return this.$_select("artworkSchema") as any
      }

      
/**
 * Tags available for collections under this specific game, including global tags.
 */
      availableTags<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"availableTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("availableTags", options as any) as any
    }
  

      
/**
 * Number of collections within this game
 */
      get collectionCount(): $Field<"collectionCount", number | null | undefined>  {
       return this.$_select("collectionCount") as any
      }

      
/**
 * True if the name of this game is a copyrighted asset
 */
      get copyrightedName(): $Field<"copyrightedName", boolean>  {
       return this.$_select("copyrightedName") as any
      }

      
/**
 * Nexus-specific domain name, used to separate games on the Nexus Mods website.
 */
      get domainName(): $Field<"domainName", string>  {
       return this.$_select("domainName") as any
      }

      
/**
 * Number of total downloads for mods in this game
 */
      get downloadCount(): $Field<"downloadCount", BigInt | null | undefined>  {
       return this.$_select("downloadCount") as any
      }

      
/**
 * URL to the game's forum
 */
      get forumUrl(): $Field<"forumUrl", string | null | undefined>  {
       return this.$_select("forumUrl") as any
      }

      
/**
 * Genre of this game
 */
      get genre(): $Field<"genre", string | null | undefined>  {
       return this.$_select("genre") as any
      }

      
/**
 * The database ID for this game.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Number of uploaded images within this game
 */
      get imageCount(): $Field<"imageCount", number | null | undefined>  {
       return this.$_select("imageCount") as any
      }

      
/**
 * Number of uploaded images, supporter images, and videos within this game
 */
      get mediaCount(): $Field<"mediaCount", number | null | undefined>  {
       return this.$_select("mediaCount") as any
      }

      
/**
 * Number of mods within this game
 */
      get modCount(): $Field<"modCount", number | null | undefined>  {
       return this.$_select("modCount") as any
      }

      
/**
 * Name of this game
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Tags only available for collections under this specific game.
 */
      specificTags<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"specificTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("specificTags", options as any) as any
    }
  

      
/**
 * Number of uploaded supporter images within this game
 */
      get supporterImageCount(): $Field<"supporterImageCount", number | null | undefined>  {
       return this.$_select("supporterImageCount") as any
      }

      
/**
 * Number of days to consider for trending mods
 */
      get trendingPeriodDays(): $Field<"trendingPeriodDays", number>  {
       return this.$_select("trendingPeriodDays") as any
      }

      
/**
 * Number of total unique downloads for mods in this game
 */
      get uniqueDownloadCount(): $Field<"uniqueDownloadCount", BigInt | null | undefined>  {
       return this.$_select("uniqueDownloadCount") as any
      }

      
/**
 * Number of uploaded videos within this game
 */
      get videoCount(): $Field<"videoCount", number | null | undefined>  {
       return this.$_select("videoCount") as any
      }
}


/**
 * Game artwork is set individually. This describes the schema for the artwork.
 */
export class GameArtwork extends $Base<"GameArtwork"> {
  constructor() {
    super("GameArtwork")
  }

  
      
/**
 * V1 prior to May 2025, using one tile image.
 */
      schemaV1<Sel extends Selection<ArtworkSchemaV1>>(selectorFn: (s: ArtworkSchemaV1) => [...Sel]):$Field<"schemaV1", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ArtworkSchemaV1)
      };
      return this.$_select("schemaV1", options as any) as any
    }
  

      
/**
 * V2 introduced May 2025, comprising tile, hero, and thumbnail images.
 */
      schemaV2<Sel extends Selection<ArtworkSchemaV2>>(selectorFn: (s: ArtworkSchemaV2) => [...Sel]):$Field<"schemaV2", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ArtworkSchemaV2)
      };
      return this.$_select("schemaV2", options as any) as any
    }
  
}

  
/**
 * Schema for managing game artwork
 */
export enum GameArtworkSchema {
  
  V1 = "V1",

  V2 = "V2"
}
  


/**
 * The connection type for Game.
 */
export class GameConnection extends $Base<"GameConnection"> {
  constructor() {
    super("GameConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<GameEdge>>(selectorFn: (s: GameEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new GameEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class GameEdge extends $Base<"GameEdge"> {
  constructor() {
    super("GameEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("node", options as any) as any
    }
  
}


/**
 * Represents a game expansion (DLC)
 */
export class GameExpansion extends $Base<"GameExpansion"> {
  constructor() {
    super("GameExpansion")
  }

  
      
/**
 * The ID of the game that the expansion belongs to
 */
      get gameId(): $Field<"gameId", string>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The ID of the game expansion
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The name of the game expansion
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }
}


export type GameNameFieldFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: string
}
    


export class GamePage extends $Base<"GamePage"> {
  constructor() {
    super("GamePage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A version of a specific game.
 */
export class GameVersion extends $Base<"GameVersion"> {
  constructor() {
    super("GameVersion")
  }

  
      
/**
 * Unique ID for referring to this version in future queries
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Game version reference
 */
      get reference(): $Field<"reference", string>  {
       return this.$_select("reference") as any
      }
}


/**
 * Facet fields specific to the games query.
 */
export type GamesFacet = {
  genre?: Readonly<Array<string>> | null | undefined,
hasCollections?: Readonly<Array<string>> | null | undefined,
supportsVortex?: Readonly<Array<string>> | null | undefined
}
    


/**
 * Filter for a list of Games
 */
export type GamesSearchFilter = {
  filter?: Readonly<Array<GamesSearchFilter>> | null | undefined,
name?: Readonly<Array<GameNameFieldFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined
}
    


/**
 * Sort for a list of Games
 */
export type GamesSearchSort = {
  approved?: BaseSortValue | null | undefined,
collections?: BaseSortValue | null | undefined,
downloads?: BaseSortValue | null | undefined,
mods?: BaseSortValue | null | undefined,
name?: BaseSortValue | null | undefined,
relevance?: BaseSortValue | null | undefined
}
    


/**
 * Autogenerated return type of GiveKudosMutation.
 */
export class GiveKudosMutationPayload extends $Base<"GiveKudosMutationPayload"> {
  constructor() {
    super("GiveKudosMutationPayload")
  }

  
      
/**
 * True if the user was successfully given kudos
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A sitewide notice to be displayed to all users
 */
export class GlobalNotice extends $Base<"GlobalNotice"> {
  constructor() {
    super("GlobalNotice")
  }

  
      
/**
 * Content of the notice
 */
      get content(): $Field<"content", string>  {
       return this.$_select("content") as any
      }

      
/**
 * Date of the notice
 */
      get date(): $Field<"date", DateTime>  {
       return this.$_select("date") as any
      }

      
/**
 * Staff member who created the notice
 */
      staff<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"staff", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("staff", options as any) as any
    }
  
}


/**
 * A globally identifiable entity.
 */
export class GloballyIdentifiable extends $Interface<{CollectionImage: CollectionImage,CollectionVideo: CollectionVideo}, "GloballyIdentifiable"> {
  constructor() {
    super({CollectionImage: CollectionImage,CollectionVideo: CollectionVideo}, "GloballyIdentifiable")
  }
  
      
/**
 * The global ID for this entity.
 */
      get globalId(): $Field<"globalId", string | null | undefined>  {
       return this.$_select("globalId") as any
      }

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }
}


/**
 * Result of checking an MD5 hash against the CSAM known image hashlist
 */
export class HashCheckResult extends $Base<"HashCheckResult"> {
  constructor() {
    super("HashCheckResult")
  }

  
      
/**
 * The MD5 hash that was checked
 */
      get hashValue(): $Field<"hashValue", string>  {
       return this.$_select("hashValue") as any
      }

      
/**
 * Whether the hash was found in the CSAM hashlist (true = match found, false = no match)
 */
      get match(): $Field<"match", boolean>  {
       return this.$_select("match") as any
      }
}


/**
 * Autogenerated return type of HideCollectionBugReportMutation.
 */
export class HideCollectionBugReportMutationPayload extends $Base<"HideCollectionBugReportMutationPayload"> {
  constructor() {
    super("HideCollectionBugReportMutationPayload")
  }

  
      
/**
 * Collection bug report which was hidden
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * Autogenerated return type of HideCommentMutation.
 */
export class HideCommentMutationPayload extends $Base<"HideCommentMutationPayload"> {
  constructor() {
    super("HideCommentMutationPayload")
  }

  
      
/**
 * The comment that was hidden.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * An ISO 8601-encoded datetime
 */
export type ISO8601DateTime = string



/**
 * Autogenerated return type of IgnoreUserMutation.
 */
export class IgnoreUserMutationPayload extends $Base<"IgnoreUserMutationPayload"> {
  constructor() {
    super("IgnoreUserMutationPayload")
  }

  
      
/**
 * If true, the user is blocked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * An image
 */
export class Image extends $Base<"Image"> {
  constructor() {
    super("Image")
  }

  
      
/**
 * If true, this image contains adult content
 */
      get adult(): $Field<"adult", boolean | null | undefined>  {
       return this.$_select("adult") as any
      }

      
/**
 * Whether comments are allowed on the image.
 */
      get allowComments(): $Field<"allowComments", boolean | null | undefined>  {
       return this.$_select("allowComments") as any
      }

      
/**
 * Whether ratings are allowed on the image.
 */
      get allowRating(): $Field<"allowRating", boolean | null | undefined>  {
       return this.$_select("allowRating") as any
      }

      
/**
 * A caption for this image
 */
      get caption(): $Field<"caption", string>  {
       return this.$_select("caption") as any
      }

      
/**
 * An image category
 */
      category<Sel extends Selection<ImageCategory>>(selectorFn: (s: ImageCategory) => [...Sel]):$Field<"category", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ImageCategory)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * Time of when this image was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * A detailed description of this image
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * Game this image belongs to
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Status of this image
 */
      get mediaStatus(): $Field<"mediaStatus", MediaStatus>  {
       return this.$_select("mediaStatus") as any
      }

      
/**
 * Name of the image file
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Uploader of this image
 */
      owner<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"owner", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("owner", options as any) as any
    }
  

      
/**
 * Rating of this image
 */
      get rating(): $Field<"rating", number>  {
       return this.$_select("rating") as any
      }

      
/**
 * URL of the site this image is hosted on
 */
      get siteUrl(): $Field<"siteUrl", string>  {
       return this.$_select("siteUrl") as any
      }

      
/**
 * URL of the thumbnail of this image
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * A title for this image
 */
      get title(): $Field<"title", string | null | undefined>  {
       return this.$_select("title") as any
      }

      
/**
 * URL of this image
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }

      
/**
 * True if the viewer (current user) has ignored this image's author
 */
      get viewerBlocked(): $Field<"viewerBlocked", boolean>  {
       return this.$_select("viewerBlocked") as any
      }

      
/**
 * View count of this image
 */
      get views(): $Field<"views", number>  {
       return this.$_select("views") as any
      }
}


/**
 * An image category
 */
export class ImageCategory extends $Base<"ImageCategory"> {
  constructor() {
    super("ImageCategory")
  }

  
      
/**
 * Unix timestamp of category creation
 */
      get date(): $Field<"date", number | null | undefined>  {
       return this.$_select("date") as any
      }

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this image category.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }
}

  
/**
 * Available image types
 */
export enum ImageTypes {
  
  gallery = "gallery",

  tile = "tile",

  header = "header"
}
  


/**
 * An integer value
 */
export type IntFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: number
}
    


/**
 * Autogenerated return type of IssueWarningToUserMutation.
 */
export class IssueWarningToUserMutationPayload extends $Base<"IssueWarningToUserMutationPayload"> {
  constructor() {
    super("IssueWarningToUserMutationPayload")
  }

  
      
/**
 * Warning issued successfully
 */
      get success(): $Field<"success", boolean | null | undefined>  {
       return this.$_select("success") as any
      }
}


/**
 * Represents untyped JSON
 */
export type JSON = string



/**
 * A Tag
 */
export class LegacyTag extends $Base<"LegacyTag"> {
  constructor() {
    super("LegacyTag")
  }

  
      
/**
 * If true, this tag is blockable by the user
 */
      get blockable(): $Field<"blockable", boolean>  {
       return this.$_select("blockable") as any
      }

      
/**
 * Games this
tag is used for. Will be nil if global is true, as this tag would apply to all games
 */
      games<Args extends VariabledInput<{
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<GameConnection>>(args: ExactArgNames<Args, {
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: GameConnection) => [...Sel]):$Field<"games", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
games<Sel extends Selection<GameConnection>>(selectorFn: (s: GameConnection) => [...Sel]):$Field<"games", GetOutput<Sel> | undefined , GetVariables<Sel>>
games(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new GameConnection)
      };
      return this.$_select("games", options as any) as any
    }
  

      
/**
 * If true, this Tag is global and not intended for a specific game
 */
      get global(): $Field<"global", boolean>  {
       return this.$_select("global") as any
      }

      
/**
 * ID of this tag
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this tag
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * ID of the parent tag, if any
 */
      get parentId(): $Field<"parentId", string | null | undefined>  {
       return this.$_select("parentId") as any
      }

      
/**
 * If true, this tag can be searched on by users
 */
      get searchable(): $Field<"searchable", boolean>  {
       return this.$_select("searchable") as any
      }
}


/**
 * Autogenerated return type of LegacyUpdateModerationWarningMutation.
 */
export class LegacyUpdateModerationWarningMutationPayload extends $Base<"LegacyUpdateModerationWarningMutationPayload"> {
  constructor() {
    super("LegacyUpdateModerationWarningMutationPayload")
  }

  
      
/**
 * Moderation warning updated successfully
 */
      get success(): $Field<"success", boolean | null | undefined>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of LegacyUpdatePreferencesMutation.
 */
export class LegacyUpdatePreferencesMutationPayload extends $Base<"LegacyUpdatePreferencesMutationPayload"> {
  constructor() {
    super("LegacyUpdatePreferencesMutationPayload")
  }

  
      
/**
 * User preferences updated successfully
 */
      get success(): $Field<"success", boolean | null | undefined>  {
       return this.$_select("success") as any
      }
}


/**
 * A set of user donation preferences.
 */
export class LegacyUserDonationPreferences extends $Base<"LegacyUserDonationPreferences"> {
  constructor() {
    super("LegacyUserDonationPreferences")
  }

  
      
/**
 * Whether the user has enabled author premium donations.
 */
      get donateAuthorpremium(): $Field<"donateAuthorpremium", boolean>  {
       return this.$_select("donateAuthorpremium") as any
      }

      
/**
 * Whether the user has enabled own premium donations.
 */
      get donateOwnpremium(): $Field<"donateOwnpremium", boolean>  {
       return this.$_select("donateOwnpremium") as any
      }

      
/**
 * The maximum amount of premium time in months a user can donate (0 is Lifetime, or no limit).
 */
      get donatePremiumMax(): $Field<"donatePremiumMax", number>  {
       return this.$_select("donatePremiumMax") as any
      }

      
/**
 * Whether the user has enabled profile donations.
 */
      get donateProfile(): $Field<"donateProfile", boolean>  {
       return this.$_select("donateProfile") as any
      }

      
/**
 * Whether the user has enabled straight donations.
 */
      get donateStraight(): $Field<"donateStraight", boolean>  {
       return this.$_select("donateStraight") as any
      }

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The user's PayPal email address.
 */
      get paypal(): $Field<"paypal", string>  {
       return this.$_select("paypal") as any
      }
}


/**
 * Autogenerated return type of LikeCommentMutation.
 */
export class LikeCommentMutationPayload extends $Base<"LikeCommentMutationPayload"> {
  constructor() {
    super("LikeCommentMutationPayload")
  }

  
      
/**
 * The comment that was liked.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of ListCollectionMutation.
 */
export class ListCollectionMutationPayload extends $Base<"ListCollectionMutationPayload"> {
  constructor() {
    super("ListCollectionMutationPayload")
  }

  
      
/**
 * Returns true if collection was listed
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of LockCommentMutation.
 */
export class LockCommentMutationPayload extends $Base<"LockCommentMutationPayload"> {
  constructor() {
    super("LockCommentMutationPayload")
  }

  
      
/**
 * The comment that was locked.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of LockThreadMutation.
 */
export class LockThreadMutationPayload extends $Base<"LockThreadMutationPayload"> {
  constructor() {
    super("LockThreadMutationPayload")
  }

  
      
/**
 * The comment thread that was locked.
 */
      commentThread<Sel extends Selection<CommentThread>>(selectorFn: (s: CommentThread) => [...Sel]):$Field<"commentThread", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CommentThread)
      };
      return this.$_select("commentThread", options as any) as any
    }
  
}


/**
 * Facet fields specific to the media query.
 */
export type MediaFacet = {
  category?: Readonly<Array<string>> | null | undefined,
gameId?: Readonly<Array<string>> | null | undefined,
type?: Readonly<Array<string>> | null | undefined
}
    


export type MediaGeneralSearchFilterValue = {
  op?: FilterComparisonOperator | null | undefined,
value: string
}
    


/**
 * Filter fields specific to the legacy media search query.
 */
export type MediaSearchFilter = {
  adultContent?: Readonly<Array<BooleanFilterValue>> | null | undefined,
createdAt?: Readonly<Array<BaseFilterValue>> | null | undefined,
filter?: Readonly<Array<MediaSearchFilter>> | null | undefined,
gameId?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameName?: Readonly<Array<BaseFilterValue>> | null | undefined,
generalSearch?: Readonly<Array<MediaGeneralSearchFilterValue>> | null | undefined,
mediaStatus?: Readonly<Array<BaseFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined,
owner?: Readonly<Array<BaseFilterValue>> | null | undefined,
type?: Readonly<Array<BaseFilterValue>> | null | undefined
}
    


/**
 * Sort fields specific to the media query.
 */
export type MediaSearchSort = {
  createdAt?: BaseSortValue | null | undefined,
random?: RandomSortValue | null | undefined,
rating?: BaseSortValue | null | undefined,
views?: BaseSortValue | null | undefined
}
    

  
/**
 * Available media statuses
 */
export enum MediaStatus {
  
/**
 * Publicly visible
 */
  published = "published",

/**
 * Under moderation
 */
  under_moderation = "under_moderation",

/**
 * Hidden
 */
  hidden = "hidden"
}
  


/**
 * Legacy Media Union
 */
export class MediaUnion extends $Union<{Image: Image,SupporterImage: SupporterImage,Video: Video,Node: Node}, "MediaUnion"> {
  constructor() {
    super({Image: Image,SupporterImage: SupporterImage,Video: Video,Node: Node}, "MediaUnion")
  }
}


export class MediaUnionPage extends $Base<"MediaUnionPage"> {
  constructor() {
    super("MediaUnionPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<MediaUnion>>(selectorFn: (s: MediaUnion) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new MediaUnion)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A mod
 */
export class Mod extends $Base<"Mod"> {
  constructor() {
    super("Mod")
  }

  
      
/**
 * If true, this mod contains adult content
 */
      get adult(): $Field<"adult", boolean | null | undefined>  {
       return this.$_select("adult") as any
      }

      
/**
 * If true, this mod contains adult content
 */
      get adultContent(): $Field<"adultContent", boolean | null | undefined>  {
       return this.$_select("adultContent") as any
      }

      
/**
 * Author of this mod
 */
      get author(): $Field<"author", string | null | undefined>  {
       return this.$_select("author") as any
      }

      
/**
 * Category name of this mod
 */
      get category(): $Field<"category", string>  {
       return this.$_select("category") as any
      }

      
/**
 * Time of when this mod was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * A detailed description of this mod
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * Download count of this mod
 */
      get downloads(): $Field<"downloads", number>  {
       return this.$_select("downloads") as any
      }

      
/**
 * Endorsement count of this mod
 */
      get endorsements(): $Field<"endorsements", number>  {
       return this.$_select("endorsements") as any
      }

      
/**
 * Size of the primary mod file in kilobytes
 */
      get fileSize(): $Field<"fileSize", number | null | undefined>  {
       return this.$_select("fileSize") as any
      }

      
/**
 * Game changed by this mod
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this mod.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * If true, this mod is blocked from earning DP
 */
      get isBlockedFromEarningDp(): $Field<"isBlockedFromEarningDp", boolean | null | undefined>  {
       return this.$_select("isBlockedFromEarningDp") as any
      }

      
/**
 * Mirrors for this mod
 */
      mirrors<Sel extends Selection<ModMirror>>(selectorFn: (s: ModMirror) => [...Sel]):$Field<"mirrors", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModMirror)
      };
      return this.$_select("mirrors", options as any) as any
    }
  

      
/**
 * A mod category
 */
      modCategory<Sel extends Selection<ModCategory>>(selectorFn: (s: ModCategory) => [...Sel]):$Field<"modCategory", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModCategory)
      };
      return this.$_select("modCategory", options as any) as any
    }
  

      
/**
 * The database ID for this mod.
 */
      get modId(): $Field<"modId", number>  {
       return this.$_select("modId") as any
      }

      
/**
 * Requirements of this mod
 */
      modRequirements<Sel extends Selection<ModRequirements>>(selectorFn: (s: ModRequirements) => [...Sel]):$Field<"modRequirements", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModRequirements)
      };
      return this.$_select("modRequirements", options as any) as any
    }
  

      
/**
 * Name of this mod
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * URL for the main mod image
 */
      get pictureUrl(): $Field<"pictureUrl", string | null | undefined>  {
       return this.$_select("pictureUrl") as any
      }

      
/**
 * Status of this mod
 */
      get status(): $Field<"status", string>  {
       return this.$_select("status") as any
      }

      
/**
 * A brief summary of this mod
 */
      get summary(): $Field<"summary", string>  {
       return this.$_select("summary") as any
      }

      
/**
 * URL for the blurred thumbnail mod image
 */
      get thumbnailBlurredUrl(): $Field<"thumbnailBlurredUrl", string | null | undefined>  {
       return this.$_select("thumbnailBlurredUrl") as any
      }

      
/**
 * URL for the large blurred thumbnail mod image
 */
      get thumbnailLargeBlurredUrl(): $Field<"thumbnailLargeBlurredUrl", string | null | undefined>  {
       return this.$_select("thumbnailLargeBlurredUrl") as any
      }

      
/**
 * URL for the large thumbnail mod image
 */
      get thumbnailLargeUrl(): $Field<"thumbnailLargeUrl", string | null | undefined>  {
       return this.$_select("thumbnailLargeUrl") as any
      }

      
/**
 * URL for the thumbnail mod image
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string | null | undefined>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * The database ID for this mod.
 */
      get uid(): $Field<"uid", string>  {
       return this.$_select("uid") as any
      }

      
/**
 * Time of when this mod was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Uploader of this mod
 */
      uploader<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"uploader", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("uploader", options as any) as any
    }
  

      
/**
 * Version of this mod
 */
      get version(): $Field<"version", string>  {
       return this.$_select("version") as any
      }

      
/**
 * True if the viewer (current user) has blocked this mod
 */
      get viewerBlocked(): $Field<"viewerBlocked", boolean>  {
       return this.$_select("viewerBlocked") as any
      }

      
/**
 * A timestamp indicating the last time the user downloaded this mod
 */
      get viewerDownloaded(): $Field<"viewerDownloaded", DateTime | null | undefined>  {
       return this.$_select("viewerDownloaded") as any
      }

      
/**
 * True indicates endorsement, false for
 abstention. Will be null if the user has not endorsed the mod
 */
      get viewerEndorsed(): $Field<"viewerEndorsed", boolean | null | undefined>  {
       return this.$_select("viewerEndorsed") as any
      }

      
/**
 * True if the viewer (current user) is blocked from interacting with this mod
 */
      get viewerIsBlocked(): $Field<"viewerIsBlocked", boolean | null | undefined>  {
       return this.$_select("viewerIsBlocked") as any
      }

      
/**
 * If true, the viewer (current user) is tracking this mod.
 */
      get viewerTracked(): $Field<"viewerTracked", boolean>  {
       return this.$_select("viewerTracked") as any
      }

      
/**
 * True if the mod has been updated since the viewer (current user) downloaded it
 */
      get viewerUpdateAvailable(): $Field<"viewerUpdateAvailable", boolean | null | undefined>  {
       return this.$_select("viewerUpdateAvailable") as any
      }
}

  
/**
 * The affiliation of user to a mod
 */
export enum ModAffiliation {
  
/**
 * The owner of the mod
 */
  OWNER = "OWNER",

/**
 * A contributor to the mod
 */
  CONTRIBUTOR = "CONTRIBUTOR"
}
  


/**
 * The mod analytics for a specific month
 */
export class ModAnalyticsByMonthNode extends $Base<"ModAnalyticsByMonthNode"> {
  constructor() {
    super("ModAnalyticsByMonthNode")
  }

  
      
/**
 * Month
 */
      get month(): $Field<"month", number>  {
       return this.$_select("month") as any
      }

      
/**
 * Total downloads
 */
      get totalDownloads(): $Field<"totalDownloads", BigInt>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * Unique downloads
 */
      get uniqueDownloads(): $Field<"uniqueDownloads", BigInt>  {
       return this.$_select("uniqueDownloads") as any
      }

      
/**
 * Year
 */
      get year(): $Field<"year", number>  {
       return this.$_select("year") as any
      }
}


/**
 * A page of mod analytics grouped by month
 */
export class ModAnalyticsByMonthPage extends $Base<"ModAnalyticsByMonthPage"> {
  constructor() {
    super("ModAnalyticsByMonthPage")
  }

  
      
/**
 * A list of mod analytics by month nodes
 */
      nodes<Sel extends Selection<ModAnalyticsByMonthNode>>(selectorFn: (s: ModAnalyticsByMonthNode) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModAnalyticsByMonthNode)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information about the page
 */
      pageInfo<Sel extends Selection<OffsetBasedPageInfo>>(selectorFn: (s: OffsetBasedPageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new OffsetBasedPageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * The total number of downloads for mods with which this user is affiliated
 */
      get totalDownloads(): $Field<"totalDownloads", BigInt>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * The total number of unique downloads for mods with which this user is affiliated
 */
      get totalUniqueDownloads(): $Field<"totalUniqueDownloads", BigInt>  {
       return this.$_select("totalUniqueDownloads") as any
      }
}

  
/**
 * Attributes to sort by for mod analytics by month
 */
export enum ModAnalyticsByMonthSortBy {
  
/**
 * Sort by date
 */
  DATE = "DATE",

/**
 * Sort by total downloads
 */
  TOTAL_DOWNLOADS = "TOTAL_DOWNLOADS",

/**
 * Sort by total unique downloads
 */
  UNIQUE_DOWNLOADS = "UNIQUE_DOWNLOADS"
}
  


/**
 * The analytics for a mod within a month
 */
export class ModAnalyticsForMonthNode extends $Base<"ModAnalyticsForMonthNode"> {
  constructor() {
    super("ModAnalyticsForMonthNode")
  }

  
      
/**
 * Mod
 */
      mod<Sel extends Selection<Mod>>(selectorFn: (s: Mod) => [...Sel]):$Field<"mod", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Mod)
      };
      return this.$_select("mod", options as any) as any
    }
  

      
/**
 * Total downloads
 */
      get totalDownloads(): $Field<"totalDownloads", BigInt>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * Unique downloads
 */
      get uniqueDownloads(): $Field<"uniqueDownloads", BigInt>  {
       return this.$_select("uniqueDownloads") as any
      }
}


/**
 * A page of mod analytics grouped by month
 */
export class ModAnalyticsForMonthPage extends $Base<"ModAnalyticsForMonthPage"> {
  constructor() {
    super("ModAnalyticsForMonthPage")
  }

  
      
/**
 * A list of mod analytics for month nodes
 */
      nodes<Sel extends Selection<ModAnalyticsForMonthNode>>(selectorFn: (s: ModAnalyticsForMonthNode) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModAnalyticsForMonthNode)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information about the current page
 */
      pageInfo<Sel extends Selection<OffsetBasedPageInfo>>(selectorFn: (s: OffsetBasedPageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new OffsetBasedPageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * The total number of downloads for the month
 */
      get totalDownloads(): $Field<"totalDownloads", BigInt>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * The total number of unique downloads for the month
 */
      get totalUniqueDownloads(): $Field<"totalUniqueDownloads", BigInt>  {
       return this.$_select("totalUniqueDownloads") as any
      }
}

  
/**
 * Attributes to sort by for mod analytics for month
 */
export enum ModAnalyticsForMonthSortBy {
  
/**
 * Sort by total downloads
 */
  TOTAL_DOWNLOADS = "TOTAL_DOWNLOADS",

/**
 * Sort by total unique downloads
 */
  UNIQUE_DOWNLOADS = "UNIQUE_DOWNLOADS"
}
  


/**
 * A mod category
 */
export class ModCategory extends $Base<"ModCategory"> {
  constructor() {
    super("ModCategory")
  }

  
      
/**
 * The database ID for this mod category.
 */
      get categoryId(): $Field<"categoryId", number>  {
       return this.$_select("categoryId") as any
      }

      
/**
 * Unix timestamp of category creation
 */
      get date(): $Field<"date", number | null | undefined>  {
       return this.$_select("date") as any
      }

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * Comma separated mod category id and game id
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Comma separated list of legacy tag IDs
 */
      get tags(): $Field<"tags", string | null | undefined>  {
       return this.$_select("tags") as any
      }
}


/**
 * A Mod Endorsement
 */
export class ModEndorsement extends $Base<"ModEndorsement"> {
  constructor() {
    super("ModEndorsement")
  }

  
      
/**
 * Id of endorsed entity
 */
      get modUid(): $Field<"modUid", BigInt>  {
       return this.$_select("modUid") as any
      }

      
/**
 * Endorsement status: abstained/endorsed
 */
      get status(): $Field<"status", string>  {
       return this.$_select("status") as any
      }

      
/**
 * The database ID for this endorsement.
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * The connection type for User.
 */
export class ModEndorserConnection extends $Base<"ModEndorserConnection"> {
  constructor() {
    super("ModEndorserConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<ModEndorserEdge>>(selectorFn: (s: ModEndorserEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModEndorserEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  
}


/**
 * Mod endorser edge
 */
export class ModEndorserEdge extends $Base<"ModEndorserEdge"> {
  constructor() {
    super("ModEndorserEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * Time of endorsement
 */
      get endorsedAt(): $Field<"endorsedAt", DateTime>  {
       return this.$_select("endorsedAt") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("node", options as any) as any
    }
  
}


/**
 * Files belonging to a mod
 */
export class ModFile extends $Base<"ModFile"> {
  constructor() {
    super("ModFile")
  }

  
      
/**
 * The database ID for this File category.
 */
      get category(): $Field<"category", ModFileCategory>  {
       return this.$_select("category") as any
      }

      
/**
 * The database ID for this File category.
 */
      get categoryId(): $Field<"categoryId", number>  {
       return this.$_select("categoryId") as any
      }

      
/**
 * Patch notes for this mod file version
 */
      get changelogText(): $Field<"changelogText", Readonly<Array<string>>>  {
       return this.$_select("changelogText") as any
      }

      
/**
 * Number of downloads for this file
 */
      get count(): $Field<"count", number>  {
       return this.$_select("count") as any
      }

      
/**
 * Unix Timestamp for when this file was uploaded
 */
      get date(): $Field<"date", number>  {
       return this.$_select("date") as any
      }

      
/**
 * Description for this file
 */
      get description(): $Field<"description", string | null | undefined>  {
       return this.$_select("description") as any
      }

      
/**
 * Forms a composite key with the game_id
 */
      get fileId(): $Field<"fileId", number>  {
       return this.$_select("fileId") as any
      }

      
/**
 * Game that this file relates to
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * If true, this file can be downloaded by a mod manager
 */
      get manager(): $Field<"manager", number>  {
       return this.$_select("manager") as any
      }

      
/**
 * Mod that this file belongs to
 */
      mod<Sel extends Selection<Mod>>(selectorFn: (s: Mod) => [...Sel]):$Field<"mod", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Mod)
      };
      return this.$_select("mod", options as any) as any
    }
  

      
/**
 * The database ID for this mod.
 */
      get modId(): $Field<"modId", number>  {
       return this.$_select("modId") as any
      }

      
/**
 * File name
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * User that uploaded this file
 */
      owner<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"owner", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("owner", options as any) as any
    }
  

      
/**
 * If true, this file is the primary file for the mod
 */
      get primary(): $Field<"primary", number>  {
       return this.$_select("primary") as any
      }

      
/**
 * URL for reporting this file
 */
      get reportLink(): $Field<"reportLink", string>  {
       return this.$_select("reportLink") as any
      }

      
/**
 * If true, popup will be displayed for showing the requirements
 */
      get requirementsAlert(): $Field<"requirementsAlert", number>  {
       return this.$_select("requirementsAlert") as any
      }

      
/**
 * If true, this file has been virus scanned
 */
      get scanned(): $Field<"scanned", number>  {
       return this.$_select("scanned") as any
      }

      
/**
 * Status of virus scanning on this file
 */
      get scannedV2(): $Field<"scannedV2", VirusScanStatus>  {
       return this.$_select("scannedV2") as any
      }

      
/**
 * Size of this file, in kilobytes
 */
      get size(): $Field<"size", number>  {
       return this.$_select("size") as any
      }

      
/**
 * Size of this file, in bytes
 */
      get sizeInBytes(): $Field<"sizeInBytes", BigInt | null | undefined>  {
       return this.$_select("sizeInBytes") as any
      }

      
/**
 * Number of downloads for this file
 */
      get totalDownloads(): $Field<"totalDownloads", number>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * Number of unique downloads for this file
 */
      get uCount(): $Field<"uCount", number>  {
       return this.$_select("uCount") as any
      }

      
/**
 * Unique ID for this file
 */
      get uid(): $Field<"uid", string>  {
       return this.$_select("uid") as any
      }

      
/**
 * Number of unique downloads for this file
 */
      get uniqueDownloads(): $Field<"uniqueDownloads", number>  {
       return this.$_select("uniqueDownloads") as any
      }

      
/**
 * URL to download this file
 */
      get uri(): $Field<"uri", string>  {
       return this.$_select("uri") as any
      }

      
/**
 * Version this file relates to
 */
      get version(): $Field<"version", string>  {
       return this.$_select("version") as any
      }
}

  
/**
 * Used to flag a mod file as a main, old or archived file.
 */
export enum ModFileCategory {
  
  MAIN = "MAIN",

  UPDATE = "UPDATE",

  OPTIONAL = "OPTIONAL",

  OLD_VERSION = "OLD_VERSION",

  MISCELLANEOUS = "MISCELLANEOUS",

  REMOVED = "REMOVED",

  ARCHIVED = "ARCHIVED"
}
  


export class ModFileContent extends $Base<"ModFileContent"> {
  constructor() {
    super("ModFileContent")
  }

  
      
      get fileExtension(): $Field<"fileExtension", string>  {
       return this.$_select("fileExtension") as any
      }

      
      get fileId(): $Field<"fileId", number>  {
       return this.$_select("fileId") as any
      }

      
      get fileName(): $Field<"fileName", string>  {
       return this.$_select("fileName") as any
      }

      
      get filePath(): $Field<"filePath", string>  {
       return this.$_select("filePath") as any
      }

      
      get filePathParts(): $Field<"filePathParts", Readonly<Array<string>>>  {
       return this.$_select("filePathParts") as any
      }

      
      get fileSize(): $Field<"fileSize", BigInt>  {
       return this.$_select("fileSize") as any
      }

      
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this mod_file_content.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
      get modId(): $Field<"modId", number>  {
       return this.$_select("modId") as any
      }
}


export class ModFileContentPage extends $Base<"ModFileContentPage"> {
  constructor() {
    super("ModFileContentPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<ModFileContent>>(selectorFn: (s: ModFileContent) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModFileContent)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


export type ModFileContentSearchFilter = {
  fileExtensionExact?: Readonly<Array<BaseFilterValueEqualsMatches>> | null | undefined,
fileId?: Readonly<Array<IntFilterValue>> | null | undefined,
fileNameWildcard?: Readonly<Array<BaseFilterValueEqualsWildcard>> | null | undefined,
filePathPartsExact?: Readonly<Array<BaseFilterValueEqualsMatches>> | null | undefined,
filePathWildcard?: Readonly<Array<BaseFilterValueEqualsWildcard>> | null | undefined,
fileSize?: Readonly<Array<BaseFilterValueNumeric>> | null | undefined,
filter?: Readonly<Array<ModFileContentSearchFilter>> | null | undefined,
gameId?: Readonly<Array<IntFilterValue>> | null | undefined,
modId?: Readonly<Array<IntFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined
}
    


export type ModFileContentSearchSort = {
  fileId?: BaseSortValue | null | undefined,
gameId?: BaseSortValue | null | undefined,
modId?: BaseSortValue | null | undefined
}
    


export class ModFilePage extends $Base<"ModFilePage"> {
  constructor() {
    super("ModFilePage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<ModFile>>(selectorFn: (s: ModFile) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModFile)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A download mirror for a mod
 */
export class ModMirror extends $Base<"ModMirror"> {
  constructor() {
    super("ModMirror")
  }

  
      
/**
 * Download count for this mirror
 */
      get count(): $Field<"count", number | null | undefined>  {
       return this.$_select("count") as any
      }

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this mod mirror.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The database ID for this mod.
 */
      get modId(): $Field<"modId", number>  {
       return this.$_select("modId") as any
      }

      
/**
 * Name of this mirror
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Download count for this mirror
 */
      get totalDownloads(): $Field<"totalDownloads", number | null | undefined>  {
       return this.$_select("totalDownloads") as any
      }

      
/**
 * URI for this mirror
 */
      get uri(): $Field<"uri", string | null | undefined>  {
       return this.$_select("uri") as any
      }
}


export class ModPage extends $Base<"ModPage"> {
  constructor() {
    super("ModPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<Mod>>(selectorFn: (s: Mod) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Mod)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * Represents a mod requirement
 */
export class ModRequirement extends $Base<"ModRequirement"> {
  constructor() {
    super("ModRequirement")
  }

  
      
/**
 * If true, the requirement is external to the site. See the url field for the address.
 */
      get externalRequirement(): $Field<"externalRequirement", boolean>  {
       return this.$_select("externalRequirement") as any
      }

      
/**
 * The ID of the game that the required mod belongs to
 */
      get gameId(): $Field<"gameId", string>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The ID of the mod requirement
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The ID of the mod that is required
 */
      get modId(): $Field<"modId", string>  {
       return this.$_select("modId") as any
      }

      
/**
 * The name of the mod required
 */
      get modName(): $Field<"modName", string>  {
       return this.$_select("modName") as any
      }

      
/**
 * Notes about the mod requirement
 */
      get notes(): $Field<"notes", string | null | undefined>  {
       return this.$_select("notes") as any
      }

      
/**
 * The URL of the mod that is required by the mod
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }
}


export class ModRequirementPage extends $Base<"ModRequirementPage"> {
  constructor() {
    super("ModRequirementPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<ModRequirement>>(selectorFn: (s: ModRequirement) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModRequirement)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * Represents the requirements of a mod
 */
export class ModRequirements extends $Base<"ModRequirements"> {
  constructor() {
    super("ModRequirements")
  }

  
      
/**
 * The DLC (expansion) requirements of the mod
 */
      dlcRequirements<Sel extends Selection<ModRequirementsDlc>>(selectorFn: (s: ModRequirementsDlc) => [...Sel]):$Field<"dlcRequirements", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModRequirementsDlc)
      };
      return this.$_select("dlcRequirements", options as any) as any
    }
  

      
/**
 * Other mods that require this mod
 */
      modsRequiringThisMod<Args extends VariabledInput<{
        offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModRequiringPage>>(args: ExactArgNames<Args, {
        offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModRequiringPage) => [...Sel]):$Field<"modsRequiringThisMod", GetOutput<Sel> , GetVariables<Sel, Args>>
modsRequiringThisMod<Sel extends Selection<ModRequiringPage>>(selectorFn: (s: ModRequiringPage) => [...Sel]):$Field<"modsRequiringThisMod", GetOutput<Sel> , GetVariables<Sel>>
modsRequiringThisMod(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModRequiringPage)
      };
      return this.$_select("modsRequiringThisMod", options as any) as any
    }
  

      
/**
 * Required mods for this mod
 */
      nexusRequirements<Args extends VariabledInput<{
        offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModRequirementPage>>(args: ExactArgNames<Args, {
        offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModRequirementPage) => [...Sel]):$Field<"nexusRequirements", GetOutput<Sel> , GetVariables<Sel, Args>>
nexusRequirements<Sel extends Selection<ModRequirementPage>>(selectorFn: (s: ModRequirementPage) => [...Sel]):$Field<"nexusRequirements", GetOutput<Sel> , GetVariables<Sel>>
nexusRequirements(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModRequirementPage)
      };
      return this.$_select("nexusRequirements", options as any) as any
    }
  
}


/**
 * Represents the DLC (expansion) requirements of a mod
 */
export class ModRequirementsDlc extends $Base<"ModRequirementsDlc"> {
  constructor() {
    super("ModRequirementsDlc")
  }

  
      
/**
 * The game expansion (DLC) required by the mod
 */
      gameExpansion<Sel extends Selection<GameExpansion>>(selectorFn: (s: GameExpansion) => [...Sel]):$Field<"gameExpansion", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new GameExpansion)
      };
      return this.$_select("gameExpansion", options as any) as any
    }
  

      
/**
 * Notes about the expansion (DLC) requirement
 */
      get notes(): $Field<"notes", string | null | undefined>  {
       return this.$_select("notes") as any
      }
}


/**
 * Represents a mod requirement
 */
export class ModRequiring extends $Base<"ModRequiring"> {
  constructor() {
    super("ModRequiring")
  }

  
      
/**
 * If true, the requirement is external to the site. See the url field for the address.
 */
      get externalRequirement(): $Field<"externalRequirement", boolean>  {
       return this.$_select("externalRequirement") as any
      }

      
/**
 * The ID of the game that the mod belongs to
 */
      get gameId(): $Field<"gameId", string>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The ID of the mod requirement
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The ID of the mod that is required
 */
      get modId(): $Field<"modId", string>  {
       return this.$_select("modId") as any
      }

      
/**
 * The name of the mod that requires the mod
 */
      get modName(): $Field<"modName", string>  {
       return this.$_select("modName") as any
      }

      
/**
 * Notes about the mod requirement
 */
      get notes(): $Field<"notes", string | null | undefined>  {
       return this.$_select("notes") as any
      }

      
/**
 * The URL of the mod that is required by the mod
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }
}


export class ModRequiringPage extends $Base<"ModRequiringPage"> {
  constructor() {
    super("ModRequiringPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<ModRequiring>>(selectorFn: (s: ModRequiring) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModRequiring)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}

  
/**
 * Used to define the source of a mod. Useful for informing Collections how to retrieve
mods.
 */
export enum ModSource {
  
/**
 * The Nexus website
 */
  nexus = "nexus",

/**
 * A direct url to download from
 */
  direct = "direct",

/**
 * A general url to find the mod (further instructions may be provided)
 */
  browse = "browse",

/**
 * Manual instructions for installing the mod
 */
  manual = "manual",

/**
 * Mod files are included in the collection asset file, and do not need to be acquired separately
 */
  bundle = "bundle"
}
  


/**
 * An upload
 */
export class ModUpload extends $Base<"ModUpload"> {
  constructor() {
    super("ModUpload")
  }

  
      
/**
 * If true, this file has been claimed by a user
 */
      get claimed(): $Field<"claimed", boolean | null | undefined>  {
       return this.$_select("claimed") as any
      }

      
/**
 * If true, the content preview has been generated for this upload
 */
      get contentPreviewGenerated(): $Field<"contentPreviewGenerated", boolean | null | undefined>  {
       return this.$_select("contentPreviewGenerated") as any
      }

      
/**
 * Time of when this upload was first created.
 */
      get createdAt(): $Field<"createdAt", string>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this upload was discarded.
 */
      get discardedAt(): $Field<"discardedAt", string | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * If true, this file has been reassembled from the uploaded chunks
 */
      get fileChunksReassembled(): $Field<"fileChunksReassembled", boolean | null | undefined>  {
       return this.$_select("fileChunksReassembled") as any
      }

      
/**
 * Forms a composite key with the game_id
 */
      get fileId(): $Field<"fileId", number | null | undefined>  {
       return this.$_select("fileId") as any
      }

      
/**
 * A Game
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * The database ID for this upload.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The virus scanning status of this upload, provided by our internal virus scanning tools
 */
      get internalVirusScanStatus(): $Field<"internalVirusScanStatus", number | null | undefined>  {
       return this.$_select("internalVirusScanStatus") as any
      }

      
/**
 * The MD5 hash for this object in our object store
 */
      get md5(): $Field<"md5", string | null | undefined>  {
       return this.$_select("md5") as any
      }

      
/**
 * Files belonging to a mod
 */
      modFile<Sel extends Selection<ModFile>>(selectorFn: (s: ModFile) => [...Sel]):$Field<"modFile", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModFile)
      };
      return this.$_select("modFile", options as any) as any
    }
  

      
/**
 * The database ID for this mod.
 */
      get modId(): $Field<"modId", number | null | undefined>  {
       return this.$_select("modId") as any
      }

      
/**
 * If true, this file has been uploaded to object store
 */
      get s3UploadComplete(): $Field<"s3UploadComplete", boolean | null | undefined>  {
       return this.$_select("s3UploadComplete") as any
      }

      
/**
 * The URL for this object in our object store
 */
      get s3Url(): $Field<"s3Url", string | null | undefined>  {
       return this.$_select("s3Url") as any
      }

      
/**
 * The HAS256 hash for this object in our object store
 */
      get sha256(): $Field<"sha256", string | null | undefined>  {
       return this.$_select("sha256") as any
      }

      
/**
 * The size of this upload in bytes
 */
      get sizeBytes(): $Field<"sizeBytes", string | null | undefined>  {
       return this.$_select("sizeBytes") as any
      }

      
/**
 * System filename for this upload
 */
      get systemFileName(): $Field<"systemFileName", string | null | undefined>  {
       return this.$_select("systemFileName") as any
      }

      
/**
 * Temporary filename for this upload
 */
      get tempFileName(): $Field<"tempFileName", string>  {
       return this.$_select("tempFileName") as any
      }

      
/**
 * Time of when this upload was last updated.
 */
      get updatedAt(): $Field<"updatedAt", string>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Type of upload
 */
      get uploadType(): $Field<"uploadType", string | null | undefined>  {
       return this.$_select("uploadType") as any
      }

      
/**
 * A Nexus Mods user
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * Number of positive reports from VirusTotal
 */
      get virusTotalPositives(): $Field<"virusTotalPositives", number | null | undefined>  {
       return this.$_select("virusTotalPositives") as any
      }

      
/**
 * The virus scanning status of this upload, provided by VirusTotal
 */
      get virusTotalStatus(): $Field<"virusTotalStatus", number | null | undefined>  {
       return this.$_select("virusTotalStatus") as any
      }

      
/**
 * The URL of the VirusTotal report for this upload
 */
      get virusTotalUrl(): $Field<"virusTotalUrl", string | null | undefined>  {
       return this.$_select("virusTotalUrl") as any
      }
}

  
/**
 * Moderatable Model Types
 */
export enum Moderatable {
  
/**
 * A nexusmods Collection of Mods
 */
  Collection = "Collection"
}
  


/**
 * Autogenerated return type of ModerateMutation.
 */
export class ModerateMutationPayload extends $Base<"ModerateMutationPayload"> {
  constructor() {
    super("ModerateMutationPayload")
  }

  
      
/**
 * Return the moderation type
 */
      moderation<Sel extends Selection<Moderation>>(selectorFn: (s: Moderation) => [...Sel]):$Field<"moderation", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Moderation)
      };
      return this.$_select("moderation", options as any) as any
    }
  

      
/**
 * if true, this entity is put into moderation
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A moderation entry
 */
export class Moderation extends $Base<"Moderation"> {
  constructor() {
    super("Moderation")
  }

  
      
/**
 * Time of when this moderation was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * If true, this moderation entry can be edited
 */
      get editable(): $Field<"editable", boolean>  {
       return this.$_select("editable") as any
      }

      
/**
 * The database ID for this moderation.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Polymorphic ID of the entity that is being moderated
 */
      get moderatableId(): $Field<"moderatableId", string>  {
       return this.$_select("moderatableId") as any
      }

      
/**
 * Polymorphic Type of the entity that is being moderated
 */
      get moderatableType(): $Field<"moderatableType", Moderatable>  {
       return this.$_select("moderatableType") as any
      }

      
/**
 * Array of fixes applied for this
moderation
 */
      moderationFixes<Sel extends Selection<ModerationFix>>(selectorFn: (s: ModerationFix) => [...Sel]):$Field<"moderationFixes", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationFix)
      };
      return this.$_select("moderationFixes", options as any) as any
    }
  

      
/**
 * Reason for placing this entity
into moderation
 */
      moderationReason<Sel extends Selection<ModerationReason>>(selectorFn: (s: ModerationReason) => [...Sel]):$Field<"moderationReason", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationReason)
      };
      return this.$_select("moderationReason", options as any) as any
    }
  

      
/**
 * The database ID for this staff member.
 */
      get staffId(): $Field<"staffId", string>  {
       return this.$_select("staffId") as any
      }

      
/**
 * Content for the staff note
 */
      get staffNote(): $Field<"staffNote", string | null | undefined>  {
       return this.$_select("staffNote") as any
      }

      
/**
 * Date this entity was unlocked
 */
      get unlockedAt(): $Field<"unlockedAt", DateTime | null | undefined>  {
       return this.$_select("unlockedAt") as any
      }

      
/**
 * User that unlocked this entity
 */
      get unlockedBy(): $Field<"unlockedBy", string | null | undefined>  {
       return this.$_select("unlockedBy") as any
      }

      
/**
 * Content for the message to show when unlocked
 */
      get unlockedNote(): $Field<"unlockedNote", string | null | undefined>  {
       return this.$_select("unlockedNote") as any
      }

      
/**
 * Time of when this moderation was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }

      
/**
 * Staff member that put this entity into moderation
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * Content for the user note
 */
      get userNote(): $Field<"userNote", string | null | undefined>  {
       return this.$_select("userNote") as any
      }
}


/**
 * A moderation fix submission
 */
export class ModerationFix extends $Base<"ModerationFix"> {
  constructor() {
    super("ModerationFix")
  }

  
      
/**
 * User who authored this moderation fix
 */
      author<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"author", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("author", options as any) as any
    }
  

      
/**
 * ID of the user who authored this moderation fix
 */
      get authorId(): $Field<"authorId", string>  {
       return this.$_select("authorId") as any
      }

      
/**
 * Time of when this moderation fix was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Description of this moderation fix
 */
      get description(): $Field<"description", string | null | undefined>  {
       return this.$_select("description") as any
      }

      
/**
 * The database ID for this moderation fix.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Type of moderation fix
 */
      moderation<Sel extends Selection<Moderation>>(selectorFn: (s: Moderation) => [...Sel]):$Field<"moderation", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Moderation)
      };
      return this.$_select("moderation", options as any) as any
    }
  

      
/**
 * Status of this moderation fix
 */
      get status(): $Field<"status", ModerationFixStatus>  {
       return this.$_select("status") as any
      }

      
/**
 * Time of when this moderation fix was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}

  
/**
 * Available moderation fix statuses
 */
export enum ModerationFixStatus {
  
/**
 * Awaiting an Admin's approval
 */
  submitted = "submitted",

/**
 * An Admin has accepted this fix
 */
  accepted = "accepted",

/**
 * An Admin has rejected this fix
 */
  rejected = "rejected"
}
  


/**
 * A moderation reason
 */
export class ModerationReason extends $Base<"ModerationReason"> {
  constructor() {
    super("ModerationReason")
  }

  
      
/**
 * Time of when this moderation reason was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The database ID for this moderation reason.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Reason for moderation
 */
      get reason(): $Field<"reason", string>  {
       return this.$_select("reason") as any
      }

      
/**
 * Resolution of the moderation
 */
      get resolution(): $Field<"resolution", string | null | undefined>  {
       return this.$_select("resolution") as any
      }

      
/**
 * Time of when this moderation reason was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * A moderation restriction
 */
export type ModerationRestrictionInput = {
  gameId?: string | null | undefined,
modId?: string | null | undefined,
restriction: ModerationRestrictions,
timeframe: number
}
    

  
/**
 * Moderation restriction types
 */
export enum ModerationRestrictions {
  
  FILE_UPLOAD = "FILE_UPLOAD",

  MOD_TOOLS = "MOD_TOOLS",

  FILE_DOWNLOAD = "FILE_DOWNLOAD",

  POST = "POST",

  COMMENT_FILE = "COMMENT_FILE",

  IMAGE_UPLOAD = "IMAGE_UPLOAD",

  ENDORSE_MOD = "ENDORSE_MOD",

  ENDORSE_MEDIA = "ENDORSE_MEDIA",

  BLOCK_PM = "BLOCK_PM",

  ADD_VIDEOS = "ADD_VIDEOS"
}
  


/**
 * A moderation_warning
 */
export class ModerationWarning extends $Base<"ModerationWarning"> {
  constructor() {
    super("ModerationWarning")
  }

  
      
/**
 * Category Id
 */
      get category(): $Field<"category", ModerationWarningCategoryEnum>  {
       return this.$_select("category") as any
      }

      
/**
 * Unix timestamp of moderation warning date
 */
      get date(): $Field<"date", number>  {
       return this.$_select("date") as any
      }

      
/**
 * The database ID for this moderation warning.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Has been read
 */
      get isRead(): $Field<"isRead", boolean>  {
       return this.$_select("isRead") as any
      }

      
/**
 * Moderation warning link
 */
      get link(): $Field<"link", string>  {
       return this.$_select("link") as any
      }

      
/**
 * A moderation restriction
 */
      moderationWarningRestrictions<Args extends VariabledInput<{
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<ModerationWarningRestrictionConnection>>(args: ExactArgNames<Args, {
        after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: ModerationWarningRestrictionConnection) => [...Sel]):$Field<"moderationWarningRestrictions", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
moderationWarningRestrictions<Sel extends Selection<ModerationWarningRestrictionConnection>>(selectorFn: (s: ModerationWarningRestrictionConnection) => [...Sel]):$Field<"moderationWarningRestrictions", GetOutput<Sel> | undefined , GetVariables<Sel>>
moderationWarningRestrictions(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new ModerationWarningRestrictionConnection)
      };
      return this.$_select("moderationWarningRestrictions", options as any) as any
    }
  

      
/**
 * Forum post linked to warning
 */
      post<Sel extends Selection<ForumPost>>(selectorFn: (s: ForumPost) => [...Sel]):$Field<"post", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ForumPost)
      };
      return this.$_select("post", options as any) as any
    }
  

      
/**
 * Post id of moderation warning
 */
      get postId(): $Field<"postId", string | null | undefined>  {
       return this.$_select("postId") as any
      }

      
/**
 * Public reason
 */
      get publicReason(): $Field<"publicReason", string | null | undefined>  {
       return this.$_select("publicReason") as any
      }

      
/**
 * Reason for moderation warning
 */
      get reason(): $Field<"reason", string>  {
       return this.$_select("reason") as any
      }

      
/**
 * User id who removed moderation warning
 */
      get removedBy(): $Field<"removedBy", string | null | undefined>  {
       return this.$_select("removedBy") as any
      }

      
/**
 * Removed date of moderation warning
 */
      get removedDate(): $Field<"removedDate", number | null | undefined>  {
       return this.$_select("removedDate") as any
      }

      
/**
 * Removed reason
 */
      get removedReason(): $Field<"removedReason", string | null | undefined>  {
       return this.$_select("removedReason") as any
      }

      
/**
 * Issuer of warning
 */
      staff<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"staff", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("staff", options as any) as any
    }
  

      
/**
 * User warning has been applied to
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  
}

  
/**
 * Moderation warning category types.
 */
export enum ModerationWarningCategoryEnum {
  
  INFORMAL_WARNING = "INFORMAL_WARNING",

  FORMAL_WARNING = "FORMAL_WARNING",

  BAN = "BAN",

  UNBAN = "UNBAN",

  CLOSE_ACCOUNT = "CLOSE_ACCOUNT",

  AUTOMATIC_MESSAGE = "AUTOMATIC_MESSAGE",

  MANUAL_MESSAGE = "MANUAL_MESSAGE"
}
  


/**
 * The connection type for ModerationWarning.
 */
export class ModerationWarningConnection extends $Base<"ModerationWarningConnection"> {
  constructor() {
    super("ModerationWarningConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<ModerationWarningEdge>>(selectorFn: (s: ModerationWarningEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarningEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<ModerationWarning>>(selectorFn: (s: ModerationWarning) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarning)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class ModerationWarningEdge extends $Base<"ModerationWarningEdge"> {
  constructor() {
    super("ModerationWarningEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<ModerationWarning>>(selectorFn: (s: ModerationWarning) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarning)
      };
      return this.$_select("node", options as any) as any
    }
  
}


/**
 * A moderation restriction
 */
export class ModerationWarningRestriction extends $Base<"ModerationWarningRestriction"> {
  constructor() {
    super("ModerationWarningRestriction")
  }

  
      
/**
 * Duration of restriction
 */
      get duration(): $Field<"duration", number>  {
       return this.$_select("duration") as any
      }

      
/**
 * Restricted feature
 */
      get featureId(): $Field<"featureId", ModerationWarningRestrictionFeatureEnum | null | undefined>  {
       return this.$_select("featureId") as any
      }

      
/**
 * The database ID for this moderation restriction.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }
}


/**
 * The connection type for ModerationWarningRestriction.
 */
export class ModerationWarningRestrictionConnection extends $Base<"ModerationWarningRestrictionConnection"> {
  constructor() {
    super("ModerationWarningRestrictionConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<ModerationWarningRestrictionEdge>>(selectorFn: (s: ModerationWarningRestrictionEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarningRestrictionEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<ModerationWarningRestriction>>(selectorFn: (s: ModerationWarningRestriction) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarningRestriction)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class ModerationWarningRestrictionEdge extends $Base<"ModerationWarningRestrictionEdge"> {
  constructor() {
    super("ModerationWarningRestrictionEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<ModerationWarningRestriction>>(selectorFn: (s: ModerationWarningRestriction) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarningRestriction)
      };
      return this.$_select("node", options as any) as any
    }
  
}

  
/**
 * Moderation warning restriction feature types.
 */
export enum ModerationWarningRestrictionFeatureEnum {
  
  FileUpload = "FileUpload",

  ModTools = "ModTools",

  FileDownload = "FileDownload",

  Post = "Post",

  CommentFile = "CommentFile",

  ImageUpload = "ImageUpload",

  EndorseMod = "EndorseMod",

  EndorseImage = "EndorseImage",

  ChatBan = "ChatBan",

  BlockPM = "BlockPM",

  AddVideos = "AddVideos",

  EndorseVideos = "EndorseVideos"
}
  


/**
 * Autogenerated return type of ModifyImageForCollectionMutation.
 */
export class ModifyImageForCollectionMutationPayload extends $Base<"ModifyImageForCollectionMutationPayload"> {
  constructor() {
    super("ModifyImageForCollectionMutationPayload")
  }

  
      
/**
 * Image that was updated on the collection
 */
      image<Sel extends Selection<CollectionImage>>(selectorFn: (s: CollectionImage) => [...Sel]):$Field<"image", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionImage)
      };
      return this.$_select("image", options as any) as any
    }
  

      
/**
 * True when image was updated
 */
      get updated(): $Field<"updated", boolean>  {
       return this.$_select("updated") as any
      }
}


/**
 * Facet fields specific to the mods query.
 */
export type ModsFacet = {
  adult?: Readonly<Array<string>> | null | undefined,
categoryName?: Readonly<Array<string>> | null | undefined,
gameDomainName?: Readonly<Array<string>> | null | undefined,
gameId?: Readonly<Array<string>> | null | undefined,
gameName?: Readonly<Array<string>> | null | undefined,
languageName?: Readonly<Array<string>> | null | undefined,
status?: Readonly<Array<string>> | null | undefined,
tag?: Readonly<Array<string>> | null | undefined
}
    


/**
 * Filter fields specific to a Mods query
 */
export type ModsFilter = {
  adultContent?: Readonly<Array<BooleanFilterValue>> | null | undefined,
author?: Readonly<Array<BaseFilterValue>> | null | undefined,
categoryName?: Readonly<Array<BaseFilterValue>> | null | undefined,
createdAt?: Readonly<Array<BaseFilterValue>> | null | undefined,
description?: Readonly<Array<BaseFilterValueEqualsMatches>> | null | undefined,
downloads?: Readonly<Array<IntFilterValue>> | null | undefined,
endorsements?: Readonly<Array<IntFilterValue>> | null | undefined,
fileSize?: Readonly<Array<IntFilterValue>> | null | undefined,
filter?: Readonly<Array<ModsFilter>> | null | undefined,
gameDomainName?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameId?: Readonly<Array<BaseFilterValue>> | null | undefined,
gameName?: Readonly<Array<BaseFilterValue>> | null | undefined,
hasUpdated?: Readonly<Array<BooleanFilterValue>> | null | undefined,
languageName?: Readonly<Array<BaseFilterValue>> | null | undefined,
name?: Readonly<Array<BaseFilterValueEqualsWildcard>> | null | undefined,
nameStemmed?: Readonly<Array<BaseFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined,
primaryImage?: Readonly<Array<BaseFilterValue>> | null | undefined,
status?: Readonly<Array<BaseFilterValue>> | null | undefined,
supportsVortex?: Readonly<Array<BooleanFilterValue>> | null | undefined,
tag?: Readonly<Array<BaseFilterValue>> | null | undefined,
updatedAt?: Readonly<Array<BaseFilterValue>> | null | undefined,
uploader?: Readonly<Array<BaseFilterValue>> | null | undefined,
uploaderId?: Readonly<Array<BaseFilterValue>> | null | undefined
}
    


/**
 * Sort fields specific to a Mods query.
 */
export type ModsSort = {
  createdAt?: BaseSortValue | null | undefined,
downloads?: BaseSortValue | null | undefined,
endorsements?: BaseSortValue | null | undefined,
lastComment?: BaseSortValue | null | undefined,
name?: BaseSortValue | null | undefined,
random?: RandomSortValue | null | undefined,
relevance?: BaseSortValue | null | undefined,
size?: BaseSortValue | null | undefined,
uniqueDownloads?: BaseSortValue | null | undefined,
updatedAt?: BaseSortValue | null | undefined
}
    


/**
 * All mutations to update, create and delete data
 */
export class Mutation extends $Base<"Mutation"> {
  constructor() {
    super("Mutation")
  }

  
      
/**
 * Abstains from mod endorsement.
 */
      abstainFromModEndorsement<Args extends VariabledInput<{
        modUid: string,
      }>,Sel extends Selection<AbstainFromModEndorsementMutationPayload>>(args: ExactArgNames<Args, {
        modUid: string,
      }>, selectorFn: (s: AbstainFromModEndorsementMutationPayload) => [...Sel]):$Field<"abstainFromModEndorsement", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modUid: "String!"
            },
        args,

        selection: selectorFn(new AbstainFromModEndorsementMutationPayload)
      };
      return this.$_select("abstainFromModEndorsement", options as any) as any
    }
  

      
/**
 * Marks the fix as accepted and takes the collection out of moderation.
Only collection moderators can call this mutation
 */
      acceptModerationFix<Args extends VariabledInput<{
        moderationFixId: string,
      }>,Sel extends Selection<AcceptModerationFixMutationPayload>>(args: ExactArgNames<Args, {
        moderationFixId: string,
      }>, selectorFn: (s: AcceptModerationFixMutationPayload) => [...Sel]):$Field<"acceptModerationFix", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              moderationFixId: "ID!"
            },
        args,

        selection: selectorFn(new AcceptModerationFixMutationPayload)
      };
      return this.$_select("acceptModerationFix", options as any) as any
    }
  

      
/**
 * Adds a badge to a collection.
 */
      addBadgeToCollection<Args extends VariabledInput<{
        badgeId: string
collectionId: number,
      }>,Sel extends Selection<AddBadgeToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        badgeId: string
collectionId: number,
      }>, selectorFn: (s: AddBadgeToCollectionMutationPayload) => [...Sel]):$Field<"addBadgeToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              badgeId: "ID!",
collectionId: "Int!"
            },
        args,

        selection: selectorFn(new AddBadgeToCollectionMutationPayload)
      };
      return this.$_select("addBadgeToCollection", options as any) as any
    }
  

      
/**
 * Adds a game to a user's favourites
 */
      addFavouriteGame<Args extends VariabledInput<{
        gameId: string,
      }>,Sel extends Selection<AddFavouriteGameMutationPayload>>(args: ExactArgNames<Args, {
        gameId: string,
      }>, selectorFn: (s: AddFavouriteGameMutationPayload) => [...Sel]):$Field<"addFavouriteGame", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              gameId: "ID!"
            },
        args,

        selection: selectorFn(new AddFavouriteGameMutationPayload)
      };
      return this.$_select("addFavouriteGame", options as any) as any
    }
  

      
/**
 * Adds a new header image to a collection
 */
      addHeaderImageToCollection<Args extends VariabledInput<{
        image: UploadImageInput
collectionId: string,
      }>,Sel extends Selection<AddHeaderImageToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        image: UploadImageInput
collectionId: string,
      }>, selectorFn: (s: AddHeaderImageToCollectionMutationPayload) => [...Sel]):$Field<"addHeaderImageToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              image: "UploadImageInput!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new AddHeaderImageToCollectionMutationPayload)
      };
      return this.$_select("addHeaderImageToCollection", options as any) as any
    }
  

      
/**
 * Adds a new image to a collection
 */
      addImageToCollection<Args extends VariabledInput<{
        image: UploadImageInput
collectionId: string
collectionRevisionId?: string | null | undefined,
      }>,Sel extends Selection<AddImageToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        image: UploadImageInput
collectionId: string
collectionRevisionId?: string | null | undefined,
      }>, selectorFn: (s: AddImageToCollectionMutationPayload) => [...Sel]):$Field<"addImageToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              image: "UploadImageInput!",
collectionId: "ID!",
collectionRevisionId: "ID"
            },
        args,

        selection: selectorFn(new AddImageToCollectionMutationPayload)
      };
      return this.$_select("addImageToCollection", options as any) as any
    }
  

      
/**
 * Adds a tag to a collection. User must have the `collection:add_tag` permission
 */
      addTagToCollection<Args extends VariabledInput<{
        tagIds: Readonly<Array<string>>
collectionId: number,
      }>,Sel extends Selection<AddTagToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        tagIds: Readonly<Array<string>>
collectionId: number,
      }>, selectorFn: (s: AddTagToCollectionMutationPayload) => [...Sel]):$Field<"addTagToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              tagIds: "[ID!]!",
collectionId: "Int!"
            },
        args,

        selection: selectorFn(new AddTagToCollectionMutationPayload)
      };
      return this.$_select("addTagToCollection", options as any) as any
    }
  

      
/**
 * Adds a new tile image to a collection
 */
      addTileImageToCollection<Args extends VariabledInput<{
        image: UploadImageInput
collectionId: string,
      }>,Sel extends Selection<AddTileImageToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        image: UploadImageInput
collectionId: string,
      }>, selectorFn: (s: AddTileImageToCollectionMutationPayload) => [...Sel]):$Field<"addTileImageToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              image: "UploadImageInput!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new AddTileImageToCollectionMutationPayload)
      };
      return this.$_select("addTileImageToCollection", options as any) as any
    }
  

      
/**
 * Adds a new image to a collection
 */
      addVideoToCollection<Args extends VariabledInput<{
        video: UploadVideoInput
collectionId: string
collectionRevisionId?: string | null | undefined,
      }>,Sel extends Selection<AddVideoToCollectionMutationPayload>>(args: ExactArgNames<Args, {
        video: UploadVideoInput
collectionId: string
collectionRevisionId?: string | null | undefined,
      }>, selectorFn: (s: AddVideoToCollectionMutationPayload) => [...Sel]):$Field<"addVideoToCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              video: "UploadVideoInput!",
collectionId: "ID!",
collectionRevisionId: "ID"
            },
        args,

        selection: selectorFn(new AddVideoToCollectionMutationPayload)
      };
      return this.$_select("addVideoToCollection", options as any) as any
    }
  

      
/**
 * Updates existing Moderation entity. Used to update details about the moderation or to unlock it.
 */
      amendModeration<Args extends VariabledInput<{
        id: string
userNote?: string | null | undefined
staffNote?: string | null | undefined
editable?: boolean | null | undefined
unlocked?: boolean | null | undefined
unlockedNote?: string | null | undefined
collectionStatus?: CollectionStatus | null | undefined
moderationReasonId?: string | null | undefined,
      }>,Sel extends Selection<AmendModerationMutationPayload>>(args: ExactArgNames<Args, {
        id: string
userNote?: string | null | undefined
staffNote?: string | null | undefined
editable?: boolean | null | undefined
unlocked?: boolean | null | undefined
unlockedNote?: string | null | undefined
collectionStatus?: CollectionStatus | null | undefined
moderationReasonId?: string | null | undefined,
      }>, selectorFn: (s: AmendModerationMutationPayload) => [...Sel]):$Field<"amendModeration", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!",
userNote: "String",
staffNote: "String",
editable: "Boolean",
unlocked: "Boolean",
unlockedNote: "String",
collectionStatus: "CollectionStatus",
moderationReasonId: "ID"
            },
        args,

        selection: selectorFn(new AmendModerationMutationPayload)
      };
      return this.$_select("amendModeration", options as any) as any
    }
  

      
/**
 * Ignores a specific user for the current user.
 */
      blockAuthor<Args extends VariabledInput<{
        userName?: string | null | undefined
userId?: string | null | undefined
authorName?: string | null | undefined
authorId?: string | null | undefined,
      }>,Sel extends Selection<BlockUserMutationPayload>>(args: ExactArgNames<Args, {
        userName?: string | null | undefined
userId?: string | null | undefined
authorName?: string | null | undefined
authorId?: string | null | undefined,
      }>, selectorFn: (s: BlockUserMutationPayload) => [...Sel]):$Field<"blockAuthor", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
blockAuthor<Sel extends Selection<BlockUserMutationPayload>>(selectorFn: (s: BlockUserMutationPayload) => [...Sel]):$Field<"blockAuthor", GetOutput<Sel> | undefined , GetVariables<Sel>>
blockAuthor(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userName: "String",
userId: "ID",
authorName: "String",
authorId: "ID"
            },
        args,

        selection: selectorFn(new BlockUserMutationPayload)
      };
      return this.$_select("blockAuthor", options as any) as any
    }
  

      
/**
 * Allows the current user to block all of a user's existing mods from earning DP.
 */
      blockModsFromEarningDp<Args extends VariabledInput<{
        userId?: string | null | undefined,
      }>,Sel extends Selection<BlockModsFromEarningDpMutationPayload>>(args: ExactArgNames<Args, {
        userId?: string | null | undefined,
      }>, selectorFn: (s: BlockModsFromEarningDpMutationPayload) => [...Sel]):$Field<"blockModsFromEarningDp", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
blockModsFromEarningDp<Sel extends Selection<BlockModsFromEarningDpMutationPayload>>(selectorFn: (s: BlockModsFromEarningDpMutationPayload) => [...Sel]):$Field<"blockModsFromEarningDp", GetOutput<Sel> | undefined , GetVariables<Sel>>
blockModsFromEarningDp(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userId: "ID"
            },
        args,

        selection: selectorFn(new BlockModsFromEarningDpMutationPayload)
      };
      return this.$_select("blockModsFromEarningDp", options as any) as any
    }
  

      
/**
 * Blocks a specific tag for the current user.
 */
      blockTag<Args extends VariabledInput<{
        tagId: string,
      }>,Sel extends Selection<BlockTagMutationPayload>>(args: ExactArgNames<Args, {
        tagId: string,
      }>, selectorFn: (s: BlockTagMutationPayload) => [...Sel]):$Field<"blockTag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              tagId: "ID!"
            },
        args,

        selection: selectorFn(new BlockTagMutationPayload)
      };
      return this.$_select("blockTag", options as any) as any
    }
  

      
/**
 * Changes a collection owner.
 */
      changeCollectionOwner<Args extends VariabledInput<{
        collectionId: string
ownerId: string,
      }>,Sel extends Selection<ChangeCollectionOwnerPayload>>(args: ExactArgNames<Args, {
        collectionId: string
ownerId: string,
      }>, selectorFn: (s: ChangeCollectionOwnerPayload) => [...Sel]):$Field<"changeCollectionOwner", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!",
ownerId: "ID!"
            },
        args,

        selection: selectorFn(new ChangeCollectionOwnerPayload)
      };
      return this.$_select("changeCollectionOwner", options as any) as any
    }
  

      
/**
 * Clears the status of an existing bug report on a collection
 */
      clearCollectionBugReportModerationStatus<Args extends VariabledInput<{
        bugReportId: string,
      }>,Sel extends Selection<ClearCollectionBugReportModerationStatusMutationPayload>>(args: ExactArgNames<Args, {
        bugReportId: string,
      }>, selectorFn: (s: ClearCollectionBugReportModerationStatusMutationPayload) => [...Sel]):$Field<"clearCollectionBugReportModerationStatus", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!"
            },
        args,

        selection: selectorFn(new ClearCollectionBugReportModerationStatusMutationPayload)
      };
      return this.$_select("clearCollectionBugReportModerationStatus", options as any) as any
    }
  

      
/**
 * Clears the moderation status of a comment.
 */
      clearCommentModerationStatus<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<ClearCommentModerationStatusMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: ClearCommentModerationStatusMutationPayload) => [...Sel]):$Field<"clearCommentModerationStatus", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new ClearCommentModerationStatusMutationPayload)
      };
      return this.$_select("clearCommentModerationStatus", options as any) as any
    }
  

      
/**
 * Clears the moderation status of a comment thread.
 */
      clearCommentThreadModerationStatus<Args extends VariabledInput<{
        commentThreadId: string,
      }>,Sel extends Selection<ClearThreadModerationStatusMutationPayload>>(args: ExactArgNames<Args, {
        commentThreadId: string,
      }>, selectorFn: (s: ClearThreadModerationStatusMutationPayload) => [...Sel]):$Field<"clearCommentThreadModerationStatus", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentThreadId: "ID!"
            },
        args,

        selection: selectorFn(new ClearThreadModerationStatusMutationPayload)
      };
      return this.$_select("clearCommentThreadModerationStatus", options as any) as any
    }
  

      
/**
 * Marks a collection bug report as closed. Can be called by the reporter or the collection curator, but only the curator can specify a closure_reason
 */
      closeCollectionBugReport<Args extends VariabledInput<{
        bugReportId: string
closureReason: BugReportClosureReason,
      }>,Sel extends Selection<CloseCollectionBugReportMutationPayload>>(args: ExactArgNames<Args, {
        bugReportId: string
closureReason: BugReportClosureReason,
      }>, selectorFn: (s: CloseCollectionBugReportMutationPayload) => [...Sel]):$Field<"closeCollectionBugReport", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!",
closureReason: "BugReportClosureReason!"
            },
        args,

        selection: selectorFn(new CloseCollectionBugReportMutationPayload)
      };
      return this.$_select("closeCollectionBugReport", options as any) as any
    }
  

      
/**
 * Creates an API Key for a user
 */
      createApiKey<Args extends VariabledInput<{
        applicationId?: string | null | undefined,
      }>,Sel extends Selection<CreateApiKeyMutationPayload>>(args: ExactArgNames<Args, {
        applicationId?: string | null | undefined,
      }>, selectorFn: (s: CreateApiKeyMutationPayload) => [...Sel]):$Field<"createApiKey", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
createApiKey<Sel extends Selection<CreateApiKeyMutationPayload>>(selectorFn: (s: CreateApiKeyMutationPayload) => [...Sel]):$Field<"createApiKey", GetOutput<Sel> | undefined , GetVariables<Sel>>
createApiKey(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              applicationId: "ID"
            },
        args,

        selection: selectorFn(new CreateApiKeyMutationPayload)
      };
      return this.$_select("createApiKey", options as any) as any
    }
  

      
/**
 * Creates a revision changelog entry
 */
      createChangelog<Args extends VariabledInput<{
        revisionId: string
description: string,
      }>,Sel extends Selection<CreateChangelogMutationPayload>>(args: ExactArgNames<Args, {
        revisionId: string
description: string,
      }>, selectorFn: (s: CreateChangelogMutationPayload) => [...Sel]):$Field<"createChangelog", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              revisionId: "ID!",
description: "String!"
            },
        args,

        selection: selectorFn(new CreateChangelogMutationPayload)
      };
      return this.$_select("createChangelog", options as any) as any
    }
  

      
/**
 * Create a new Collection. Must be passed the collection data from the manifest containing
  the manifest schema.
 */
      createCollection<Args extends VariabledInput<{
        collectionData: CollectionPayload
uuid: string,
      }>,Sel extends Selection<CreateCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionData: CollectionPayload
uuid: string,
      }>, selectorFn: (s: CreateCollectionMutationPayload) => [...Sel]):$Field<"createCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionData: "CollectionPayload!",
uuid: "String!"
            },
        args,

        selection: selectorFn(new CreateCollectionMutationPayload)
      };
      return this.$_select("createCollection", options as any) as any
    }
  

      
/**
 * Creates a new bug report for a collection
 */
      createCollectionBugReport<Args extends VariabledInput<{
        collectionId: string
collectionRevisionNumber: number
title: string
description?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>,Sel extends Selection<CreateCollectionBugReportMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string
collectionRevisionNumber: number
title: string
description?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>, selectorFn: (s: CreateCollectionBugReportMutationPayload) => [...Sel]):$Field<"createCollectionBugReport", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!",
collectionRevisionNumber: "Int!",
title: "String!",
description: "String",
attachmentIds: "[ID!]"
            },
        args,

        selection: selectorFn(new CreateCollectionBugReportMutationPayload)
      };
      return this.$_select("createCollectionBugReport", options as any) as any
    }
  

      
/**
 * Creates a comment.
 */
      createComment<Args extends VariabledInput<{
        commentThreadId: string
body: string
replyToId?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>,Sel extends Selection<CreateCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentThreadId: string
body: string
replyToId?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>, selectorFn: (s: CreateCommentMutationPayload) => [...Sel]):$Field<"createComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentThreadId: "ID!",
body: "String!",
replyToId: "ID",
attachmentIds: "[ID!]"
            },
        args,

        selection: selectorFn(new CreateCommentMutationPayload)
      };
      return this.$_select("createComment", options as any) as any
    }
  

      
/**
 * Create a new CSAM Deletion Request
 */
      createCsamDeletionRequest<Args extends VariabledInput<{
        csamUrls: string,
      }>,Sel extends Selection<CreateCsamDeletionRequestPayload>>(args: ExactArgNames<Args, {
        csamUrls: string,
      }>, selectorFn: (s: CreateCsamDeletionRequestPayload) => [...Sel]):$Field<"createCsamDeletionRequest", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              csamUrls: "String!"
            },
        args,

        selection: selectorFn(new CreateCsamDeletionRequestPayload)
      };
      return this.$_select("createCsamDeletionRequest", options as any) as any
    }
  

      
/**
 * Create a new message
 */
      createMessage<Args extends VariabledInput<{
        to: Readonly<Array<number>>
title: string
body: string,
      }>,Sel extends Selection<CreateMessagePayload>>(args: ExactArgNames<Args, {
        to: Readonly<Array<number>>
title: string
body: string,
      }>, selectorFn: (s: CreateMessagePayload) => [...Sel]):$Field<"createMessage", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              to: "[Int!]!",
title: "String!",
body: "String!"
            },
        args,

        selection: selectorFn(new CreateMessagePayload)
      };
      return this.$_select("createMessage", options as any) as any
    }
  

      
/**
 * Creates an endorsement for a mod.
 */
      createModEndorsement<Args extends VariabledInput<{
        modUid: string,
      }>,Sel extends Selection<CreateModEndorsementMutationPayload>>(args: ExactArgNames<Args, {
        modUid: string,
      }>, selectorFn: (s: CreateModEndorsementMutationPayload) => [...Sel]):$Field<"createModEndorsement", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modUid: "String!"
            },
        args,

        selection: selectorFn(new CreateModEndorsementMutationPayload)
      };
      return this.$_select("createModEndorsement", options as any) as any
    }
  

      
/**
 * Creates a moderation note about a user
 */
      createNoteAboutUser<Args extends VariabledInput<{
        userId: string
note: string,
      }>,Sel extends Selection<CreateNoteAboutUserMutationPayload>>(args: ExactArgNames<Args, {
        userId: string
note: string,
      }>, selectorFn: (s: CreateNoteAboutUserMutationPayload) => [...Sel]):$Field<"createNoteAboutUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              userId: "ID!",
note: "String!"
            },
        args,

        selection: selectorFn(new CreateNoteAboutUserMutationPayload)
      };
      return this.$_select("createNoteAboutUser", options as any) as any
    }
  

      
/**
 * Creates a new Collection Revision, or updates an existing Collection Revision (if a
  draft already exists )
 */
      createOrUpdateRevision<Args extends VariabledInput<{
        collectionData: CollectionPayload
collectionId: number
uuid: string,
      }>,Sel extends Selection<CreateOrUpdateRevisionMutationPayload>>(args: ExactArgNames<Args, {
        collectionData: CollectionPayload
collectionId: number
uuid: string,
      }>, selectorFn: (s: CreateOrUpdateRevisionMutationPayload) => [...Sel]):$Field<"createOrUpdateRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionData: "CollectionPayload!",
collectionId: "Int!",
uuid: "String!"
            },
        args,

        selection: selectorFn(new CreateOrUpdateRevisionMutationPayload)
      };
      return this.$_select("createOrUpdateRevision", options as any) as any
    }
  

      
/**
 * Creates a new collection Tag
 */
      createTag<Args extends VariabledInput<{
        name: string
categoryId?: string | null | undefined
gameIds?: Readonly<Array<string>> | null | undefined
global?: boolean | null | undefined
adult?: boolean | null | undefined,
      }>,Sel extends Selection<CreateTagMutationPayload>>(args: ExactArgNames<Args, {
        name: string
categoryId?: string | null | undefined
gameIds?: Readonly<Array<string>> | null | undefined
global?: boolean | null | undefined
adult?: boolean | null | undefined,
      }>, selectorFn: (s: CreateTagMutationPayload) => [...Sel]):$Field<"createTag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              name: "String!",
categoryId: "ID",
gameIds: "[ID!]",
global: "Boolean",
adult: "Boolean"
            },
        args,

        selection: selectorFn(new CreateTagMutationPayload)
      };
      return this.$_select("createTag", options as any) as any
    }
  

      
/**
 * Deletes a user's API Key
 */
      deleteApiKey<Args extends VariabledInput<{
        applicationId: string,
      }>,Sel extends Selection<DeleteApiKeyMutationPayload>>(args: ExactArgNames<Args, {
        applicationId: string,
      }>, selectorFn: (s: DeleteApiKeyMutationPayload) => [...Sel]):$Field<"deleteApiKey", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              applicationId: "ID!"
            },
        args,

        selection: selectorFn(new DeleteApiKeyMutationPayload)
      };
      return this.$_select("deleteApiKey", options as any) as any
    }
  

      
/**
 * Deletes a user's personal API Key
 */
      deletePersonalApiKey<Sel extends Selection<DeletePersonalApiKeyMutationPayload>>(selectorFn: (s: DeletePersonalApiKeyMutationPayload) => [...Sel]):$Field<"deletePersonalApiKey", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new DeletePersonalApiKeyMutationPayload)
      };
      return this.$_select("deletePersonalApiKey", options as any) as any
    }
  

      
/**
 * Discards an entire Collection and its associated entities
 */
      discardCollection<Args extends VariabledInput<{
        collectionId: string
reason: string,
      }>,Sel extends Selection<DiscardCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string
reason: string,
      }>, selectorFn: (s: DiscardCollectionMutationPayload) => [...Sel]):$Field<"discardCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!",
reason: "String!"
            },
        args,

        selection: selectorFn(new DiscardCollectionMutationPayload)
      };
      return this.$_select("discardCollection", options as any) as any
    }
  

      
/**
 * Discards a comment.
 */
      discardComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<DiscardCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: DiscardCommentMutationPayload) => [...Sel]):$Field<"discardComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new DiscardCommentMutationPayload)
      };
      return this.$_select("discardComment", options as any) as any
    }
  

      
/**
 * Discards a Collection Revision. Revision can only be discarded if it is a DRAFT or is not older than
24 hours and has no more than a 100 unique downloads.
 */
      discardRevision<Args extends VariabledInput<{
        collectionId: string
revisionNumber: number
reason?: string | null | undefined,
      }>,Sel extends Selection<DiscardRevisionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string
revisionNumber: number
reason?: string | null | undefined,
      }>, selectorFn: (s: DiscardRevisionMutationPayload) => [...Sel]):$Field<"discardRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!",
revisionNumber: "Int!",
reason: "String"
            },
        args,

        selection: selectorFn(new DiscardRevisionMutationPayload)
      };
      return this.$_select("discardRevision", options as any) as any
    }
  

      
/**
 * Removed an existing tag. User must have the `tag:discard` permission
 */
      discardTag<Args extends VariabledInput<{
        id: string,
      }>,Sel extends Selection<DiscardTagMutationPayload>>(args: ExactArgNames<Args, {
        id: string,
      }>, selectorFn: (s: DiscardTagMutationPayload) => [...Sel]):$Field<"discardTag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        selection: selectorFn(new DiscardTagMutationPayload)
      };
      return this.$_select("discardTag", options as any) as any
    }
  

      
/**
 * Updates the core details for a collection such as the name, description and category
 */
      editCollection<Args extends VariabledInput<{
        collectionId: number
name?: string | null | undefined
summary?: string | null | undefined
description?: string | null | undefined
categoryId?: string | null | undefined
allowUserMedia?: boolean | null | undefined
manuallyVerifyMedia?: boolean | null | undefined,
      }>,Sel extends Selection<EditCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: number
name?: string | null | undefined
summary?: string | null | undefined
description?: string | null | undefined
categoryId?: string | null | undefined
allowUserMedia?: boolean | null | undefined
manuallyVerifyMedia?: boolean | null | undefined,
      }>, selectorFn: (s: EditCollectionMutationPayload) => [...Sel]):$Field<"editCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "Int!",
name: "String",
summary: "String",
description: "String",
categoryId: "ID",
allowUserMedia: "Boolean",
manuallyVerifyMedia: "Boolean"
            },
        args,

        selection: selectorFn(new EditCollectionMutationPayload)
      };
      return this.$_select("editCollection", options as any) as any
    }
  

      
/**
 * Creates an endorsement for a generic Endorsable model. TODO: This will be moving to a
model-specific mutation
 */
      endorse<Args extends VariabledInput<{
        abstain?: boolean | null | undefined
modelId: number
modelType: string,
      }>,Sel extends Selection<CreateEndorsementMutationPayload>>(args: ExactArgNames<Args, {
        abstain?: boolean | null | undefined
modelId: number
modelType: string,
      }>, selectorFn: (s: CreateEndorsementMutationPayload) => [...Sel]):$Field<"endorse", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              abstain: "Boolean",
modelId: "Int!",
modelType: "String!"
            },
        args,

        selection: selectorFn(new CreateEndorsementMutationPayload)
      };
      return this.$_select("endorse", options as any) as any
    }
  

      
/**
 * Allows the current user to give kudos to another user
 */
      giveKudos<Args extends VariabledInput<{
        kudosUserId?: string | null | undefined,
      }>,Sel extends Selection<GiveKudosMutationPayload>>(args: ExactArgNames<Args, {
        kudosUserId?: string | null | undefined,
      }>, selectorFn: (s: GiveKudosMutationPayload) => [...Sel]):$Field<"giveKudos", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
giveKudos<Sel extends Selection<GiveKudosMutationPayload>>(selectorFn: (s: GiveKudosMutationPayload) => [...Sel]):$Field<"giveKudos", GetOutput<Sel> | undefined , GetVariables<Sel>>
giveKudos(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              kudosUserId: "ID"
            },
        args,

        selection: selectorFn(new GiveKudosMutationPayload)
      };
      return this.$_select("giveKudos", options as any) as any
    }
  

      
/**
 * Hides a bug report on a collection from public view
 */
      hideCollectionBugReport<Args extends VariabledInput<{
        bugReportId: string
reason?: string | null | undefined
internalReason?: string | null | undefined,
      }>,Sel extends Selection<HideCollectionBugReportMutationPayload>>(args: ExactArgNames<Args, {
        bugReportId: string
reason?: string | null | undefined
internalReason?: string | null | undefined,
      }>, selectorFn: (s: HideCollectionBugReportMutationPayload) => [...Sel]):$Field<"hideCollectionBugReport", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!",
reason: "String",
internalReason: "String"
            },
        args,

        selection: selectorFn(new HideCollectionBugReportMutationPayload)
      };
      return this.$_select("hideCollectionBugReport", options as any) as any
    }
  

      
/**
 * Hides a comment.
 */
      hideComment<Args extends VariabledInput<{
        commentId: string
reason: string
internalReason?: string | null | undefined,
      }>,Sel extends Selection<HideCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string
reason: string
internalReason?: string | null | undefined,
      }>, selectorFn: (s: HideCommentMutationPayload) => [...Sel]):$Field<"hideComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!",
reason: "String!",
internalReason: "String"
            },
        args,

        selection: selectorFn(new HideCommentMutationPayload)
      };
      return this.$_select("hideComment", options as any) as any
    }
  

      
/**
 * Ignores a specific user for the current user.
 */
      ignoreUser<Args extends VariabledInput<{
        userName?: string | null | undefined
userId?: string | null | undefined,
      }>,Sel extends Selection<IgnoreUserMutationPayload>>(args: ExactArgNames<Args, {
        userName?: string | null | undefined
userId?: string | null | undefined,
      }>, selectorFn: (s: IgnoreUserMutationPayload) => [...Sel]):$Field<"ignoreUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
ignoreUser<Sel extends Selection<IgnoreUserMutationPayload>>(selectorFn: (s: IgnoreUserMutationPayload) => [...Sel]):$Field<"ignoreUser", GetOutput<Sel> | undefined , GetVariables<Sel>>
ignoreUser(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userName: "String",
userId: "ID"
            },
        args,

        selection: selectorFn(new IgnoreUserMutationPayload)
      };
      return this.$_select("ignoreUser", options as any) as any
    }
  

      
/**
 * Issues a moderation warning to a user
 */
      issueWarningToUser<Args extends VariabledInput<{
        userId: string
warning: FormalOrInformalWarning
reason: string
publicReason?: string | null | undefined
referenceLinks?: Readonly<Array<string>> | null | undefined
commentId?: string | null | undefined
restrictions?: Readonly<Array<ModerationRestrictionInput>> | null | undefined,
      }>,Sel extends Selection<IssueWarningToUserMutationPayload>>(args: ExactArgNames<Args, {
        userId: string
warning: FormalOrInformalWarning
reason: string
publicReason?: string | null | undefined
referenceLinks?: Readonly<Array<string>> | null | undefined
commentId?: string | null | undefined
restrictions?: Readonly<Array<ModerationRestrictionInput>> | null | undefined,
      }>, selectorFn: (s: IssueWarningToUserMutationPayload) => [...Sel]):$Field<"issueWarningToUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              userId: "ID!",
warning: "FormalOrInformalWarning!",
reason: "String!",
publicReason: "String",
referenceLinks: "[String!]",
commentId: "ID",
restrictions: "[ModerationRestrictionInput!]"
            },
        args,

        selection: selectorFn(new IssueWarningToUserMutationPayload)
      };
      return this.$_select("issueWarningToUser", options as any) as any
    }
  

      
/**
 * Likes a comment.
 */
      likeComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<LikeCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: LikeCommentMutationPayload) => [...Sel]):$Field<"likeComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new LikeCommentMutationPayload)
      };
      return this.$_select("likeComment", options as any) as any
    }
  

      
/**
 * Sets a collection as `listed`. A collection can only be listed if there are published revisions.
User must have the `collection:set_status` permission
 */
      listCollection<Args extends VariabledInput<{
        collectionId: number,
      }>,Sel extends Selection<ListCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: number,
      }>, selectorFn: (s: ListCollectionMutationPayload) => [...Sel]):$Field<"listCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "Int!"
            },
        args,

        selection: selectorFn(new ListCollectionMutationPayload)
      };
      return this.$_select("listCollection", options as any) as any
    }
  

      
/**
 * Locks a comment.
 */
      lockComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<LockCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: LockCommentMutationPayload) => [...Sel]):$Field<"lockComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new LockCommentMutationPayload)
      };
      return this.$_select("lockComment", options as any) as any
    }
  

      
/**
 * Locks a comment thread.
 */
      lockCommentThread<Args extends VariabledInput<{
        commentThreadId: string,
      }>,Sel extends Selection<LockThreadMutationPayload>>(args: ExactArgNames<Args, {
        commentThreadId: string,
      }>, selectorFn: (s: LockThreadMutationPayload) => [...Sel]):$Field<"lockCommentThread", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentThreadId: "ID!"
            },
        args,

        selection: selectorFn(new LockThreadMutationPayload)
      };
      return this.$_select("lockCommentThread", options as any) as any
    }
  

      
/**
 * Sets a collection as `under_moderation`, allowing the user to provide a reason and the
ability to 'lock' the collection against future editing. User must have the `collection:moderate` permission.
 */
      moderate<Args extends VariabledInput<{
        id: string
type: Moderatable
userNote?: string | null | undefined
staffNote?: string | null | undefined
editable?: boolean | null | undefined
moderationReasonId: string,
      }>,Sel extends Selection<ModerateMutationPayload>>(args: ExactArgNames<Args, {
        id: string
type: Moderatable
userNote?: string | null | undefined
staffNote?: string | null | undefined
editable?: boolean | null | undefined
moderationReasonId: string,
      }>, selectorFn: (s: ModerateMutationPayload) => [...Sel]):$Field<"moderate", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!",
type: "Moderatable!",
userNote: "String",
staffNote: "String",
editable: "Boolean",
moderationReasonId: "ID!"
            },
        args,

        selection: selectorFn(new ModerateMutationPayload)
      };
      return this.$_select("moderate", options as any) as any
    }
  

      
/**
 * Updates an image on a collection
 */
      modifyImageForCollection<Args extends VariabledInput<{
        image: UpdateImageInput
collectionId: string,
      }>,Sel extends Selection<ModifyImageForCollectionMutationPayload>>(args: ExactArgNames<Args, {
        image: UpdateImageInput
collectionId: string,
      }>, selectorFn: (s: ModifyImageForCollectionMutationPayload) => [...Sel]):$Field<"modifyImageForCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              image: "UpdateImageInput!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new ModifyImageForCollectionMutationPayload)
      };
      return this.$_select("modifyImageForCollection", options as any) as any
    }
  

      
/**
 * Re-opens a previously closed bug report. Can be called by the report or the collection curator
 */
      openCollectionBugReport<Args extends VariabledInput<{
        bugReportId: string,
      }>,Sel extends Selection<OpenCollectionBugReportMutationPayload>>(args: ExactArgNames<Args, {
        bugReportId: string,
      }>, selectorFn: (s: OpenCollectionBugReportMutationPayload) => [...Sel]):$Field<"openCollectionBugReport", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!"
            },
        args,

        selection: selectorFn(new OpenCollectionBugReportMutationPayload)
      };
      return this.$_select("openCollectionBugReport", options as any) as any
    }
  

      
/**
 * Pins a comment. User must have the `comment:pin?` permission
 */
      pinComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<PinCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: PinCommentMutationPayload) => [...Sel]):$Field<"pinComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new PinCommentMutationPayload)
      };
      return this.$_select("pinComment", options as any) as any
    }
  

      
/**
 * Publishes a Collection Revision
 */
      publishRevision<Args extends VariabledInput<{
        revisionId: string
collectionStatus?: CollectionStatus | null | undefined
hasAdultResources?: boolean | null | undefined,
      }>,Sel extends Selection<PublishRevisionMutationPayload>>(args: ExactArgNames<Args, {
        revisionId: string
collectionStatus?: CollectionStatus | null | undefined
hasAdultResources?: boolean | null | undefined,
      }>, selectorFn: (s: PublishRevisionMutationPayload) => [...Sel]):$Field<"publishRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              revisionId: "ID!",
collectionStatus: "CollectionStatus",
hasAdultResources: "Boolean"
            },
        args,

        selection: selectorFn(new PublishRevisionMutationPayload)
      };
      return this.$_select("publishRevision", options as any) as any
    }
  

      
/**
 * Votes for a generic Rateable model. TODO: This will be moved to model-specific mutations
 */
      rate<Args extends VariabledInput<{
        id: string
type: Ratable
rating: RatingOptions,
      }>,Sel extends Selection<CreateRatingMutationPayload>>(args: ExactArgNames<Args, {
        id: string
type: Ratable
rating: RatingOptions,
      }>, selectorFn: (s: CreateRatingMutationPayload) => [...Sel]):$Field<"rate", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!",
type: "Ratable!",
rating: "RatingOptions!"
            },
        args,

        selection: selectorFn(new CreateRatingMutationPayload)
      };
      return this.$_select("rate", options as any) as any
    }
  

      
/**
 * Marks the moderation fix as rejected. The collection status is not changed.
Only collection moderators can call this mutation
 */
      rejectModerationFix<Args extends VariabledInput<{
        moderationFixId: string,
      }>,Sel extends Selection<RejectModerationFixMutationPayload>>(args: ExactArgNames<Args, {
        moderationFixId: string,
      }>, selectorFn: (s: RejectModerationFixMutationPayload) => [...Sel]):$Field<"rejectModerationFix", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              moderationFixId: "ID!"
            },
        args,

        selection: selectorFn(new RejectModerationFixMutationPayload)
      };
      return this.$_select("rejectModerationFix", options as any) as any
    }
  

      
/**
 * Removes a badge from a collection.
 */
      removeBadgeFromCollection<Args extends VariabledInput<{
        badgeId: string
collectionId: number,
      }>,Sel extends Selection<RemoveBadgeFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        badgeId: string
collectionId: number,
      }>, selectorFn: (s: RemoveBadgeFromCollectionMutationPayload) => [...Sel]):$Field<"removeBadgeFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              badgeId: "ID!",
collectionId: "Int!"
            },
        args,

        selection: selectorFn(new RemoveBadgeFromCollectionMutationPayload)
      };
      return this.$_select("removeBadgeFromCollection", options as any) as any
    }
  

      
/**
 * Removes the current user's like from a comment.
 */
      removeCommentLike<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<RemoveCommentLikeMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: RemoveCommentLikeMutationPayload) => [...Sel]):$Field<"removeCommentLike", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveCommentLikeMutationPayload)
      };
      return this.$_select("removeCommentLike", options as any) as any
    }
  

      
/**
 * Removes a game from a user's favourites
 */
      removeFavouriteGame<Args extends VariabledInput<{
        gameId: string,
      }>,Sel extends Selection<RemoveFavouriteGameMutationPayload>>(args: ExactArgNames<Args, {
        gameId: string,
      }>, selectorFn: (s: RemoveFavouriteGameMutationPayload) => [...Sel]):$Field<"removeFavouriteGame", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              gameId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveFavouriteGameMutationPayload)
      };
      return this.$_select("removeFavouriteGame", options as any) as any
    }
  

      
/**
 * Removes a header image from a Collection
 */
      removeHeaderImageFromCollection<Args extends VariabledInput<{
        collectionId: string,
      }>,Sel extends Selection<RemoveHeaderImageFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string,
      }>, selectorFn: (s: RemoveHeaderImageFromCollectionMutationPayload) => [...Sel]):$Field<"removeHeaderImageFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveHeaderImageFromCollectionMutationPayload)
      };
      return this.$_select("removeHeaderImageFromCollection", options as any) as any
    }
  

      
/**
 * Removes an image from a Collection
 */
      removeImageFromCollection<Args extends VariabledInput<{
        imageId: string
collectionId: string,
      }>,Sel extends Selection<RemoveImageFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        imageId: string
collectionId: string,
      }>, selectorFn: (s: RemoveImageFromCollectionMutationPayload) => [...Sel]):$Field<"removeImageFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              imageId: "ID!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveImageFromCollectionMutationPayload)
      };
      return this.$_select("removeImageFromCollection", options as any) as any
    }
  

      
/**
 * Allows the current user to remove kudos from another user
 */
      removeKudos<Args extends VariabledInput<{
        kudosUserId?: string | null | undefined,
      }>,Sel extends Selection<RemoveKudosMutationPayload>>(args: ExactArgNames<Args, {
        kudosUserId?: string | null | undefined,
      }>, selectorFn: (s: RemoveKudosMutationPayload) => [...Sel]):$Field<"removeKudos", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
removeKudos<Sel extends Selection<RemoveKudosMutationPayload>>(selectorFn: (s: RemoveKudosMutationPayload) => [...Sel]):$Field<"removeKudos", GetOutput<Sel> | undefined , GetVariables<Sel>>
removeKudos(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              kudosUserId: "ID"
            },
        args,

        selection: selectorFn(new RemoveKudosMutationPayload)
      };
      return this.$_select("removeKudos", options as any) as any
    }
  

      
/**
 * Removes tags from a collection
 */
      removeTagFromCollection<Args extends VariabledInput<{
        tagIds: Readonly<Array<string>>
collectionId: string,
      }>,Sel extends Selection<RemoveTagFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        tagIds: Readonly<Array<string>>
collectionId: string,
      }>, selectorFn: (s: RemoveTagFromCollectionMutationPayload) => [...Sel]):$Field<"removeTagFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              tagIds: "[ID!]!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveTagFromCollectionMutationPayload)
      };
      return this.$_select("removeTagFromCollection", options as any) as any
    }
  

      
/**
 * Removes a tile image from a Collection
 */
      removeTileImageFromCollection<Args extends VariabledInput<{
        collectionId: string,
      }>,Sel extends Selection<RemoveTileImageFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string,
      }>, selectorFn: (s: RemoveTileImageFromCollectionMutationPayload) => [...Sel]):$Field<"removeTileImageFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveTileImageFromCollectionMutationPayload)
      };
      return this.$_select("removeTileImageFromCollection", options as any) as any
    }
  

      
/**
 * Removes a video from a Collection
 */
      removeVideoFromCollection<Args extends VariabledInput<{
        videoId: string
collectionId: string,
      }>,Sel extends Selection<RemoveVideoFromCollectionMutationPayload>>(args: ExactArgNames<Args, {
        videoId: string
collectionId: string,
      }>, selectorFn: (s: RemoveVideoFromCollectionMutationPayload) => [...Sel]):$Field<"removeVideoFromCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              videoId: "ID!",
collectionId: "ID!"
            },
        args,

        selection: selectorFn(new RemoveVideoFromCollectionMutationPayload)
      };
      return this.$_select("removeVideoFromCollection", options as any) as any
    }
  

      
/**
 * Moves an item to a new position in a list.
 */
      reorderItem<Args extends VariabledInput<{
        id: string
targetId: string
location: ReorderLocation,
      }>,Sel extends Selection<ReorderItemPayload>>(args: ExactArgNames<Args, {
        id: string
targetId: string
location: ReorderLocation,
      }>, selectorFn: (s: ReorderItemPayload) => [...Sel]):$Field<"reorderItem", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!",
targetId: "ID!",
location: "ReorderLocation!"
            },
        args,

        selection: selectorFn(new ReorderItemPayload)
      };
      return this.$_select("reorderItem", options as any) as any
    }
  

      
/**
 * Reorders pinned comments. User must have the `comment:pin?` permission
 */
      reorderPinnedComments<Args extends VariabledInput<{
        commentIds: Readonly<Array<string>>,
      }>,Sel extends Selection<ReorderPinnedCommentsMutationPayload>>(args: ExactArgNames<Args, {
        commentIds: Readonly<Array<string>>,
      }>, selectorFn: (s: ReorderPinnedCommentsMutationPayload) => [...Sel]):$Field<"reorderPinnedComments", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentIds: "[ID!]!"
            },
        args,

        selection: selectorFn(new ReorderPinnedCommentsMutationPayload)
      };
      return this.$_select("reorderPinnedComments", options as any) as any
    }
  

      
/**
 * Restores a discarded comment.
 */
      restoreComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<RestoreCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: RestoreCommentMutationPayload) => [...Sel]):$Field<"restoreComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new RestoreCommentMutationPayload)
      };
      return this.$_select("restoreComment", options as any) as any
    }
  

      
/**
 * Retracts a Collection Revision. This keeps the revision listed and downloadable but marks it as
a revision that should not be used anymore.
 */
      retractRevision<Args extends VariabledInput<{
        revisionId: string
reason: string,
      }>,Sel extends Selection<RetractRevisionMutationPayload>>(args: ExactArgNames<Args, {
        revisionId: string
reason: string,
      }>, selectorFn: (s: RetractRevisionMutationPayload) => [...Sel]):$Field<"retractRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              revisionId: "ID!",
reason: "String!"
            },
        args,

        selection: selectorFn(new RetractRevisionMutationPayload)
      };
      return this.$_select("retractRevision", options as any) as any
    }
  

      
/**
 * Submits a moderation fix against a moderation that is pending acceptance
 */
      submitModerationFix<Args extends VariabledInput<{
        moderationId: string
description?: string | null | undefined,
      }>,Sel extends Selection<SubmitModerationFixMutationPayload>>(args: ExactArgNames<Args, {
        moderationId: string
description?: string | null | undefined,
      }>, selectorFn: (s: SubmitModerationFixMutationPayload) => [...Sel]):$Field<"submitModerationFix", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              moderationId: "ID!",
description: "String"
            },
        args,

        selection: selectorFn(new SubmitModerationFixMutationPayload)
      };
      return this.$_select("submitModerationFix", options as any) as any
    }
  

      
/**
 * Track desktop application events and metrics
 */
      trackAppMetric<Args extends VariabledInput<{
        eventType: AppMetricEventType
entityType: AppMetricEntityType
entityId: string
clientString?: string | null | undefined
metadata?: JSON | null | undefined,
      }>,Sel extends Selection<TrackAppMetricMutationPayload>>(args: ExactArgNames<Args, {
        eventType: AppMetricEventType
entityType: AppMetricEntityType
entityId: string
clientString?: string | null | undefined
metadata?: JSON | null | undefined,
      }>, selectorFn: (s: TrackAppMetricMutationPayload) => [...Sel]):$Field<"trackAppMetric", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              eventType: "AppMetricEventType!",
entityType: "AppMetricEntityType!",
entityId: "String!",
clientString: "String",
metadata: "JSON"
            },
        args,

        selection: selectorFn(new TrackAppMetricMutationPayload)
      };
      return this.$_select("trackAppMetric", options as any) as any
    }
  

      
/**
 * Allows the current user to track a mod
 */
      trackMod<Args extends VariabledInput<{
        modUid: string,
      }>,Sel extends Selection<TrackModMutationPayload>>(args: ExactArgNames<Args, {
        modUid: string,
      }>, selectorFn: (s: TrackModMutationPayload) => [...Sel]):$Field<"trackMod", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modUid: "ID!"
            },
        args,

        selection: selectorFn(new TrackModMutationPayload)
      };
      return this.$_select("trackMod", options as any) as any
    }
  

      
/**
 * Allows the current user to track another user
 */
      trackUser<Args extends VariabledInput<{
        trackedUserId?: string | null | undefined,
      }>,Sel extends Selection<TrackUserMutationPayload>>(args: ExactArgNames<Args, {
        trackedUserId?: string | null | undefined,
      }>, selectorFn: (s: TrackUserMutationPayload) => [...Sel]):$Field<"trackUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
trackUser<Sel extends Selection<TrackUserMutationPayload>>(selectorFn: (s: TrackUserMutationPayload) => [...Sel]):$Field<"trackUser", GetOutput<Sel> | undefined , GetVariables<Sel>>
trackUser(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              trackedUserId: "ID"
            },
        args,

        selection: selectorFn(new TrackUserMutationPayload)
      };
      return this.$_select("trackUser", options as any) as any
    }
  

      
/**
 * Unignore a specific author for the current user.
 */
      unblockAuthor<Args extends VariabledInput<{
        userName?: string | null | undefined
userId?: string | null | undefined
authorName?: string | null | undefined
authorId?: string | null | undefined,
      }>,Sel extends Selection<UnblockUserMutationPayload>>(args: ExactArgNames<Args, {
        userName?: string | null | undefined
userId?: string | null | undefined
authorName?: string | null | undefined
authorId?: string | null | undefined,
      }>, selectorFn: (s: UnblockUserMutationPayload) => [...Sel]):$Field<"unblockAuthor", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
unblockAuthor<Sel extends Selection<UnblockUserMutationPayload>>(selectorFn: (s: UnblockUserMutationPayload) => [...Sel]):$Field<"unblockAuthor", GetOutput<Sel> | undefined , GetVariables<Sel>>
unblockAuthor(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userName: "String",
userId: "ID",
authorName: "String",
authorId: "ID"
            },
        args,

        selection: selectorFn(new UnblockUserMutationPayload)
      };
      return this.$_select("unblockAuthor", options as any) as any
    }
  

      
/**
 * Allows the current user to unblock all of a user's existing mods from earning DP.
 */
      unblockModsFromEarningDp<Args extends VariabledInput<{
        userId?: string | null | undefined,
      }>,Sel extends Selection<UnblockModsFromEarningDpMutationPayload>>(args: ExactArgNames<Args, {
        userId?: string | null | undefined,
      }>, selectorFn: (s: UnblockModsFromEarningDpMutationPayload) => [...Sel]):$Field<"unblockModsFromEarningDp", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
unblockModsFromEarningDp<Sel extends Selection<UnblockModsFromEarningDpMutationPayload>>(selectorFn: (s: UnblockModsFromEarningDpMutationPayload) => [...Sel]):$Field<"unblockModsFromEarningDp", GetOutput<Sel> | undefined , GetVariables<Sel>>
unblockModsFromEarningDp(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userId: "ID"
            },
        args,

        selection: selectorFn(new UnblockModsFromEarningDpMutationPayload)
      };
      return this.$_select("unblockModsFromEarningDp", options as any) as any
    }
  

      
/**
 * Unblocks a specific tag for the current user.
 */
      unblockTag<Args extends VariabledInput<{
        tagId: string,
      }>,Sel extends Selection<UnblockTagMutationPayload>>(args: ExactArgNames<Args, {
        tagId: string,
      }>, selectorFn: (s: UnblockTagMutationPayload) => [...Sel]):$Field<"unblockTag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              tagId: "ID!"
            },
        args,

        selection: selectorFn(new UnblockTagMutationPayload)
      };
      return this.$_select("unblockTag", options as any) as any
    }
  

      
/**
 * Unignore a specific author for the current user.
 */
      unignoreUser<Args extends VariabledInput<{
        userName?: string | null | undefined
userId?: string | null | undefined,
      }>,Sel extends Selection<UnignoreUserMutationPayload>>(args: ExactArgNames<Args, {
        userName?: string | null | undefined
userId?: string | null | undefined,
      }>, selectorFn: (s: UnignoreUserMutationPayload) => [...Sel]):$Field<"unignoreUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
unignoreUser<Sel extends Selection<UnignoreUserMutationPayload>>(selectorFn: (s: UnignoreUserMutationPayload) => [...Sel]):$Field<"unignoreUser", GetOutput<Sel> | undefined , GetVariables<Sel>>
unignoreUser(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userName: "String",
userId: "ID"
            },
        args,

        selection: selectorFn(new UnignoreUserMutationPayload)
      };
      return this.$_select("unignoreUser", options as any) as any
    }
  

      
/**
 * Unlists a Collection Revision from the public Nexus Mods pages.
 */
      unlistCollection<Args extends VariabledInput<{
        collectionId: string,
      }>,Sel extends Selection<UnlistCollectionMutationPayload>>(args: ExactArgNames<Args, {
        collectionId: string,
      }>, selectorFn: (s: UnlistCollectionMutationPayload) => [...Sel]):$Field<"unlistCollection", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              collectionId: "ID!"
            },
        args,

        selection: selectorFn(new UnlistCollectionMutationPayload)
      };
      return this.$_select("unlistCollection", options as any) as any
    }
  

      
/**
 * Unpins a comment. User must have the `comment:unpin?` permission
 */
      unpinComment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<UnpinCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: UnpinCommentMutationPayload) => [...Sel]):$Field<"unpinComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new UnpinCommentMutationPayload)
      };
      return this.$_select("unpinComment", options as any) as any
    }
  

      
/**
 * Retracts a Collection Revision. This keeps the revision listed and downloadable but marks it as
a revision that should not be used anymore.
 */
      unpublishRevision<Args extends VariabledInput<{
        revisionId: string
reason: string,
      }>,Sel extends Selection<RetractRevisionMutationPayload>>(args: ExactArgNames<Args, {
        revisionId: string
reason: string,
      }>, selectorFn: (s: RetractRevisionMutationPayload) => [...Sel]):$Field<"unpublishRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              revisionId: "ID!",
reason: "String!"
            },
        args,

        selection: selectorFn(new RetractRevisionMutationPayload)
      };
      return this.$_select("unpublishRevision", options as any) as any
    }
  

      
/**
 * Allows the current user to untrack a mod
 */
      untrackMod<Args extends VariabledInput<{
        modUid: string,
      }>,Sel extends Selection<UntrackModMutationPayload>>(args: ExactArgNames<Args, {
        modUid: string,
      }>, selectorFn: (s: UntrackModMutationPayload) => [...Sel]):$Field<"untrackMod", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modUid: "ID!"
            },
        args,

        selection: selectorFn(new UntrackModMutationPayload)
      };
      return this.$_select("untrackMod", options as any) as any
    }
  

      
/**
 * Makes the current user stop tracking another user
 */
      untrackUser<Args extends VariabledInput<{
        trackedUserId?: string | null | undefined,
      }>,Sel extends Selection<UntrackUserMutationPayload>>(args: ExactArgNames<Args, {
        trackedUserId?: string | null | undefined,
      }>, selectorFn: (s: UntrackUserMutationPayload) => [...Sel]):$Field<"untrackUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
untrackUser<Sel extends Selection<UntrackUserMutationPayload>>(selectorFn: (s: UntrackUserMutationPayload) => [...Sel]):$Field<"untrackUser", GetOutput<Sel> | undefined , GetVariables<Sel>>
untrackUser(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              trackedUserId: "ID"
            },
        args,

        selection: selectorFn(new UntrackUserMutationPayload)
      };
      return this.$_select("untrackUser", options as any) as any
    }
  

      
/**
 * Updates a user's bio (About Me) on their profile
 */
      updateAboutMe<Args extends VariabledInput<{
        userId?: string | null | undefined
about: string,
      }>,Sel extends Selection<UpdateAboutMeMutationPayload>>(args: ExactArgNames<Args, {
        userId?: string | null | undefined
about: string,
      }>, selectorFn: (s: UpdateAboutMeMutationPayload) => [...Sel]):$Field<"updateAboutMe", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              userId: "ID",
about: "String!"
            },
        args,

        selection: selectorFn(new UpdateAboutMeMutationPayload)
      };
      return this.$_select("updateAboutMe", options as any) as any
    }
  

      
/**
 * Updates existing revision changelog
 */
      updateChangelog<Args extends VariabledInput<{
        changelogId: string
description: string,
      }>,Sel extends Selection<UpdateChangelogMutationPayload>>(args: ExactArgNames<Args, {
        changelogId: string
description: string,
      }>, selectorFn: (s: UpdateChangelogMutationPayload) => [...Sel]):$Field<"updateChangelog", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              changelogId: "ID!",
description: "String!"
            },
        args,

        selection: selectorFn(new UpdateChangelogMutationPayload)
      };
      return this.$_select("updateChangelog", options as any) as any
    }
  

      
/**
 * Updates a bug report on a collection
 */
      updateCollectionBugReport<Args extends VariabledInput<{
        bugReportId: string
collectionRevisionNumber?: number | null | undefined
title: string
description?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>,Sel extends Selection<UpdateCollectionBugReportMutationPayload>>(args: ExactArgNames<Args, {
        bugReportId: string
collectionRevisionNumber?: number | null | undefined
title: string
description?: string | null | undefined
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>, selectorFn: (s: UpdateCollectionBugReportMutationPayload) => [...Sel]):$Field<"updateCollectionBugReport", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              bugReportId: "ID!",
collectionRevisionNumber: "Int",
title: "String!",
description: "String",
attachmentIds: "[ID!]"
            },
        args,

        selection: selectorFn(new UpdateCollectionBugReportMutationPayload)
      };
      return this.$_select("updateCollectionBugReport", options as any) as any
    }
  

      
/**
 * Updates a comment.
 */
      updateComment<Args extends VariabledInput<{
        commentId: string
body: string
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>,Sel extends Selection<UpdateCommentMutationPayload>>(args: ExactArgNames<Args, {
        commentId: string
body: string
attachmentIds?: Readonly<Array<string>> | null | undefined,
      }>, selectorFn: (s: UpdateCommentMutationPayload) => [...Sel]):$Field<"updateComment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!",
body: "String!",
attachmentIds: "[ID!]"
            },
        args,

        selection: selectorFn(new UpdateCommentMutationPayload)
      };
      return this.$_select("updateComment", options as any) as any
    }
  

      
/**
 * Updates a user's country on their profile
 */
      updateCountry<Args extends VariabledInput<{
        userId?: string | null | undefined
country?: string | null | undefined,
      }>,Sel extends Selection<UpdateCountryMutationPayload>>(args: ExactArgNames<Args, {
        userId?: string | null | undefined
country?: string | null | undefined,
      }>, selectorFn: (s: UpdateCountryMutationPayload) => [...Sel]):$Field<"updateCountry", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
updateCountry<Sel extends Selection<UpdateCountryMutationPayload>>(selectorFn: (s: UpdateCountryMutationPayload) => [...Sel]):$Field<"updateCountry", GetOutput<Sel> | undefined , GetVariables<Sel>>
updateCountry(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userId: "ID",
country: "String"
            },
        args,

        selection: selectorFn(new UpdateCountryMutationPayload)
      };
      return this.$_select("updateCountry", options as any) as any
    }
  

      
/**
 * Update the detailed status of a CSAM Deletion Request
 */
      updateCsamDeletionRequest<Args extends VariabledInput<{
        id: number
detailedStatus: CsamDeletionRequestCDNResult
cdnSecret?: string | null | undefined,
      }>,Sel extends Selection<UpdateCsamDeletionRequestPayload>>(args: ExactArgNames<Args, {
        id: number
detailedStatus: CsamDeletionRequestCDNResult
cdnSecret?: string | null | undefined,
      }>, selectorFn: (s: UpdateCsamDeletionRequestPayload) => [...Sel]):$Field<"updateCsamDeletionRequest", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "Int!",
detailedStatus: "CsamDeletionRequestCDNResult!",
cdnSecret: "String"
            },
        args,

        selection: selectorFn(new UpdateCsamDeletionRequestPayload)
      };
      return this.$_select("updateCsamDeletionRequest", options as any) as any
    }
  

      
/**
 * Updates a game
 */
      updateGame<Args extends VariabledInput<{
        gameId: number
artworkSchema?: GameArtworkSchema | null | undefined
copyrightedName?: boolean | null | undefined,
      }>,Sel extends Selection<UpdateGameMutationPayload>>(args: ExactArgNames<Args, {
        gameId: number
artworkSchema?: GameArtworkSchema | null | undefined
copyrightedName?: boolean | null | undefined,
      }>, selectorFn: (s: UpdateGameMutationPayload) => [...Sel]):$Field<"updateGame", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              gameId: "Int!",
artworkSchema: "GameArtworkSchema",
copyrightedName: "Boolean"
            },
        args,

        selection: selectorFn(new UpdateGameMutationPayload)
      };
      return this.$_select("updateGame", options as any) as any
    }
  

      
/**
 * Updates a users moderation warning
 */
      updateModerationWarning<Args extends VariabledInput<{
        moderationWarningId: string
isRead: boolean,
      }>,Sel extends Selection<LegacyUpdateModerationWarningMutationPayload>>(args: ExactArgNames<Args, {
        moderationWarningId: string
isRead: boolean,
      }>, selectorFn: (s: LegacyUpdateModerationWarningMutationPayload) => [...Sel]):$Field<"updateModerationWarning", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              moderationWarningId: "ID!",
isRead: "Boolean!"
            },
        args,

        selection: selectorFn(new LegacyUpdateModerationWarningMutationPayload)
      };
      return this.$_select("updateModerationWarning", options as any) as any
    }
  

      
/**
 * Updates a users preferences
 */
      updatePreferences<Args extends VariabledInput<{
        defaultModsTab?: PreferencesDefaultModsTabEnum | null | undefined
defaultModsTabTimeRange?: PreferencesTimeRangeEnum | null | undefined
defaultMediaTab?: PreferencesDefaultMediaTabEnum | null | undefined
defaultMediaTabTimeRange?: PreferencesTimeRangeEnum | null | undefined
subfeedsCommentsYour?: boolean | null | undefined
subfeedsActivityYour?: boolean | null | undefined
subfeedsCommentsTracked?: boolean | null | undefined
subfeedsActivityTracked?: boolean | null | undefined
subfeedsAuthorTracked?: boolean | null | undefined
defaultOrder?: PreferencesDefaultSortEnum | null | undefined
defaultSearchView?: PreferencesDefaultSearchViewEnum | null | undefined
results?: PreferencesResultsEnum | null | undefined
comments?: PreferencesCommentsEnum | null | undefined
dlLocation?: PreferencesDlLocationEnum | null | undefined
reminder?: PreferencesReminderEnum | null | undefined
imageShowcase?: PreferencesImageShowcaseEnum | null | undefined
bubbleReply?: boolean | null | undefined
disableProfileActivity?: boolean | null | undefined
displayLastActivity?: boolean | null | undefined
adult?: boolean | null | undefined
adultBlurImages?: boolean | null | undefined
download?: PreferencesDownloadMethodEnum | null | undefined
notificationsActive?: boolean | null | undefined
notificationsGameSpecific?: boolean | null | undefined
defaultSearchType?: PreferencesSearchTypeEnum | null | undefined
marketingEmails?: boolean | null | undefined,
      }>,Sel extends Selection<LegacyUpdatePreferencesMutationPayload>>(args: ExactArgNames<Args, {
        defaultModsTab?: PreferencesDefaultModsTabEnum | null | undefined
defaultModsTabTimeRange?: PreferencesTimeRangeEnum | null | undefined
defaultMediaTab?: PreferencesDefaultMediaTabEnum | null | undefined
defaultMediaTabTimeRange?: PreferencesTimeRangeEnum | null | undefined
subfeedsCommentsYour?: boolean | null | undefined
subfeedsActivityYour?: boolean | null | undefined
subfeedsCommentsTracked?: boolean | null | undefined
subfeedsActivityTracked?: boolean | null | undefined
subfeedsAuthorTracked?: boolean | null | undefined
defaultOrder?: PreferencesDefaultSortEnum | null | undefined
defaultSearchView?: PreferencesDefaultSearchViewEnum | null | undefined
results?: PreferencesResultsEnum | null | undefined
comments?: PreferencesCommentsEnum | null | undefined
dlLocation?: PreferencesDlLocationEnum | null | undefined
reminder?: PreferencesReminderEnum | null | undefined
imageShowcase?: PreferencesImageShowcaseEnum | null | undefined
bubbleReply?: boolean | null | undefined
disableProfileActivity?: boolean | null | undefined
displayLastActivity?: boolean | null | undefined
adult?: boolean | null | undefined
adultBlurImages?: boolean | null | undefined
download?: PreferencesDownloadMethodEnum | null | undefined
notificationsActive?: boolean | null | undefined
notificationsGameSpecific?: boolean | null | undefined
defaultSearchType?: PreferencesSearchTypeEnum | null | undefined
marketingEmails?: boolean | null | undefined,
      }>, selectorFn: (s: LegacyUpdatePreferencesMutationPayload) => [...Sel]):$Field<"updatePreferences", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
updatePreferences<Sel extends Selection<LegacyUpdatePreferencesMutationPayload>>(selectorFn: (s: LegacyUpdatePreferencesMutationPayload) => [...Sel]):$Field<"updatePreferences", GetOutput<Sel> | undefined , GetVariables<Sel>>
updatePreferences(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              defaultModsTab: "PreferencesDefaultModsTabEnum",
defaultModsTabTimeRange: "PreferencesTimeRangeEnum",
defaultMediaTab: "PreferencesDefaultMediaTabEnum",
defaultMediaTabTimeRange: "PreferencesTimeRangeEnum",
subfeedsCommentsYour: "Boolean",
subfeedsActivityYour: "Boolean",
subfeedsCommentsTracked: "Boolean",
subfeedsActivityTracked: "Boolean",
subfeedsAuthorTracked: "Boolean",
defaultOrder: "PreferencesDefaultSortEnum",
defaultSearchView: "PreferencesDefaultSearchViewEnum",
results: "PreferencesResultsEnum",
comments: "PreferencesCommentsEnum",
dlLocation: "PreferencesDlLocationEnum",
reminder: "PreferencesReminderEnum",
imageShowcase: "PreferencesImageShowcaseEnum",
bubbleReply: "Boolean",
disableProfileActivity: "Boolean",
displayLastActivity: "Boolean",
adult: "Boolean",
adultBlurImages: "Boolean",
download: "PreferencesDownloadMethodEnum",
notificationsActive: "Boolean",
notificationsGameSpecific: "Boolean",
defaultSearchType: "PreferencesSearchTypeEnum",
marketingEmails: "Boolean"
            },
        args,

        selection: selectorFn(new LegacyUpdatePreferencesMutationPayload)
      };
      return this.$_select("updatePreferences", options as any) as any
    }
  

      
/**
 * Updates a specific Collection Revision with new installation information and adult
content flags
 */
      updateRevision<Args extends VariabledInput<{
        revisionId: number
installationInfo?: string | null | undefined
adultContent?: boolean | null | undefined,
      }>,Sel extends Selection<UpdateRevisionMutationPayload>>(args: ExactArgNames<Args, {
        revisionId: number
installationInfo?: string | null | undefined
adultContent?: boolean | null | undefined,
      }>, selectorFn: (s: UpdateRevisionMutationPayload) => [...Sel]):$Field<"updateRevision", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              revisionId: "Int!",
installationInfo: "String",
adultContent: "Boolean"
            },
        args,

        selection: selectorFn(new UpdateRevisionMutationPayload)
      };
      return this.$_select("updateRevision", options as any) as any
    }
  

      
/**
 * Updates a collection Tag
 */
      updateTag<Args extends VariabledInput<{
        id: string
name?: string | null | undefined
categoryId?: string | null | undefined
gameIds?: Readonly<Array<string>> | null | undefined
global?: boolean | null | undefined
adult?: boolean | null | undefined,
      }>,Sel extends Selection<UpdateTagMutationPayload>>(args: ExactArgNames<Args, {
        id: string
name?: string | null | undefined
categoryId?: string | null | undefined
gameIds?: Readonly<Array<string>> | null | undefined
global?: boolean | null | undefined
adult?: boolean | null | undefined,
      }>, selectorFn: (s: UpdateTagMutationPayload) => [...Sel]):$Field<"updateTag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!",
name: "String",
categoryId: "ID",
gameIds: "[ID!]",
global: "Boolean",
adult: "Boolean"
            },
        args,

        selection: selectorFn(new UpdateTagMutationPayload)
      };
      return this.$_select("updateTag", options as any) as any
    }
  

      
/**
 * Updates a user's donation preferences.
 */
      updateUserDonationPreferences<Args extends VariabledInput<{
        donateStraight?: boolean | null | undefined
donateAuthorpremium?: boolean | null | undefined
donateOwnpremium?: boolean | null | undefined
donateProfile?: boolean | null | undefined
donatePremiumMax?: number | null | undefined
dpOptedIn?: boolean | null | undefined
paypal?: string | null | undefined,
      }>,Sel extends Selection<UpdateUserDonationPreferencesPayload>>(args: ExactArgNames<Args, {
        donateStraight?: boolean | null | undefined
donateAuthorpremium?: boolean | null | undefined
donateOwnpremium?: boolean | null | undefined
donateProfile?: boolean | null | undefined
donatePremiumMax?: number | null | undefined
dpOptedIn?: boolean | null | undefined
paypal?: string | null | undefined,
      }>, selectorFn: (s: UpdateUserDonationPreferencesPayload) => [...Sel]):$Field<"updateUserDonationPreferences", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
updateUserDonationPreferences<Sel extends Selection<UpdateUserDonationPreferencesPayload>>(selectorFn: (s: UpdateUserDonationPreferencesPayload) => [...Sel]):$Field<"updateUserDonationPreferences", GetOutput<Sel> | undefined , GetVariables<Sel>>
updateUserDonationPreferences(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              donateStraight: "Boolean",
donateAuthorpremium: "Boolean",
donateOwnpremium: "Boolean",
donateProfile: "Boolean",
donatePremiumMax: "Int",
dpOptedIn: "Boolean",
paypal: "String"
            },
        args,

        selection: selectorFn(new UpdateUserDonationPreferencesPayload)
      };
      return this.$_select("updateUserDonationPreferences", options as any) as any
    }
  

      
/**
 * Uploads a file to later be attached to an Attachable entity
 */
      uploadAttachment<Args extends VariabledInput<{
        file: Upload,
      }>,Sel extends Selection<UploadAttachmentMutationPayload>>(args: ExactArgNames<Args, {
        file: Upload,
      }>, selectorFn: (s: UploadAttachmentMutationPayload) => [...Sel]):$Field<"uploadAttachment", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              file: "Upload!"
            },
        args,

        selection: selectorFn(new UploadAttachmentMutationPayload)
      };
      return this.$_select("uploadAttachment", options as any) as any
    }
  

      
/**
 * TODO
 */
      uploadGameArtworkV2<Args extends VariabledInput<{
        gameId: number
tileFile?: Upload | null | undefined
heroFile?: Upload | null | undefined
thumbnailFile?: Upload | null | undefined,
      }>,Sel extends Selection<UploadGameArtworkV2MutationPayload>>(args: ExactArgNames<Args, {
        gameId: number
tileFile?: Upload | null | undefined
heroFile?: Upload | null | undefined
thumbnailFile?: Upload | null | undefined,
      }>, selectorFn: (s: UploadGameArtworkV2MutationPayload) => [...Sel]):$Field<"uploadGameArtworkV2", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              gameId: "Int!",
tileFile: "Upload",
heroFile: "Upload",
thumbnailFile: "Upload"
            },
        args,

        selection: selectorFn(new UploadGameArtworkV2MutationPayload)
      };
      return this.$_select("uploadGameArtworkV2", options as any) as any
    }
  

      
/**
 * Writes a full page notification to a user
 */
      writeFullPageNotificationToUser<Args extends VariabledInput<{
        userId: string
title: string
message: string
referenceLinks?: Readonly<Array<string>> | null | undefined,
      }>,Sel extends Selection<WriteFullPageNotificationToUserMutationPayload>>(args: ExactArgNames<Args, {
        userId: string
title: string
message: string
referenceLinks?: Readonly<Array<string>> | null | undefined,
      }>, selectorFn: (s: WriteFullPageNotificationToUserMutationPayload) => [...Sel]):$Field<"writeFullPageNotificationToUser", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              userId: "ID!",
title: "String!",
message: "String!",
referenceLinks: "[String!]"
            },
        args,

        selection: selectorFn(new WriteFullPageNotificationToUserMutationPayload)
      };
      return this.$_select("writeFullPageNotificationToUser", options as any) as any
    }
  
}


/**
 * A News article, stored and originally defined by the legacy forum
 */
export class News extends $Base<"News"> {
  constructor() {
    super("News")
  }

  
      
/**
 * Author of this News Article
 */
      author<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"author", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("author", options as any) as any
    }
  

      
/**
 * The number of comments on this article
 */
      get commentsCount(): $Field<"commentsCount", number>  {
       return this.$_select("commentsCount") as any
      }

      
/**
 * Content of this news article
 */
      get content(): $Field<"content", string>  {
       return this.$_select("content") as any
      }

      
/**
 * Date this news article was created
 */
      get date(): $Field<"date", ISO8601DateTime>  {
       return this.$_select("date") as any
      }

      
/**
 * Games this news article is related to
 */
      games<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"games", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("games", options as any) as any
    }
  

      
/**
 * The name of the image on the forum
 */
      get header(): $Field<"header", string | null | undefined>  {
       return this.$_select("header") as any
      }

      
/**
 * Is this news article written in HTML?
 */
      get html(): $Field<"html", boolean>  {
       return this.$_select("html") as any
      }

      
/**
 * The database ID for this news.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The name of the image on the forum
 */
      get image(): $Field<"image", string | null | undefined>  {
       return this.$_select("image") as any
      }

      
/**
 * Category of this news article
 */
      newsCategory<Sel extends Selection<NewsCategory>>(selectorFn: (s: NewsCategory) => [...Sel]):$Field<"newsCategory", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NewsCategory)
      };
      return this.$_select("newsCategory", options as any) as any
    }
  

      
/**
 * If the news article has a source, this is it's name
 */
      get sourceName(): $Field<"sourceName", string | null | undefined>  {
       return this.$_select("sourceName") as any
      }

      
/**
 * If the news article has a source, this is the URL
 */
      get sourceUrl(): $Field<"sourceUrl", string | null | undefined>  {
       return this.$_select("sourceUrl") as any
      }

      
/**
 * Summary of this news article
 */
      get summary(): $Field<"summary", string>  {
       return this.$_select("summary") as any
      }

      
/**
 * Title of this news article
 */
      get title(): $Field<"title", string>  {
       return this.$_select("title") as any
      }

      
/**
 * The name of the uncropped image on the forum
 */
      get uncroppedHeader(): $Field<"uncroppedHeader", string | null | undefined>  {
       return this.$_select("uncroppedHeader") as any
      }

      
/**
 * The name of the uncropped image on the forum
 */
      get uncroppedImage(): $Field<"uncroppedImage", string | null | undefined>  {
       return this.$_select("uncroppedImage") as any
      }
}


/**
 * A news category
 */
export class NewsCategory extends $Base<"NewsCategory"> {
  constructor() {
    super("NewsCategory")
  }

  
      
/**
 * The database ID for this news category.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }
}

  
/**
 * Forum news articles type.
 */
export enum NewsCategoryEnum {
  
  SITE_NEWS = "SITE_NEWS",

  GAME_NEWS = "GAME_NEWS",

  MOD_NEWS = "MOD_NEWS",

  INTERVIEWS = "INTERVIEWS",

  COMPETITIONS = "COMPETITIONS",

  FEATURES = "FEATURES"
}
  


export class NewsPage extends $Base<"NewsPage"> {
  constructor() {
    super("NewsPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<News>>(selectorFn: (s: News) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new News)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An object with an ID.
 */
export class Node extends $Interface<{ApiKey: ApiKey,Attachment: Attachment,CommentRevision: CommentRevision,Image: Image,LegacyTag: LegacyTag,LegacyUserDonationPreferences: LegacyUserDonationPreferences,ModFile: ModFile,ModerationWarning: ModerationWarning,ModerationWarningRestriction: ModerationWarningRestriction,Preference: Preference,Rating: Rating,SupporterImage: SupporterImage,Video: Video}, "Node"> {
  constructor() {
    super({ApiKey: ApiKey,Attachment: Attachment,CommentRevision: CommentRevision,Image: Image,LegacyTag: LegacyTag,LegacyUserDonationPreferences: LegacyUserDonationPreferences,ModFile: ModFile,ModerationWarning: ModerationWarning,ModerationWarningRestriction: ModerationWarningRestriction,Preference: Preference,Rating: Rating,SupporterImage: SupporterImage,Video: Video}, "Node")
  }
  
      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }
}


/**
 * Metadata about a single facet value.
 */
export class NodesFacet extends $Base<"NodesFacet"> {
  constructor() {
    super("NodesFacet")
  }

  
      
/**
 * Number of results available for this facet value. Affected by values set on other facets.
 */
      get count(): $Field<"count", number>  {
       return this.$_select("count") as any
      }

      
/**
 * Name matching the graphql facet request.
 */
      get facet(): $Field<"facet", string>  {
       return this.$_select("facet") as any
      }

      
/**
 * Value available for this facet. May be used in a subsequent facet request to filter the results by facet.
 */
      get value(): $Field<"value", string>  {
       return this.$_select("value") as any
      }
}


/**
 * Information about a page of items
 */
export class OffsetBasedPageInfo extends $Base<"OffsetBasedPageInfo"> {
  constructor() {
    super("OffsetBasedPageInfo")
  }

  
      
/**
 * Whether there is a next page
 */
      get hasNextPage(): $Field<"hasNextPage", boolean>  {
       return this.$_select("hasNextPage") as any
      }

      
/**
 * Whether there is a previous page
 */
      get hasPreviousPage(): $Field<"hasPreviousPage", boolean>  {
       return this.$_select("hasPreviousPage") as any
      }

      
/**
 * The current page number
 */
      get page(): $Field<"page", number>  {
       return this.$_select("page") as any
      }

      
/**
 * The number of items per page
 */
      get pageSize(): $Field<"pageSize", number>  {
       return this.$_select("pageSize") as any
      }

      
/**
 * The total number of items
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * Autogenerated return type of OpenCollectionBugReportMutation.
 */
export class OpenCollectionBugReportMutationPayload extends $Base<"OpenCollectionBugReportMutationPayload"> {
  constructor() {
    super("OpenCollectionBugReportMutationPayload")
  }

  
      
/**
 * Collection bug report which was re-opened
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * Represents a single opted in mod
 */
export class OptedInMod extends $Base<"OptedInMod"> {
  constructor() {
    super("OptedInMod")
  }

  
      
/**
 * Time of when this OptedInMod was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Game
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * The ID of the game the mod belongs to
 */
      get gameId(): $Field<"gameId", number>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The database ID for this opted in mod.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Mod
 */
      mod<Sel extends Selection<Mod>>(selectorFn: (s: Mod) => [...Sel]):$Field<"mod", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Mod)
      };
      return this.$_select("mod", options as any) as any
    }
  

      
/**
 * ID of the that was opted in
 */
      get modId(): $Field<"modId", number>  {
       return this.$_select("modId") as any
      }

      
/**
 * Ratio of the DP from this mod shared with this user
 */
      get ratio(): $Field<"ratio", number>  {
       return this.$_select("ratio") as any
      }

      
/**
 * Uploader of the mod
 */
      uploader<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"uploader", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("uploader", options as any) as any
    }
  

      
/**
 * ID of the uploader of the mod. This
might not be the current user, as mod authors can share mod DP with other users.
 */
      get uploaderId(): $Field<"uploaderId", number>  {
       return this.$_select("uploaderId") as any
      }
}


/**
 * A list of mods that this user has been opted into
 */
export class OptedInMods extends $Base<"OptedInMods"> {
  constructor() {
    super("OptedInMods")
  }

  
      
/**
 * Number of mods this user has opted in
 */
      get count(): $Field<"count", number>  {
       return this.$_select("count") as any
      }

      
/**
 * Mods that have been opted in
 */
      entries<Sel extends Selection<OptedInMod>>(selectorFn: (s: OptedInMod) => [...Sel]):$Field<"entries", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new OptedInMod)
      };
      return this.$_select("entries", options as any) as any
    }
  

      
/**
 * User
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * ID of the user
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * Information about pagination in a connection.
 */
export class PageInfo extends $Base<"PageInfo"> {
  constructor() {
    super("PageInfo")
  }

  
      
/**
 * When paginating forwards, the cursor to continue.
 */
      get endCursor(): $Field<"endCursor", string | null | undefined>  {
       return this.$_select("endCursor") as any
      }

      
/**
 * When paginating forwards, are there more items?
 */
      get hasNextPage(): $Field<"hasNextPage", boolean>  {
       return this.$_select("hasNextPage") as any
      }

      
/**
 * When paginating backwards, are there more items?
 */
      get hasPreviousPage(): $Field<"hasPreviousPage", boolean>  {
       return this.$_select("hasPreviousPage") as any
      }

      
/**
 * When paginating backwards, the cursor to continue.
 */
      get startCursor(): $Field<"startCursor", string | null | undefined>  {
       return this.$_select("startCursor") as any
      }
}


/**
 * An entity to represent either an account or a bank
 */
export class PaymentEntity extends $Base<"PaymentEntity"> {
  constructor() {
    super("PaymentEntity")
  }

  
      
/**
 * The database ID for this payment entity.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this entity
 */
      get label(): $Field<"label", string>  {
       return this.$_select("label") as any
      }

      
/**
 * Type of entity
 */
      get type(): $Field<"type", string>  {
       return this.$_select("type") as any
      }
}


/**
 * A global or entity-specific permission granted to a user
 */
export class Permission extends $Base<"Permission"> {
  constructor() {
    super("Permission")
  }

  
      
/**
 * If true, this permission is being granted globally from the user's role
 */
      get global(): $Field<"global", boolean>  {
       return this.$_select("global") as any
      }

      
/**
 * Permission string being granted E.g. 'collection:publish'
 */
      get key(): $Field<"key", string>  {
       return this.$_select("key") as any
      }
}


/**
 * Autogenerated return type of PinCommentMutation.
 */
export class PinCommentMutationPayload extends $Base<"PinCommentMutationPayload"> {
  constructor() {
    super("PinCommentMutationPayload")
  }

  
      
/**
 * The comment that was pinned.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * A user preference
 */
export class Preference extends $Base<"Preference"> {
  constructor() {
    super("Preference")
  }

  
      
/**
 * Show adult content
 */
      get adult(): $Field<"adult", boolean>  {
       return this.$_select("adult") as any
      }

      
/**
 * Blur adult images
 */
      get adultBlurImages(): $Field<"adultBlurImages", boolean>  {
       return this.$_select("adultBlurImages") as any
      }

      
/**
 * Replies to posts bump original post
 */
      get bubbleReply(): $Field<"bubbleReply", boolean>  {
       return this.$_select("bubbleReply") as any
      }

      
/**
 * Amount of comments per page.
 */
      get comments(): $Field<"comments", PreferencesCommentsEnum>  {
       return this.$_select("comments") as any
      }

      
/**
 * Default media tab.
 */
      get defaultMediaTab(): $Field<"defaultMediaTab", PreferencesDefaultMediaTabEnum>  {
       return this.$_select("defaultMediaTab") as any
      }

      
/**
 * Time range values for preferences.
 */
      get defaultMediaTabTimeRange(): $Field<"defaultMediaTabTimeRange", PreferencesTimeRangeEnum>  {
       return this.$_select("defaultMediaTabTimeRange") as any
      }

      
/**
 * Default mods tab.
 */
      get defaultModsTab(): $Field<"defaultModsTab", PreferencesDefaultModsTabEnum>  {
       return this.$_select("defaultModsTab") as any
      }

      
/**
 * Time range values for preferences.
 */
      get defaultModsTabTimeRange(): $Field<"defaultModsTabTimeRange", PreferencesTimeRangeEnum>  {
       return this.$_select("defaultModsTabTimeRange") as any
      }

      
/**
 * Default sorting option.
 */
      get defaultOrder(): $Field<"defaultOrder", PreferencesDefaultSortEnum>  {
       return this.$_select("defaultOrder") as any
      }

      
/**
 * Default search types
 */
      get defaultSearchType(): $Field<"defaultSearchType", PreferencesSearchTypeEnum>  {
       return this.$_select("defaultSearchType") as any
      }

      
/**
 * Default search view.
 */
      get defaultSearchView(): $Field<"defaultSearchView", PreferencesDefaultSearchViewEnum>  {
       return this.$_select("defaultSearchView") as any
      }

      
/**
 * Display user activity
 */
      get disableProfileActivity(): $Field<"disableProfileActivity", boolean>  {
       return this.$_select("disableProfileActivity") as any
      }

      
/**
 * Display when user was last active
 */
      get displayLastActivity(): $Field<"displayLastActivity", boolean>  {
       return this.$_select("displayLastActivity") as any
      }

      
/**
 * Download location.
 */
      get dlLocation(): $Field<"dlLocation", PreferencesDlLocationEnum>  {
       return this.$_select("dlLocation") as any
      }

      
/**
 * Preferred download method
 */
      get download(): $Field<"download", PreferencesDownloadMethodEnum>  {
       return this.$_select("download") as any
      }

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Image showcase.
 */
      get imageShowcase(): $Field<"imageShowcase", PreferencesImageShowcaseEnum>  {
       return this.$_select("imageShowcase") as any
      }

      
/**
 * If true, this user is blocking content
 */
      get isBlockingContent(): $Field<"isBlockingContent", boolean>  {
       return this.$_select("isBlockingContent") as any
      }

      
/**
 * Whether the user has opted in to marketing emails
 */
      get marketingEmails(): $Field<"marketingEmails", boolean>  {
       return this.$_select("marketingEmails") as any
      }

      
/**
 * Display notifications
 */
      get notificationsActive(): $Field<"notificationsActive", boolean>  {
       return this.$_select("notificationsActive") as any
      }

      
/**
 * Game specific notifications when visiting game pages
 */
      get notificationsGameSpecific(): $Field<"notificationsGameSpecific", boolean>  {
       return this.$_select("notificationsGameSpecific") as any
      }

      
/**
 * Endorsement reminder.
 */
      get reminder(): $Field<"reminder", PreferencesReminderEnum>  {
       return this.$_select("reminder") as any
      }

      
/**
 * Amount of results per page.
 */
      get results(): $Field<"results", PreferencesResultsEnum>  {
       return this.$_select("results") as any
      }

      
/**
 * Activity about tracked files, images and videos
 */
      get subfeedsActivityTracked(): $Field<"subfeedsActivityTracked", boolean>  {
       return this.$_select("subfeedsActivityTracked") as any
      }

      
/**
 * Activity about a users files, images and videos
 */
      get subfeedsActivityYour(): $Field<"subfeedsActivityYour", boolean>  {
       return this.$_select("subfeedsActivityYour") as any
      }

      
/**
 * Author tracked files, images and videos
 */
      get subfeedsAuthorTracked(): $Field<"subfeedsAuthorTracked", boolean>  {
       return this.$_select("subfeedsAuthorTracked") as any
      }

      
/**
 * Comments about tracked files, images and videos
 */
      get subfeedsCommentsTracked(): $Field<"subfeedsCommentsTracked", boolean>  {
       return this.$_select("subfeedsCommentsTracked") as any
      }

      
/**
 * Comments about a users files, images and videos
 */
      get subfeedsCommentsYour(): $Field<"subfeedsCommentsYour", boolean>  {
       return this.$_select("subfeedsCommentsYour") as any
      }
}

  
/**
 * Amount of comments per page.
 */
export enum PreferencesCommentsEnum {
  
  COMMENTS_10 = "COMMENTS_10",

  COMMENTS_20 = "COMMENTS_20",

  COMMENTS_30 = "COMMENTS_30",

  COMMENTS_40 = "COMMENTS_40",

  COMMENTS_50 = "COMMENTS_50"
}
  

  
/**
 * Default media tab.
 */
export enum PreferencesDefaultMediaTabEnum {
  
  NEW = "NEW",

  TRENDING = "TRENDING",

  POPULAR = "POPULAR",

  RANDOM = "RANDOM"
}
  

  
/**
 * Default mods tab.
 */
export enum PreferencesDefaultModsTabEnum {
  
  NEW = "NEW",

  TRENDING = "TRENDING",

  POPULAR = "POPULAR",

  RANDOM = "RANDOM",

  UPDATED = "UPDATED"
}
  

  
/**
 * Default search view.
 */
export enum PreferencesDefaultSearchViewEnum {
  
  STANDARD = "STANDARD",

  LIST = "LIST",

  COMPACT = "COMPACT"
}
  

  
/**
 * Default sorting option.
 */
export enum PreferencesDefaultSortEnum {
  
  BY_RECENT_FILES = "BY_RECENT_FILES",

  BY_ENDORSEMENTS = "BY_ENDORSEMENTS",

  BY_DOWNLOADS = "BY_DOWNLOADS",

  BY_UNIQUE_DOWNLOADS = "BY_UNIQUE_DOWNLOADS",

  BY_LAST_UPDATED_FILE = "BY_LAST_UPDATED_FILE",

  BY_AUTHOR_NAME = "BY_AUTHOR_NAME",

  BY_FILE_NAME = "BY_FILE_NAME",

  BY_FILE_SIZE = "BY_FILE_SIZE",

  RANDOM_SORTING = "RANDOM_SORTING",

  LAST_COMMENT = "LAST_COMMENT"
}
  

  
/**
 * Download location.
 */
export enum PreferencesDlLocationEnum {
  
  NEXUS_CDN = "NEXUS_CDN",

  AMSTERDAM = "AMSTERDAM",

  PRAGUE = "PRAGUE",

  CHICAGO = "CHICAGO",

  LOS_ANGELES = "LOS_ANGELES",

  MIAMI = "MIAMI"
}
  

  
/**
 * Download method.
 */
export enum PreferencesDownloadMethodEnum {
  
  POP_UP_BOX = "POP_UP_BOX",

  SEPARATE_PAGE = "SEPARATE_PAGE"
}
  

  
/**
 * Image showcase.
 */
export enum PreferencesImageShowcaseEnum {
  
  NOT_SET = "NOT_SET",

  CHOOSE_ON_PER_IMAGE_BASIS = "CHOOSE_ON_PER_IMAGE_BASIS",

  TURN_OFF_IMAGES = "TURN_OFF_IMAGES",

  TURN_ON_IMAGES = "TURN_ON_IMAGES"
}
  

  
/**
 * Endorsement reminder.
 */
export enum PreferencesReminderEnum {
  
  NEVER = "NEVER",

  DAYS_1 = "DAYS_1",

  DAYS_3 = "DAYS_3",

  DAYS_7 = "DAYS_7",

  DAYS_14 = "DAYS_14",

  DAYS_28 = "DAYS_28"
}
  

  
/**
 * Amount of results per page.
 */
export enum PreferencesResultsEnum {
  
  RESULTS_20 = "RESULTS_20",

  RESULTS_40 = "RESULTS_40",

  RESULTS_60 = "RESULTS_60",

  RESULTS_80 = "RESULTS_80"
}
  

  
/**
 * Search types.
 */
export enum PreferencesSearchTypeEnum {
  
  ALL_CONTENT = "ALL_CONTENT",

  GAMES = "GAMES",

  MODS = "MODS",

  COLLECTIONS = "COLLECTIONS",

  IMAGES = "IMAGES",

  VIDEOS = "VIDEOS",

  USERS = "USERS"
}
  

  
/**
 * Time range values for preferences.
 */
export enum PreferencesTimeRangeEnum {
  
  ALL_TIME = "ALL_TIME",

  ONE_DAY = "ONE_DAY",

  ONE_WEEK = "ONE_WEEK",

  TWO_WEEKS = "TWO_WEEKS",

  FOUR_WEEKS = "FOUR_WEEKS",

  ONE_YEAR = "ONE_YEAR"
}
  


/**
 * returned attributes for presigned post requests
 */
export class PresignedUrl extends $Base<"PresignedUrl"> {
  constructor() {
    super("PresignedUrl")
  }

  
      
/**
 * Presigned URL
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }

      
/**
 * UUID
 */
      get uuid(): $Field<"uuid", string>  {
       return this.$_select("uuid") as any
      }
}


/**
 * A public changelog attached to a collection revision.
      If you need to access more fields, use CollectionChangelogType instead.
 */
export class PublicCollectionChangelog extends $Base<"PublicCollectionChangelog"> {
  constructor() {
    super("PublicCollectionChangelog")
  }

  
      
/**
 * The id of the collection revision for which this changelog was created
 */
      get collectionRevisionId(): $Field<"collectionRevisionId", number>  {
       return this.$_select("collectionRevisionId") as any
      }

      
/**
 * Time of when this collection changelog was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The content of the collection changelog, in Markdown format
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * The database ID for this collection changelog.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * The revision number of the collection revision for which this changelog was created
 */
      get revisionNumber(): $Field<"revisionNumber", number>  {
       return this.$_select("revisionNumber") as any
      }

      
/**
 * Time of when this collection changelog was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * A public collection revision type.
      If you need to access more fields, use CollectionRevisionType instead.
 */
export class PublicCollectionRevision extends $Base<"PublicCollectionRevision"> {
  constructor() {
    super("PublicCollectionRevision")
  }

  
      
/**
 * A changelog attached to a collection revision
 */
      collectionChangelog<Sel extends Selection<PublicCollectionChangelog>>(selectorFn: (s: PublicCollectionChangelog) => [...Sel]):$Field<"collectionChangelog", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PublicCollectionChangelog)
      };
      return this.$_select("collectionChangelog", options as any) as any
    }
  

      
/**
 * Time of when this revision was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this revision was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The database ID for this revision.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * An average taken from all ratings for this revision
 */
      get overallRating(): $Field<"overallRating", string | null | undefined>  {
       return this.$_select("overallRating") as any
      }

      
/**
 * A count of all ratings for this revision
 */
      get overallRatingCount(): $Field<"overallRatingCount", number | null | undefined>  {
       return this.$_select("overallRatingCount") as any
      }

      
/**
 * Average rating for a single revision and total number of votes
 */
      rating<Sel extends Selection<AverageRating>>(selectorFn: (s: AverageRating) => [...Sel]):$Field<"rating", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new AverageRating)
      };
      return this.$_select("rating", options as any) as any
    }
  

      
/**
 * The revision number
 */
      get revision(): $Field<"revision", number>  {
       return this.$_select("revision") as any
      }

      
/**
 * The revision number
 */
      get revisionNumber(): $Field<"revisionNumber", number>  {
       return this.$_select("revisionNumber") as any
      }

      
/**
 * The status of this revision. Possible values are 'draft', 'published' or 'retracted'
 */
      get revisionStatus(): $Field<"revisionStatus", string>  {
       return this.$_select("revisionStatus") as any
      }

      
/**
 * Time of when this revision was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * Autogenerated return type of PublishRevisionMutation.
 */
export class PublishRevisionMutationPayload extends $Base<"PublishRevisionMutationPayload"> {
  constructor() {
    super("PublishRevisionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Queries for fetching and filtering data
 */
export class Query extends $Base<"Query"> {
  constructor() {
    super("Query")
  }

  
      
/**
 * Gets age verification info for the authenticated user
 */
      ageVerificationInfo<Args extends VariabledInput<{
        userId?: string | null | undefined,
      }>,Sel extends Selection<AgeVerificationInfo>>(args: ExactArgNames<Args, {
        userId?: string | null | undefined,
      }>, selectorFn: (s: AgeVerificationInfo) => [...Sel]):$Field<"ageVerificationInfo", GetOutput<Sel> , GetVariables<Sel, Args>>
ageVerificationInfo<Sel extends Selection<AgeVerificationInfo>>(selectorFn: (s: AgeVerificationInfo) => [...Sel]):$Field<"ageVerificationInfo", GetOutput<Sel> , GetVariables<Sel>>
ageVerificationInfo(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              userId: "ID"
            },
        args,

        selection: selectorFn(new AgeVerificationInfo)
      };
      return this.$_select("ageVerificationInfo", options as any) as any
    }
  

      
/**
 * Get a list of modding applications (accessed via API keys)
 */
      applications<Sel extends Selection<ApiApplication>>(selectorFn: (s: ApiApplication) => [...Sel]):$Field<"applications", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ApiApplication)
      };
      return this.$_select("applications", options as any) as any
    }
  

      
/**
 * Get a list of badges
 */
      badges<Sel extends Selection<Badge>>(selectorFn: (s: Badge) => [...Sel]):$Field<"badges", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Badge)
      };
      return this.$_select("badges", options as any) as any
    }
  

      
/**
 * Get a list of the current user's ignored users.
 */
      blockedAuthors<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"blockedAuthors", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("blockedAuthors", options as any) as any
    }
  

      
/**
 * Get a list of the current user's blocked tags.
 */
      blockedTags<Args extends VariabledInput<{
        excludeAdult?: boolean | null | undefined,
      }>,Sel extends Selection<LegacyTag>>(args: ExactArgNames<Args, {
        excludeAdult?: boolean | null | undefined,
      }>, selectorFn: (s: LegacyTag) => [...Sel]):$Field<"blockedTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel, Args>>
blockedTags<Sel extends Selection<LegacyTag>>(selectorFn: (s: LegacyTag) => [...Sel]):$Field<"blockedTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>>
blockedTags(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              excludeAdult: "Boolean"
            },
        args,

        selection: selectorFn(new LegacyTag)
      };
      return this.$_select("blockedTags", options as any) as any
    }
  

      
/**
 * Get a list of categories
 */
      categories<Args extends VariabledInput<{
        gameId?: number | null | undefined
global?: boolean | null | undefined,
      }>,Sel extends Selection<Category>>(args: ExactArgNames<Args, {
        gameId?: number | null | undefined
global?: boolean | null | undefined,
      }>, selectorFn: (s: Category) => [...Sel]):$Field<"categories", Array<GetOutput<Sel>> | undefined , GetVariables<Sel, Args>>
categories<Sel extends Selection<Category>>(selectorFn: (s: Category) => [...Sel]):$Field<"categories", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>>
categories(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              gameId: "Int",
global: "Boolean"
            },
        args,

        selection: selectorFn(new Category)
      };
      return this.$_select("categories", options as any) as any
    }
  

      
/**
 * Get a category by ID
 */
      category<Args extends VariabledInput<{
        id: string,
      }>,Sel extends Selection<Category>>(args: ExactArgNames<Args, {
        id: string,
      }>, selectorFn: (s: Category) => [...Sel]):$Field<"category", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        selection: selectorFn(new Category)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * Get a collection by slug
 */
      collection<Args extends VariabledInput<{
        slug?: string | null | undefined
viewAdultContent?: boolean | null | undefined
domainName?: string | null | undefined,
      }>,Sel extends Selection<Collection>>(args: ExactArgNames<Args, {
        slug?: string | null | undefined
viewAdultContent?: boolean | null | undefined
domainName?: string | null | undefined,
      }>, selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel, Args>>
collection<Sel extends Selection<Collection>>(selectorFn: (s: Collection) => [...Sel]):$Field<"collection", GetOutput<Sel> , GetVariables<Sel>>
collection(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              slug: "String",
viewAdultContent: "Boolean",
domainName: "String"
            },
        args,

        selection: selectorFn(new Collection)
      };
      return this.$_select("collection", options as any) as any
    }
  

      
/**
 * Get a list of Games containing 1 or more collections with the collection counts
 */
      collectionGames<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"collectionGames", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("collectionGames", options as any) as any
    }
  

      
/**
 * Get a revision by collection slug and revision number
 */
      collectionRevision<Args extends VariabledInput<{
        slug?: string | null | undefined
revision?: number | null | undefined
viewAdultContent?: boolean | null | undefined
domainName?: string | null | undefined,
      }>,Sel extends Selection<CollectionRevision>>(args: ExactArgNames<Args, {
        slug?: string | null | undefined
revision?: number | null | undefined
viewAdultContent?: boolean | null | undefined
domainName?: string | null | undefined,
      }>, selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"collectionRevision", GetOutput<Sel> , GetVariables<Sel, Args>>
collectionRevision<Sel extends Selection<CollectionRevision>>(selectorFn: (s: CollectionRevision) => [...Sel]):$Field<"collectionRevision", GetOutput<Sel> , GetVariables<Sel>>
collectionRevision(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              slug: "String",
revision: "Int",
viewAdultContent: "Boolean",
domainName: "String"
            },
        args,

        selection: selectorFn(new CollectionRevision)
      };
      return this.$_select("collectionRevision", options as any) as any
    }
  

      
/**
 * Get a pre-signed upload URL for B2
 */
      collectionRevisionUploadUrl<Sel extends Selection<PresignedUrl>>(selectorFn: (s: PresignedUrl) => [...Sel]):$Field<"collectionRevisionUploadUrl", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PresignedUrl)
      };
      return this.$_select("collectionRevisionUploadUrl", options as any) as any
    }
  

      
/**
 * Get a list of collections
 */
      collectionsV2<Args extends VariabledInput<{
        facets?: CollectionsFacet | null | undefined
viewUserBlockedContent?: boolean | null | undefined
filter?: CollectionsSearchFilter | null | undefined
postFilter?: CollectionsSearchFilter | null | undefined
sort?: Readonly<Array<CollectionsSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<CollectionPage>>(args: ExactArgNames<Args, {
        facets?: CollectionsFacet | null | undefined
viewUserBlockedContent?: boolean | null | undefined
filter?: CollectionsSearchFilter | null | undefined
postFilter?: CollectionsSearchFilter | null | undefined
sort?: Readonly<Array<CollectionsSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: CollectionPage) => [...Sel]):$Field<"collectionsV2", GetOutput<Sel> , GetVariables<Sel, Args>>
collectionsV2<Sel extends Selection<CollectionPage>>(selectorFn: (s: CollectionPage) => [...Sel]):$Field<"collectionsV2", GetOutput<Sel> , GetVariables<Sel>>
collectionsV2(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              facets: "CollectionsFacet",
viewUserBlockedContent: "Boolean",
filter: "CollectionsSearchFilter",
postFilter: "CollectionsSearchFilter",
sort: "[CollectionsSearchSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new CollectionPage)
      };
      return this.$_select("collectionsV2", options as any) as any
    }
  

      
/**
 * Get a comment by its ID.
 */
      comment<Args extends VariabledInput<{
        commentId: string,
      }>,Sel extends Selection<Comment>>(args: ExactArgNames<Args, {
        commentId: string,
      }>, selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentId: "ID!"
            },
        args,

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  

      
/**
 * Get a comment thread by its ID.
 */
      commentThread<Args extends VariabledInput<{
        commentThreadId: string,
      }>,Sel extends Selection<CommentThread>>(args: ExactArgNames<Args, {
        commentThreadId: string,
      }>, selectorFn: (s: CommentThread) => [...Sel]):$Field<"commentThread", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              commentThreadId: "ID!"
            },
        args,

        selection: selectorFn(new CommentThread)
      };
      return this.$_select("commentThread", options as any) as any
    }
  

      
/**
 * Get all CSAM Deletion Requests
 */
      csamDeletionRequests<Args extends VariabledInput<{
        status?: CsamDeletionRequestStatus | null | undefined
cdnSecret?: string | null | undefined,
      }>,Sel extends Selection<CsamDeletionRequest>>(args: ExactArgNames<Args, {
        status?: CsamDeletionRequestStatus | null | undefined
cdnSecret?: string | null | undefined,
      }>, selectorFn: (s: CsamDeletionRequest) => [...Sel]):$Field<"csamDeletionRequests", Array<GetOutput<Sel>> , GetVariables<Sel, Args>>
csamDeletionRequests<Sel extends Selection<CsamDeletionRequest>>(selectorFn: (s: CsamDeletionRequest) => [...Sel]):$Field<"csamDeletionRequests", Array<GetOutput<Sel>> , GetVariables<Sel>>
csamDeletionRequests(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              status: "CsamDeletionRequestStatus",
cdnSecret: "String"
            },
        args,

        selection: selectorFn(new CsamDeletionRequest)
      };
      return this.$_select("csamDeletionRequests", options as any) as any
    }
  

      
/**
 * Check MD5 hashes against the latest successful CSAM known image hashlist
 */
      csamHashCheck<Args extends VariabledInput<{
        md5Hashes: Readonly<Array<string>>,
      }>,Sel extends Selection<HashCheckResult>>(args: ExactArgNames<Args, {
        md5Hashes: Readonly<Array<string>>,
      }>, selectorFn: (s: HashCheckResult) => [...Sel]):$Field<"csamHashCheck", Array<GetOutput<Sel>> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              md5Hashes: "[String!]!"
            },
        args,

        selection: selectorFn(new HashCheckResult)
      };
      return this.$_select("csamHashCheck", options as any) as any
    }
  

      
/**
 * Get a list of unread warnings for a user
 */
      currentWarnings<Sel extends Selection<UserWarnings>>(selectorFn: (s: UserWarnings) => [...Sel]):$Field<"currentWarnings", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new UserWarnings)
      };
      return this.$_select("currentWarnings", options as any) as any
    }
  

      
/**
 * Gets an external video.
 */
      externalVideo<Args extends VariabledInput<{
        url: string,
      }>,Sel extends Selection<ExternalVideo>>(args: ExactArgNames<Args, {
        url: string,
      }>, selectorFn: (s: ExternalVideo) => [...Sel]):$Field<"externalVideo", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              url: "String!"
            },
        args,

        selection: selectorFn(new ExternalVideo)
      };
      return this.$_select("externalVideo", options as any) as any
    }
  

      
/**
 * Gets a user's favourite games
 */
      favouriteGames<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"favouriteGames", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("favouriteGames", options as any) as any
    }
  

      
/**
 * Get Mod FileHash by md5
 */
      fileHash<Args extends VariabledInput<{
        md5: string,
      }>,Sel extends Selection<FileHash>>(args: ExactArgNames<Args, {
        md5: string,
      }>, selectorFn: (s: FileHash) => [...Sel]):$Field<"fileHash", Array<GetOutput<Sel>> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              md5: "String!"
            },
        args,

        selection: selectorFn(new FileHash)
      };
      return this.$_select("fileHash", options as any) as any
    }
  

      
/**
 * Get a list of FileHashes
 */
      fileHashes<Args extends VariabledInput<{
        md5s: Readonly<Array<string>>,
      }>,Sel extends Selection<FileHash>>(args: ExactArgNames<Args, {
        md5s: Readonly<Array<string>>,
      }>, selectorFn: (s: FileHash) => [...Sel]):$Field<"fileHashes", Array<GetOutput<Sel>> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              md5s: "[String!]!"
            },
        args,

        selection: selectorFn(new FileHash)
      };
      return this.$_select("fileHashes", options as any) as any
    }
  

      
/**
 * Get a Game by ID or domain name
 */
      game<Args extends VariabledInput<{
        id?: string | null | undefined
domainName?: string | null | undefined,
      }>,Sel extends Selection<Game>>(args: ExactArgNames<Args, {
        id?: string | null | undefined
domainName?: string | null | undefined,
      }>, selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> | undefined , GetVariables<Sel>>
game(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              id: "ID",
domainName: "String"
            },
        args,

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * Get the current artwork schemas.
 */
      gameArtwork<Sel extends Selection<GameArtwork>>(selectorFn: (s: GameArtwork) => [...Sel]):$Field<"gameArtwork", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new GameArtwork)
      };
      return this.$_select("gameArtwork", options as any) as any
    }
  

      
/**
 * Get a list of Games
 */
      games<Args extends VariabledInput<{
        facets?: GamesFacet | null | undefined
filter?: GamesSearchFilter | null | undefined
postFilter?: GamesSearchFilter | null | undefined
sort?: Readonly<Array<GamesSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<GamePage>>(args: ExactArgNames<Args, {
        facets?: GamesFacet | null | undefined
filter?: GamesSearchFilter | null | undefined
postFilter?: GamesSearchFilter | null | undefined
sort?: Readonly<Array<GamesSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: GamePage) => [...Sel]):$Field<"games", GetOutput<Sel> , GetVariables<Sel, Args>>
games<Sel extends Selection<GamePage>>(selectorFn: (s: GamePage) => [...Sel]):$Field<"games", GetOutput<Sel> , GetVariables<Sel>>
games(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              facets: "GamesFacet",
filter: "GamesSearchFilter",
postFilter: "GamesSearchFilter",
sort: "[GamesSearchSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new GamePage)
      };
      return this.$_select("games", options as any) as any
    }
  

      
/**
 * Get a list of the current user's ignored users.
 */
      ignoredUsers<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"ignoredUsers", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("ignoredUsers", options as any) as any
    }
  

      
/**
 * Get a list of the current user's ignored users.
 */
      legacyBlockedAuthors<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"legacyBlockedAuthors", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("legacyBlockedAuthors", options as any) as any
    }
  

      
/**
 * Get a list of mod using composite ids, with paging
 */
      legacyMods<Args extends VariabledInput<{
        ids: Readonly<Array<CompositeIdInput>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModPage>>(args: ExactArgNames<Args, {
        ids: Readonly<Array<CompositeIdInput>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModPage) => [...Sel]):$Field<"legacyMods", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              ids: "[CompositeIdInput!]!",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModPage)
      };
      return this.$_select("legacyMods", options as any) as any
    }
  

      
/**
 * Get a list of mods by domain_name and id, with paging
 */
      legacyModsByDomain<Args extends VariabledInput<{
        ids: Readonly<Array<CompositeDomainWithIdInput>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModPage>>(args: ExactArgNames<Args, {
        ids: Readonly<Array<CompositeDomainWithIdInput>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModPage) => [...Sel]):$Field<"legacyModsByDomain", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              ids: "[CompositeDomainWithIdInput!]!",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModPage)
      };
      return this.$_select("legacyModsByDomain", options as any) as any
    }
  

      
/**
 * Fetches Mod Tags.
 */
      legacyTags<Args extends VariabledInput<{
        gameId?: string | null | undefined
onlyAdult?: boolean | null | undefined
excludeAdult?: boolean | null | undefined,
      }>,Sel extends Selection<LegacyTag>>(args: ExactArgNames<Args, {
        gameId?: string | null | undefined
onlyAdult?: boolean | null | undefined
excludeAdult?: boolean | null | undefined,
      }>, selectorFn: (s: LegacyTag) => [...Sel]):$Field<"legacyTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel, Args>>
legacyTags<Sel extends Selection<LegacyTag>>(selectorFn: (s: LegacyTag) => [...Sel]):$Field<"legacyTags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>>
legacyTags(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              gameId: "ID",
onlyAdult: "Boolean",
excludeAdult: "Boolean"
            },
        args,

        selection: selectorFn(new LegacyTag)
      };
      return this.$_select("legacyTags", options as any) as any
    }
  

      
/**
 * Get a list of media items (Images or Videos)
 */
      media<Args extends VariabledInput<{
        facets?: MediaFacet | null | undefined
viewUserBlockedContent?: boolean | null | undefined
filter?: MediaSearchFilter | null | undefined
postFilter?: MediaSearchFilter | null | undefined
sort?: Readonly<Array<MediaSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<MediaUnionPage>>(args: ExactArgNames<Args, {
        facets?: MediaFacet | null | undefined
viewUserBlockedContent?: boolean | null | undefined
filter?: MediaSearchFilter | null | undefined
postFilter?: MediaSearchFilter | null | undefined
sort?: Readonly<Array<MediaSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: MediaUnionPage) => [...Sel]):$Field<"media", GetOutput<Sel> , GetVariables<Sel, Args>>
media<Sel extends Selection<MediaUnionPage>>(selectorFn: (s: MediaUnionPage) => [...Sel]):$Field<"media", GetOutput<Sel> , GetVariables<Sel>>
media(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              facets: "MediaFacet",
viewUserBlockedContent: "Boolean",
filter: "MediaSearchFilter",
postFilter: "MediaSearchFilter",
sort: "[MediaSearchSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new MediaUnionPage)
      };
      return this.$_select("media", options as any) as any
    }
  

      
/**
 * Get a list of users that have endorsed a mod. Will return a maximum of 100 items per page.
 */
      modEndorsers<Args extends VariabledInput<{
        modUid: string
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<ModEndorserConnection>>(args: ExactArgNames<Args, {
        modUid: string
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: ModEndorserConnection) => [...Sel]):$Field<"modEndorsers", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modUid: "ID!",
after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new ModEndorserConnection)
      };
      return this.$_select("modEndorsers", options as any) as any
    }
  

      
      modFileContents<Args extends VariabledInput<{
        filter?: ModFileContentSearchFilter | null | undefined
sort?: Readonly<Array<ModFileContentSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModFileContentPage>>(args: ExactArgNames<Args, {
        filter?: ModFileContentSearchFilter | null | undefined
sort?: Readonly<Array<ModFileContentSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModFileContentPage) => [...Sel]):$Field<"modFileContents", GetOutput<Sel> , GetVariables<Sel, Args>>
modFileContents<Sel extends Selection<ModFileContentPage>>(selectorFn: (s: ModFileContentPage) => [...Sel]):$Field<"modFileContents", GetOutput<Sel> , GetVariables<Sel>>
modFileContents(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              filter: "ModFileContentSearchFilter",
sort: "[ModFileContentSearchSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModFileContentPage)
      };
      return this.$_select("modFileContents", options as any) as any
    }
  

      
/**
 * Get a list of mod files
 */
      modFiles<Args extends VariabledInput<{
        modId: string
gameId: string,
      }>,Sel extends Selection<ModFile>>(args: ExactArgNames<Args, {
        modId: string
gameId: string,
      }>, selectorFn: (s: ModFile) => [...Sel]):$Field<"modFiles", Array<GetOutput<Sel>> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              modId: "ID!",
gameId: "ID!"
            },
        args,

        selection: selectorFn(new ModFile)
      };
      return this.$_select("modFiles", options as any) as any
    }
  

      
/**
 * Get a list of mod files by uid
 */
      modFilesByUid<Args extends VariabledInput<{
        uids: Readonly<Array<string>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModFilePage>>(args: ExactArgNames<Args, {
        uids: Readonly<Array<string>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModFilePage) => [...Sel]):$Field<"modFilesByUid", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              uids: "[ID!]!",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModFilePage)
      };
      return this.$_select("modFilesByUid", options as any) as any
    }
  

      
/**
 * Get a Moderation Reason by ID
 */
      moderationReason<Args extends VariabledInput<{
        id: string,
      }>,Sel extends Selection<ModerationReason>>(args: ExactArgNames<Args, {
        id: string,
      }>, selectorFn: (s: ModerationReason) => [...Sel]):$Field<"moderationReason", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        selection: selectorFn(new ModerationReason)
      };
      return this.$_select("moderationReason", options as any) as any
    }
  

      
/**
 * Get a list of Moderation Reasons
 */
      moderationReasons<Sel extends Selection<ModerationReason>>(selectorFn: (s: ModerationReason) => [...Sel]):$Field<"moderationReasons", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationReason)
      };
      return this.$_select("moderationReasons", options as any) as any
    }
  

      
/**
 * Get a list of moderation warnings
 */
      moderationWarnings<Args extends VariabledInput<{
        category?: Readonly<Array<ModerationWarningCategoryEnum>> | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<ModerationWarningConnection>>(args: ExactArgNames<Args, {
        category?: Readonly<Array<ModerationWarningCategoryEnum>> | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: ModerationWarningConnection) => [...Sel]):$Field<"moderationWarnings", GetOutput<Sel> | undefined , GetVariables<Sel, Args>>
moderationWarnings<Sel extends Selection<ModerationWarningConnection>>(selectorFn: (s: ModerationWarningConnection) => [...Sel]):$Field<"moderationWarnings", GetOutput<Sel> | undefined , GetVariables<Sel>>
moderationWarnings(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              category: "[ModerationWarningCategoryEnum!]",
after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new ModerationWarningConnection)
      };
      return this.$_select("moderationWarnings", options as any) as any
    }
  

      
/**
 * Get a list of mods, with paging
 */
      mods<Args extends VariabledInput<{
        viewUploaderHidden?: boolean | null | undefined
viewUserBlockedContent?: boolean | null | undefined
facets?: ModsFacet | null | undefined
filter?: ModsFilter | null | undefined
postFilter?: ModsFilter | null | undefined
sort?: Readonly<Array<ModsSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModPage>>(args: ExactArgNames<Args, {
        viewUploaderHidden?: boolean | null | undefined
viewUserBlockedContent?: boolean | null | undefined
facets?: ModsFacet | null | undefined
filter?: ModsFilter | null | undefined
postFilter?: ModsFilter | null | undefined
sort?: Readonly<Array<ModsSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModPage) => [...Sel]):$Field<"mods", GetOutput<Sel> , GetVariables<Sel, Args>>
mods<Sel extends Selection<ModPage>>(selectorFn: (s: ModPage) => [...Sel]):$Field<"mods", GetOutput<Sel> , GetVariables<Sel>>
mods(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              viewUploaderHidden: "Boolean",
viewUserBlockedContent: "Boolean",
facets: "ModsFacet",
filter: "ModsFilter",
postFilter: "ModsFilter",
sort: "[ModsSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModPage)
      };
      return this.$_select("mods", options as any) as any
    }
  

      
/**
 * Get a list of mods by uid, with paging
 */
      modsByUid<Args extends VariabledInput<{
        uids: Readonly<Array<string>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<ModPage>>(args: ExactArgNames<Args, {
        uids: Readonly<Array<string>>
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: ModPage) => [...Sel]):$Field<"modsByUid", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              uids: "[ID!]!",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new ModPage)
      };
      return this.$_select("modsByUid", options as any) as any
    }
  

      
/**
 * Get a list of collections that the current user has access to view
 */
      myCollections<Args extends VariabledInput<{
        facets?: CollectionsFacet | null | undefined
sortBy?: string | null | undefined
sortDirection?: string | null | undefined
viewAdultContent?: boolean | null | undefined
viewUnlisted?: boolean | null | undefined
viewUnderModeration?: boolean | null | undefined
filter?: CollectionsFilter | null | undefined
postFilter?: CollectionsFilter | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<CollectionPage>>(args: ExactArgNames<Args, {
        facets?: CollectionsFacet | null | undefined
sortBy?: string | null | undefined
sortDirection?: string | null | undefined
viewAdultContent?: boolean | null | undefined
viewUnlisted?: boolean | null | undefined
viewUnderModeration?: boolean | null | undefined
filter?: CollectionsFilter | null | undefined
postFilter?: CollectionsFilter | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: CollectionPage) => [...Sel]):$Field<"myCollections", GetOutput<Sel> , GetVariables<Sel, Args>>
myCollections<Sel extends Selection<CollectionPage>>(selectorFn: (s: CollectionPage) => [...Sel]):$Field<"myCollections", GetOutput<Sel> , GetVariables<Sel>>
myCollections(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              facets: "CollectionsFacet",
sortBy: "String",
sortDirection: "String",
viewAdultContent: "Boolean",
viewUnlisted: "Boolean",
viewUnderModeration: "Boolean",
filter: "CollectionsFilter",
postFilter: "CollectionsFilter",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new CollectionPage)
      };
      return this.$_select("myCollections", options as any) as any
    }
  

      
/**
 * retrieves all news articles.
 */
      news<Args extends VariabledInput<{
        newsCategory?: NewsCategoryEnum | null | undefined
gameId?: number | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<NewsPage>>(args: ExactArgNames<Args, {
        newsCategory?: NewsCategoryEnum | null | undefined
gameId?: number | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: NewsPage) => [...Sel]):$Field<"news", GetOutput<Sel> , GetVariables<Sel, Args>>
news<Sel extends Selection<NewsPage>>(selectorFn: (s: NewsPage) => [...Sel]):$Field<"news", GetOutput<Sel> , GetVariables<Sel>>
news(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              newsCategory: "NewsCategoryEnum",
gameId: "Int",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new NewsPage)
      };
      return this.$_select("news", options as any) as any
    }
  

      
/**
 * Get a list of opted in mods for this user
 */
      optedInMods<Args extends VariabledInput<{
        accountId: number,
      }>,Sel extends Selection<OptedInMods>>(args: ExactArgNames<Args, {
        accountId: number,
      }>, selectorFn: (s: OptedInMods) => [...Sel]):$Field<"optedInMods", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              accountId: "Int!"
            },
        args,

        selection: selectorFn(new OptedInMods)
      };
      return this.$_select("optedInMods", options as any) as any
    }
  

      
/**
 * Get the personal API access key for a current user
 */
      personalApiKey<Sel extends Selection<ApiKey>>(selectorFn: (s: ApiKey) => [...Sel]):$Field<"personalApiKey", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ApiKey)
      };
      return this.$_select("personalApiKey", options as any) as any
    }
  

      
/**
 * Get a list of user preferences for the current user
 */
      preferences<Sel extends Selection<Preference>>(selectorFn: (s: Preference) => [...Sel]):$Field<"preferences", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Preference)
      };
      return this.$_select("preferences", options as any) as any
    }
  

      
/**
 * Get a private message URL
 */
      privateMessageUrl<Args extends VariabledInput<{
        id: string,
      }>>(args: ExactArgNames<Args, {
        id: string,
      }>):$Field<"privateMessageUrl", string | null | undefined , GetVariables<[], Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        
      };
      return this.$_select("privateMessageUrl", options as any) as any
    }
  

      
/**
 * Get a pre-signed upload URL. You must supply EITHER mimeType (preferred) or filename.
 */
      requestMediaUploadUrl<Args extends VariabledInput<{
        filename?: string | null | undefined
mimeType?: string | null | undefined,
      }>,Sel extends Selection<PresignedUrl>>(args: ExactArgNames<Args, {
        filename?: string | null | undefined
mimeType?: string | null | undefined,
      }>, selectorFn: (s: PresignedUrl) => [...Sel]):$Field<"requestMediaUploadUrl", GetOutput<Sel> , GetVariables<Sel, Args>>
requestMediaUploadUrl<Sel extends Selection<PresignedUrl>>(selectorFn: (s: PresignedUrl) => [...Sel]):$Field<"requestMediaUploadUrl", GetOutput<Sel> , GetVariables<Sel>>
requestMediaUploadUrl(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              filename: "String",
mimeType: "String"
            },
        args,

        selection: selectorFn(new PresignedUrl)
      };
      return this.$_select("requestMediaUploadUrl", options as any) as any
    }
  

      
/**
 * Search comments by filter and sort criteria
 */
      searchComments<Args extends VariabledInput<{
        filter?: CommentsSearchFilter | null | undefined
sort?: Readonly<Array<CommentsSearchSort>> | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>,Sel extends Selection<CommentSearchResultConnection>>(args: ExactArgNames<Args, {
        filter?: CommentsSearchFilter | null | undefined
sort?: Readonly<Array<CommentsSearchSort>> | null | undefined
after?: string | null | undefined
before?: string | null | undefined
first?: number | null | undefined
last?: number | null | undefined,
      }>, selectorFn: (s: CommentSearchResultConnection) => [...Sel]):$Field<"searchComments", GetOutput<Sel> , GetVariables<Sel, Args>>
searchComments<Sel extends Selection<CommentSearchResultConnection>>(selectorFn: (s: CommentSearchResultConnection) => [...Sel]):$Field<"searchComments", GetOutput<Sel> , GetVariables<Sel>>
searchComments(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              filter: "CommentsSearchFilter",
sort: "[CommentsSearchSort!]",
after: "String",
before: "String",
first: "Int",
last: "Int"
            },
        args,

        selection: selectorFn(new CommentSearchResultConnection)
      };
      return this.$_select("searchComments", options as any) as any
    }
  

      
/**
 * Get the urls for running a speedtest to diagnose download issues
 */
      speedtestUrls<Sel extends Selection<SpeedtestUrl>>(selectorFn: (s: SpeedtestUrl) => [...Sel]):$Field<"speedtestUrls", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new SpeedtestUrl)
      };
      return this.$_select("speedtestUrls", options as any) as any
    }
  

      
/**
 * Starts the age verification appeal flow for the current user.
 */
      startAgeVerificationAppealFlow<Sel extends Selection<StartAgeVerificationFlowResponse>>(selectorFn: (s: StartAgeVerificationFlowResponse) => [...Sel]):$Field<"startAgeVerificationAppealFlow", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new StartAgeVerificationFlowResponse)
      };
      return this.$_select("startAgeVerificationAppealFlow", options as any) as any
    }
  

      
/**
 * Starts the age verification flow for the current user.
 */
      startAgeVerificationFlow<Sel extends Selection<StartAgeVerificationFlowResponse>>(selectorFn: (s: StartAgeVerificationFlowResponse) => [...Sel]):$Field<"startAgeVerificationFlow", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new StartAgeVerificationFlowResponse)
      };
      return this.$_select("startAgeVerificationFlow", options as any) as any
    }
  

      
/**
 * Get a tag by ID
 */
      tag<Args extends VariabledInput<{
        id: string,
      }>,Sel extends Selection<Tag>>(args: ExactArgNames<Args, {
        id: string,
      }>, selectorFn: (s: Tag) => [...Sel]):$Field<"tag", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        selection: selectorFn(new Tag)
      };
      return this.$_select("tag", options as any) as any
    }
  

      
/**
 * Get all tag categories
 */
      tagCategories<Sel extends Selection<TagCategory>>(selectorFn: (s: TagCategory) => [...Sel]):$Field<"tagCategories", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new TagCategory)
      };
      return this.$_select("tagCategories", options as any) as any
    }
  

      
/**
 * Get a tag category by ID
 */
      tagCategory<Args extends VariabledInput<{
        id: string,
      }>,Sel extends Selection<TagCategory>>(args: ExactArgNames<Args, {
        id: string,
      }>, selectorFn: (s: TagCategory) => [...Sel]):$Field<"tagCategory", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "ID!"
            },
        args,

        selection: selectorFn(new TagCategory)
      };
      return this.$_select("tagCategory", options as any) as any
    }
  

      
/**
 * Get a list of tags
 */
      tags<Args extends VariabledInput<{
        gameId?: number | null | undefined
categoryId?: number | null | undefined
includeGlobal?: boolean | null | undefined
includeDiscarded?: boolean | null | undefined,
      }>,Sel extends Selection<Tag>>(args: ExactArgNames<Args, {
        gameId?: number | null | undefined
categoryId?: number | null | undefined
includeGlobal?: boolean | null | undefined
includeDiscarded?: boolean | null | undefined,
      }>, selectorFn: (s: Tag) => [...Sel]):$Field<"tags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel, Args>>
tags<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"tags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>>
tags(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              gameId: "Int",
categoryId: "Int",
includeGlobal: "Boolean",
includeDiscarded: "Boolean"
            },
        args,

        selection: selectorFn(new Tag)
      };
      return this.$_select("tags", options as any) as any
    }
  

      
/**
 * Get a list of transactions, with paging and filtering
 */
      transactions<Args extends VariabledInput<{
        start?: number | null | undefined
perPage?: number | null | undefined
orderDir?: string | null | undefined
orderColumn?: string | null | undefined
accountId?: number | null | undefined
bankId?: number | null | undefined
search?: string | null | undefined,
      }>,Sel extends Selection<TransactionList>>(args: ExactArgNames<Args, {
        start?: number | null | undefined
perPage?: number | null | undefined
orderDir?: string | null | undefined
orderColumn?: string | null | undefined
accountId?: number | null | undefined
bankId?: number | null | undefined
search?: string | null | undefined,
      }>, selectorFn: (s: TransactionList) => [...Sel]):$Field<"transactions", GetOutput<Sel> , GetVariables<Sel, Args>>
transactions<Sel extends Selection<TransactionList>>(selectorFn: (s: TransactionList) => [...Sel]):$Field<"transactions", GetOutput<Sel> , GetVariables<Sel>>
transactions(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              start: "Int",
perPage: "Int",
orderDir: "String",
orderColumn: "String",
accountId: "Int",
bankId: "Int",
search: "String"
            },
        args,

        selection: selectorFn(new TransactionList)
      };
      return this.$_select("transactions", options as any) as any
    }
  

      
/**
 * Get a list of uploads
 */
      uploads<Args extends VariabledInput<{
        start: number
perPage: number
orderDir: string
orderColumn: string
id?: string | null | undefined
search?: string | null | undefined
filter?: string | null | undefined
uploadType?: string | null | undefined
gameId?: number | null | undefined
userId?: number | null | undefined
fileId?: number | null | undefined
modId?: number | null | undefined,
      }>,Sel extends Selection<UploadList>>(args: ExactArgNames<Args, {
        start: number
perPage: number
orderDir: string
orderColumn: string
id?: string | null | undefined
search?: string | null | undefined
filter?: string | null | undefined
uploadType?: string | null | undefined
gameId?: number | null | undefined
userId?: number | null | undefined
fileId?: number | null | undefined
modId?: number | null | undefined,
      }>, selectorFn: (s: UploadList) => [...Sel]):$Field<"uploads", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              start: "Int!",
perPage: "Int!",
orderDir: "String!",
orderColumn: "String!",
id: "String",
search: "String",
filter: "String",
uploadType: "String",
gameId: "Int",
userId: "Int",
fileId: "Int",
modId: "Int"
            },
        args,

        selection: selectorFn(new UploadList)
      };
      return this.$_select("uploads", options as any) as any
    }
  

      
/**
 * Get user by id
 */
      user<Args extends VariabledInput<{
        id: number,
      }>,Sel extends Selection<User>>(args: ExactArgNames<Args, {
        id: number,
      }>, selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              id: "Int!"
            },
        args,

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * Get user by username
 */
      userByName<Args extends VariabledInput<{
        name: string,
      }>,Sel extends Selection<User>>(args: ExactArgNames<Args, {
        name: string,
      }>, selectorFn: (s: User) => [...Sel]):$Field<"userByName", GetOutput<Sel> | undefined , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              name: "String!"
            },
        args,

        selection: selectorFn(new User)
      };
      return this.$_select("userByName", options as any) as any
    }
  

      
/**
 * Get a list of user donation preferences.
 */
      userDonationPreferences<Sel extends Selection<LegacyUserDonationPreferences>>(selectorFn: (s: LegacyUserDonationPreferences) => [...Sel]):$Field<"userDonationPreferences", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new LegacyUserDonationPreferences)
      };
      return this.$_select("userDonationPreferences", options as any) as any
    }
  

      
/**
 * Get monthly summary report for a specific user
 */
      userMonthlyReport<Args extends VariabledInput<{
        accountId: number
year: number
month: number,
      }>,Sel extends Selection<UserMonthlyReport>>(args: ExactArgNames<Args, {
        accountId: number
year: number
month: number,
      }>, selectorFn: (s: UserMonthlyReport) => [...Sel]):$Field<"userMonthlyReport", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              accountId: "Int!",
year: "Int!",
month: "Int!"
            },
        args,

        selection: selectorFn(new UserMonthlyReport)
      };
      return this.$_select("userMonthlyReport", options as any) as any
    }
  

      
/**
 * Get a specific report for a specific user
 */
      userMonthlyReportById<Args extends VariabledInput<{
        accountId: number
reportId: number,
      }>,Sel extends Selection<UserMonthlyReport>>(args: ExactArgNames<Args, {
        accountId: number
reportId: number,
      }>, selectorFn: (s: UserMonthlyReport) => [...Sel]):$Field<"userMonthlyReportById", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              accountId: "Int!",
reportId: "Int!"
            },
        args,

        selection: selectorFn(new UserMonthlyReport)
      };
      return this.$_select("userMonthlyReportById", options as any) as any
    }
  

      
/**
 * Get monthly summary report for a specific user
 */
      userMonthlySummary<Args extends VariabledInput<{
        accountId: number,
      }>,Sel extends Selection<UserMonthlySummary>>(args: ExactArgNames<Args, {
        accountId: number,
      }>, selectorFn: (s: UserMonthlySummary) => [...Sel]):$Field<"userMonthlySummary", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              accountId: "Int!"
            },
        args,

        selection: selectorFn(new UserMonthlySummary)
      };
      return this.$_select("userMonthlySummary", options as any) as any
    }
  

      
/**
 * Get a list of Users
 */
      users<Args extends VariabledInput<{
        filter?: UsersSearchFilter | null | undefined
sort?: Readonly<Array<UsersSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>,Sel extends Selection<UserPage>>(args: ExactArgNames<Args, {
        filter?: UsersSearchFilter | null | undefined
sort?: Readonly<Array<UsersSearchSort>> | null | undefined
offset?: number | null | undefined
count?: number | null | undefined,
      }>, selectorFn: (s: UserPage) => [...Sel]):$Field<"users", GetOutput<Sel> , GetVariables<Sel, Args>>
users<Sel extends Selection<UserPage>>(selectorFn: (s: UserPage) => [...Sel]):$Field<"users", GetOutput<Sel> , GetVariables<Sel>>
users(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              filter: "UsersSearchFilter",
sort: "[UsersSearchSort!]",
offset: "Int",
count: "Int"
            },
        args,

        selection: selectorFn(new UserPage)
      };
      return this.$_select("users", options as any) as any
    }
  

      
/**
 * Get a list of wallets, with paging and filtering
 */
      wallets<Args extends VariabledInput<{
        start?: number | null | undefined
perPage?: number | null | undefined
orderDir?: string | null | undefined
orderColumn?: string | null | undefined
search?: string | null | undefined,
      }>,Sel extends Selection<WalletList>>(args: ExactArgNames<Args, {
        start?: number | null | undefined
perPage?: number | null | undefined
orderDir?: string | null | undefined
orderColumn?: string | null | undefined
search?: string | null | undefined,
      }>, selectorFn: (s: WalletList) => [...Sel]):$Field<"wallets", GetOutput<Sel> , GetVariables<Sel, Args>>
wallets<Sel extends Selection<WalletList>>(selectorFn: (s: WalletList) => [...Sel]):$Field<"wallets", GetOutput<Sel> , GetVariables<Sel>>
wallets(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              start: "Int",
perPage: "Int",
orderDir: "String",
orderColumn: "String",
search: "String"
            },
        args,

        selection: selectorFn(new WalletList)
      };
      return this.$_select("wallets", options as any) as any
    }
  
}


export type RandomSortValue = {
  seed?: number | null | undefined
}
    

  
/**
 * Ratable Model Types
 */
export enum Ratable {
  
/**
 * A nexusmods Collection of Mods
 */
  CollectionRevision = "CollectionRevision",

/**
 * A Nexusmods Mod
 */
  Mod = "Mod"
}
  


/**
 * A Rating
 */
export class Rating extends $Base<"Rating"> {
  constructor() {
    super("Rating")
  }

  
      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Polymorphic ID of the entity being rated
 */
      get modelId(): $Field<"modelId", number>  {
       return this.$_select("modelId") as any
      }

      
/**
 * Polymorphic type of the entity being
rated
 */
      get modelType(): $Field<"modelType", string>  {
       return this.$_select("modelType") as any
      }

      
/**
 * Rating value
 */
      get rating(): $Field<"rating", string>  {
       return this.$_select("rating") as any
      }

      
/**
 * ID of the user that created this rating
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}

  
/**
 * Rating options
 */
export enum RatingOptions {
  
  positive = "positive",

  negative = "negative",

  abstained = "abstained"
}
  


/**
 * Autogenerated return type of RejectModerationFixMutation.
 */
export class RejectModerationFixMutationPayload extends $Base<"RejectModerationFixMutationPayload"> {
  constructor() {
    super("RejectModerationFixMutationPayload")
  }

  
      
/**
 * Return the moderation fix object
 */
      moderationFix<Sel extends Selection<ModerationFix>>(selectorFn: (s: ModerationFix) => [...Sel]):$Field<"moderationFix", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationFix)
      };
      return this.$_select("moderationFix", options as any) as any
    }
  

      
/**
 * Returns trus if the fix was rejected
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveBadgeFromCollectionMutation.
 */
export class RemoveBadgeFromCollectionMutationPayload extends $Base<"RemoveBadgeFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveBadgeFromCollectionMutationPayload")
  }

  
      
/**
 * True if badge was removed from the collection
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveCommentLikeMutation.
 */
export class RemoveCommentLikeMutationPayload extends $Base<"RemoveCommentLikeMutationPayload"> {
  constructor() {
    super("RemoveCommentLikeMutationPayload")
  }

  
      
/**
 * The comment that had its like removed.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of RemoveFavouriteGameMutation.
 */
export class RemoveFavouriteGameMutationPayload extends $Base<"RemoveFavouriteGameMutationPayload"> {
  constructor() {
    super("RemoveFavouriteGameMutationPayload")
  }

  
      
/**
 * True if the favourite was successfully removed
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveHeaderImageFromCollectionMutation.
 */
export class RemoveHeaderImageFromCollectionMutationPayload extends $Base<"RemoveHeaderImageFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveHeaderImageFromCollectionMutationPayload")
  }

  
      
/**
 * Returns true when image was removed successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveImageFromCollectionMutation.
 */
export class RemoveImageFromCollectionMutationPayload extends $Base<"RemoveImageFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveImageFromCollectionMutationPayload")
  }

  
      
/**
 * Returns true when image is removed successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveKudosMutation.
 */
export class RemoveKudosMutationPayload extends $Base<"RemoveKudosMutationPayload"> {
  constructor() {
    super("RemoveKudosMutationPayload")
  }

  
      
/**
 * True if the user has successfully had kudos removed
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveTagFromCollectionMutation.
 */
export class RemoveTagFromCollectionMutationPayload extends $Base<"RemoveTagFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveTagFromCollectionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveTileImageFromCollectionMutation.
 */
export class RemoveTileImageFromCollectionMutationPayload extends $Base<"RemoveTileImageFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveTileImageFromCollectionMutationPayload")
  }

  
      
/**
 * Returns true when image is removed successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of RemoveVideoFromCollectionMutation.
 */
export class RemoveVideoFromCollectionMutationPayload extends $Base<"RemoveVideoFromCollectionMutationPayload"> {
  constructor() {
    super("RemoveVideoFromCollectionMutationPayload")
  }

  
      
/**
 * Returns true when video is removed successfully.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of ReorderItem.
 */
export class ReorderItemPayload extends $Base<"ReorderItemPayload"> {
  constructor() {
    super("ReorderItemPayload")
  }

  
      
/**
 * The item that was moved.
 */
      item<Sel extends Selection<Reorderable>>(selectorFn: (s: Reorderable) => [...Sel]):$Field<"item", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Reorderable)
      };
      return this.$_select("item", options as any) as any
    }
  
}

  
/**
 * The relative location of an item in relation to another item.
 */
export enum ReorderLocation {
  
/**
 * Before the item.
 */
  BEFORE = "BEFORE",

/**
 * After the item.
 */
  AFTER = "AFTER"
}
  


/**
 * Autogenerated return type of ReorderPinnedCommentsMutation.
 */
export class ReorderPinnedCommentsMutationPayload extends $Base<"ReorderPinnedCommentsMutationPayload"> {
  constructor() {
    super("ReorderPinnedCommentsMutationPayload")
  }

  
      
/**
 * Pinned comments in a new order.
 */
      comments<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comments", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comments", options as any) as any
    }
  
}


/**
 * A reorderable entity.
 */
export class Reorderable extends $Interface<{CollectionImage: CollectionImage,CollectionVideo: CollectionVideo}, "Reorderable"> {
  constructor() {
    super({CollectionImage: CollectionImage,CollectionVideo: CollectionVideo}, "Reorderable")
  }
  
      
/**
 * The order of this entity in the list.
 */
      get order(): $Field<"order", string>  {
       return this.$_select("order") as any
      }
}


/**
 * Autogenerated return type of RestoreCommentMutation.
 */
export class RestoreCommentMutationPayload extends $Base<"RestoreCommentMutationPayload"> {
  constructor() {
    super("RestoreCommentMutationPayload")
  }

  
      
/**
 * The comment that was restored.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of RetractRevisionMutation.
 */
export class RetractRevisionMutationPayload extends $Base<"RetractRevisionMutationPayload"> {
  constructor() {
    super("RetractRevisionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A reason for which a revision has been retracted.
 */
export class RetractionReason extends $Base<"RetractionReason"> {
  constructor() {
    super("RetractionReason")
  }

  
      
/**
 * An immutable revision of a collection
 */
      get collectionRevisionId(): $Field<"collectionRevisionId", number>  {
       return this.$_select("collectionRevisionId") as any
      }

      
/**
 * Time of when this retraction reason was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The database ID for this retraction reason.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * User-provided reason for this retraction
 */
      get reason(): $Field<"reason", string>  {
       return this.$_select("reason") as any
      }

      
/**
 * Time of when this retraction reason was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}

  
/**
 * Sort directions: ASC, DESC
 */
export enum SortDirection {
  
/**
 * Ascending
 */
  ASC = "ASC",

/**
 * Descending
 */
  DESC = "DESC"
}
  


/**
 * A speedtest URL
 */
export class SpeedtestUrl extends $Base<"SpeedtestUrl"> {
  constructor() {
    super("SpeedtestUrl")
  }

  
      
/**
 * Description of this speedtest URL
 */
      get description(): $Field<"description", string | null | undefined>  {
       return this.$_select("description") as any
      }

      
/**
 * URL of the resource
 */
      get location(): $Field<"location", string | null | undefined>  {
       return this.$_select("location") as any
      }

      
/**
 * Tag of the resource
 */
      get tag(): $Field<"tag", string | null | undefined>  {
       return this.$_select("tag") as any
      }

      
/**
 * Resource name of this speedtest URL
 */
      get title(): $Field<"title", string | null | undefined>  {
       return this.$_select("title") as any
      }
}


/**
 * The gql result of a query to the age verification flow start.
 */
export class StartAgeVerificationFlowResponse extends $Base<"StartAgeVerificationFlowResponse"> {
  constructor() {
    super("StartAgeVerificationFlowResponse")
  }

  
      
/**
 * A message providing additional context about the request.
 */
      get message(): $Field<"message", string | null | undefined>  {
       return this.$_select("message") as any
      }

      
/**
 * True if the request to start the age verification flow was successful.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }

      
/**
 * The result of the age verification call.
 */
      verificationResult<Sel extends Selection<VerificationResult>>(selectorFn: (s: VerificationResult) => [...Sel]):$Field<"verificationResult", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new VerificationResult)
      };
      return this.$_select("verificationResult", options as any) as any
    }
  
}


/**
 * Autogenerated return type of SubmitModerationFixMutation.
 */
export class SubmitModerationFixMutationPayload extends $Base<"SubmitModerationFixMutationPayload"> {
  constructor() {
    super("SubmitModerationFixMutationPayload")
  }

  
      
/**
 * Return moderation fix object
 */
      moderationFix<Sel extends Selection<ModerationFix>>(selectorFn: (s: ModerationFix) => [...Sel]):$Field<"moderationFix", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationFix)
      };
      return this.$_select("moderationFix", options as any) as any
    }
  

      
/**
 * Returns true if this fix was created successfully
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * A supporter image
 */
export class SupporterImage extends $Base<"SupporterImage"> {
  constructor() {
    super("SupporterImage")
  }

  
      
/**
 * Whether comments are allowed on the image.
 */
      get allowComments(): $Field<"allowComments", boolean | null | undefined>  {
       return this.$_select("allowComments") as any
      }

      
/**
 * Whether ratings are allowed on the image.
 */
      get allowRating(): $Field<"allowRating", boolean | null | undefined>  {
       return this.$_select("allowRating") as any
      }

      
/**
 * A caption for this image
 */
      get caption(): $Field<"caption", string>  {
       return this.$_select("caption") as any
      }

      
/**
 * An image category
 */
      category<Sel extends Selection<ImageCategory>>(selectorFn: (s: ImageCategory) => [...Sel]):$Field<"category", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ImageCategory)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * Time of when this supporter_image was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * A detailed description of this image
 */
      get description(): $Field<"description", string>  {
       return this.$_select("description") as any
      }

      
/**
 * Game this image belongs to
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Status of this image
 */
      get mediaStatus(): $Field<"mediaStatus", MediaStatus>  {
       return this.$_select("mediaStatus") as any
      }

      
/**
 * Name of the image file
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Uploader of this image
 */
      owner<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"owner", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("owner", options as any) as any
    }
  

      
/**
 * Rating of this image
 */
      get rating(): $Field<"rating", number>  {
       return this.$_select("rating") as any
      }

      
/**
 * URL of the site this image is hosted on
 */
      get siteUrl(): $Field<"siteUrl", string>  {
       return this.$_select("siteUrl") as any
      }

      
/**
 * URL of the thumbnail of this image
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * A title for this image
 */
      get title(): $Field<"title", string | null | undefined>  {
       return this.$_select("title") as any
      }

      
/**
 * URL of this image
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }

      
/**
 * True if the viewer (current user) has ignored this image's author
 */
      get viewerBlocked(): $Field<"viewerBlocked", boolean>  {
       return this.$_select("viewerBlocked") as any
      }

      
/**
 * View count of this image
 */
      get views(): $Field<"views", number>  {
       return this.$_select("views") as any
      }
}


/**
 * The definition of a Tag Object. Deprecated.
Will be removed in a future release in favour of domain specific tag queries/mutations
 */
export class Tag extends $Base<"Tag"> {
  constructor() {
    super("Tag")
  }

  
      
/**
 * If true, this Tag is intended for adult content
 */
      get adult(): $Field<"adult", boolean>  {
       return this.$_select("adult") as any
      }

      
/**
 * Category that this tag belongs to
 */
      category<Sel extends Selection<TagCategory>>(selectorFn: (s: TagCategory) => [...Sel]):$Field<"category", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new TagCategory)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * Time of when this tag was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this tag was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * List of games that this tag is for
 */
      games<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"games", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("games", options as any) as any
    }
  

      
/**
 * If true, this Tag is global and not intended for a specific game
 */
      get global(): $Field<"global", boolean>  {
       return this.$_select("global") as any
      }

      
/**
 * The database ID for this tag.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this tag
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * Number of tagged entities for this tag
 */
      get taggablesCount(): $Field<"taggablesCount", number>  {
       return this.$_select("taggablesCount") as any
      }

      
/**
 * Time of when this tag was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}


/**
 * The definition of a Tag Category Object. Deprecated.
Will be removed in a future release in favour of domain specific tag queries/mutations
 */
export class TagCategory extends $Base<"TagCategory"> {
  constructor() {
    super("TagCategory")
  }

  
      
/**
 * Time of when this tag category was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Time of when this tag category was discarded.
 */
      get discardedAt(): $Field<"discardedAt", DateTime | null | undefined>  {
       return this.$_select("discardedAt") as any
      }

      
/**
 * The database ID for this tag category.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this Tag Category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * List of tags in this catgeory
 */
      tags<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"tags", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("tags", options as any) as any
    }
  

      
/**
 * Time of when this tag category was last updated.
 */
      get updatedAt(): $Field<"updatedAt", DateTime>  {
       return this.$_select("updatedAt") as any
      }
}

  
/**
 * Accepted Thumbnail Sizes
 */
export enum ThumbnailSize {
  
/**
 * 250px width
 */
  small = "small",

/**
 * 385px width
 */
  med = "med",

/**
 * 500px width
 */
  large = "large"
}
  


/**
 * Autogenerated return type of TrackAppMetricMutation.
 */
export class TrackAppMetricMutationPayload extends $Base<"TrackAppMetricMutationPayload"> {
  constructor() {
    super("TrackAppMetricMutationPayload")
  }

  
      
/**
 * The created metric event
 */
      appMetric<Sel extends Selection<AppMetric>>(selectorFn: (s: AppMetric) => [...Sel]):$Field<"appMetric", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new AppMetric)
      };
      return this.$_select("appMetric", options as any) as any
    }
  

      
/**
 * Any validation errors that occurred
 */
      get errors(): $Field<"errors", Readonly<Array<string>> | null | undefined>  {
       return this.$_select("errors") as any
      }

      
/**
 * Whether the metric was successfully tracked
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of TrackModMutation.
 */
export class TrackModMutationPayload extends $Base<"TrackModMutationPayload"> {
  constructor() {
    super("TrackModMutationPayload")
  }

  
      
/**
 * True if the request to track the mod was successful, or if the mod was already tracked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }

      
/**
 * Tracked mod entry.
 */
      trackedMod<Sel extends Selection<TrackedMod>>(selectorFn: (s: TrackedMod) => [...Sel]):$Field<"trackedMod", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new TrackedMod)
      };
      return this.$_select("trackedMod", options as any) as any
    }
  
}


/**
 * Autogenerated return type of TrackUserMutation.
 */
export class TrackUserMutationPayload extends $Base<"TrackUserMutationPayload"> {
  constructor() {
    super("TrackUserMutationPayload")
  }

  
      
/**
 * True if the request to track the user was successful
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Represents a user's tracking of a mod
 */
export class TrackedMod extends $Base<"TrackedMod"> {
  constructor() {
    super("TrackedMod")
  }

  
      
/**
 * The ID of the game that the tracked mod belongs to
 */
      get gameId(): $Field<"gameId", string>  {
       return this.$_select("gameId") as any
      }

      
/**
 * The ID of the mod that is tracked
 */
      get modId(): $Field<"modId", string>  {
       return this.$_select("modId") as any
      }

      
/**
 * The ID of the tracking user
 */
      get userId(): $Field<"userId", string>  {
       return this.$_select("userId") as any
      }
}


/**
 * A transaction
 */
export class Transaction extends $Base<"Transaction"> {
  constructor() {
    super("Transaction")
  }

  
      
/**
 * Amount of DP in this transaction
 */
      get amount(): $Field<"amount", number>  {
       return this.$_select("amount") as any
      }

      
/**
 * Time of when this transaction was first created.
 */
      get createdAt(): $Field<"createdAt", string>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * Account/Bank that DP is being sent to
 */
      get creditor(): $Field<"creditor", string | null | undefined>  {
       return this.$_select("creditor") as any
      }

      
/**
 * Account/Bank that DP is being sent to
 */
      creditorEntity<Sel extends Selection<PaymentEntity>>(selectorFn: (s: PaymentEntity) => [...Sel]):$Field<"creditorEntity", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PaymentEntity)
      };
      return this.$_select("creditorEntity", options as any) as any
    }
  

      
/**
 * Account/Bank that DP is being taken from
 */
      get debitor(): $Field<"debitor", string | null | undefined>  {
       return this.$_select("debitor") as any
      }

      
/**
 * Account/Bank that DP is being taken from
 */
      debitorEntity<Sel extends Selection<PaymentEntity>>(selectorFn: (s: PaymentEntity) => [...Sel]):$Field<"debitorEntity", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PaymentEntity)
      };
      return this.$_select("debitorEntity", options as any) as any
    }
  

      
/**
 * The database ID for this transaction.
 */
      get id(): $Field<"id", number>  {
       return this.$_select("id") as any
      }

      
/**
 * Descriptive label for this transaction
 */
      get label(): $Field<"label", string>  {
       return this.$_select("label") as any
      }

      
/**
 * Type of transaction E.g. 'refund', 'purchase' etc
 */
      get type(): $Field<"type", string>  {
       return this.$_select("type") as any
      }
}


/**
 * A list of transactions
 */
export class TransactionList extends $Base<"TransactionList"> {
  constructor() {
    super("TransactionList")
  }

  
      
/**
 * Number of transactions being filtered
 */
      get filteredCount(): $Field<"filteredCount", number>  {
       return this.$_select("filteredCount") as any
      }

      
/**
 * Total number of transactions in the system
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }

      
/**
 * List of Transactions
 */
      transactions<Sel extends Selection<Transaction>>(selectorFn: (s: Transaction) => [...Sel]):$Field<"transactions", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Transaction)
      };
      return this.$_select("transactions", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UnblockModsFromEarningDpMutation.
 */
export class UnblockModsFromEarningDpMutationPayload extends $Base<"UnblockModsFromEarningDpMutationPayload"> {
  constructor() {
    super("UnblockModsFromEarningDpMutationPayload")
  }

  
      
/**
 * True if the mods were successfully unblocked
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UnblockTagMutation.
 */
export class UnblockTagMutationPayload extends $Base<"UnblockTagMutationPayload"> {
  constructor() {
    super("UnblockTagMutationPayload")
  }

  
      
/**
 * If true, the tag is unblocked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UnblockUserMutation.
 */
export class UnblockUserMutationPayload extends $Base<"UnblockUserMutationPayload"> {
  constructor() {
    super("UnblockUserMutationPayload")
  }

  
      
/**
 * If true, the user is unignored.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UnignoreUserMutation.
 */
export class UnignoreUserMutationPayload extends $Base<"UnignoreUserMutationPayload"> {
  constructor() {
    super("UnignoreUserMutationPayload")
  }

  
      
/**
 * If true, the user is unignored.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UnlistCollectionMutation.
 */
export class UnlistCollectionMutationPayload extends $Base<"UnlistCollectionMutationPayload"> {
  constructor() {
    super("UnlistCollectionMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UnpinCommentMutation.
 */
export class UnpinCommentMutationPayload extends $Base<"UnpinCommentMutationPayload"> {
  constructor() {
    super("UnpinCommentMutationPayload")
  }

  
      
/**
 * The comment that was unpinned.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UntrackModMutation.
 */
export class UntrackModMutationPayload extends $Base<"UntrackModMutationPayload"> {
  constructor() {
    super("UntrackModMutationPayload")
  }

  
      
/**
 * True if the request to un-track the mod was successful, or if the mod was not being tracked.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UntrackUserMutation.
 */
export class UntrackUserMutationPayload extends $Base<"UntrackUserMutationPayload"> {
  constructor() {
    super("UntrackUserMutationPayload")
  }

  
      
/**
 * True if the request to stop tracking the user was successful
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UpdateAboutMeMutation.
 */
export class UpdateAboutMeMutationPayload extends $Base<"UpdateAboutMeMutationPayload"> {
  constructor() {
    super("UpdateAboutMeMutationPayload")
  }

  
      
/**
 * True if the bio was successfully updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UpdateChangelogMutation.
 */
export class UpdateChangelogMutationPayload extends $Base<"UpdateChangelogMutationPayload"> {
  constructor() {
    super("UpdateChangelogMutationPayload")
  }

  
      
/**
 * Updated Changelog ID
 */
      get changelogId(): $Field<"changelogId", number>  {
       return this.$_select("changelogId") as any
      }

      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UpdateCollectionBugReportMutation.
 */
export class UpdateCollectionBugReportMutationPayload extends $Base<"UpdateCollectionBugReportMutationPayload"> {
  constructor() {
    super("UpdateCollectionBugReportMutationPayload")
  }

  
      
/**
 * Collection bug report that was updated
 */
      collectionBugReport<Sel extends Selection<CollectionBugReport>>(selectorFn: (s: CollectionBugReport) => [...Sel]):$Field<"collectionBugReport", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CollectionBugReport)
      };
      return this.$_select("collectionBugReport", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UpdateCommentMutation.
 */
export class UpdateCommentMutationPayload extends $Base<"UpdateCommentMutationPayload"> {
  constructor() {
    super("UpdateCommentMutationPayload")
  }

  
      
/**
 * The comment that was updated.
 */
      comment<Sel extends Selection<Comment>>(selectorFn: (s: Comment) => [...Sel]):$Field<"comment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Comment)
      };
      return this.$_select("comment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UpdateCountryMutation.
 */
export class UpdateCountryMutationPayload extends $Base<"UpdateCountryMutationPayload"> {
  constructor() {
    super("UpdateCountryMutationPayload")
  }

  
      
/**
 * True if the country was successfully updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UpdateCsamDeletionRequest.
 */
export class UpdateCsamDeletionRequestPayload extends $Base<"UpdateCsamDeletionRequestPayload"> {
  constructor() {
    super("UpdateCsamDeletionRequestPayload")
  }

  
      
/**
 * The updated CSAM Deletion Request
 */
      csamDeletionRequest<Sel extends Selection<CsamDeletionRequest>>(selectorFn: (s: CsamDeletionRequest) => [...Sel]):$Field<"csamDeletionRequest", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new CsamDeletionRequest)
      };
      return this.$_select("csamDeletionRequest", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UpdateGameMutation.
 */
export class UpdateGameMutationPayload extends $Base<"UpdateGameMutationPayload"> {
  constructor() {
    super("UpdateGameMutationPayload")
  }

  
      
/**
 * If true, the game was updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Defines a Image Update request object
 */
export type UpdateImageInput = {
  altText?: string | null | undefined,
id: string,
title?: string | null | undefined
}
    

  
/**
 * Available update policies of a file resource
 */
export enum UpdatePolicy {
  
/**
 * Use the exact specified version
 */
  exact = "exact",

/**
 * Use the latest version
 */
  latest = "latest",

/**
 * Prefer the specified version if available
 */
  prefer = "prefer"
}
  


/**
 * Autogenerated return type of UpdateRevisionMutation.
 */
export class UpdateRevisionMutationPayload extends $Base<"UpdateRevisionMutationPayload"> {
  constructor() {
    super("UpdateRevisionMutationPayload")
  }

  
      
/**
 * The revision ID that was updated
 */
      get revisionId(): $Field<"revisionId", number>  {
       return this.$_select("revisionId") as any
      }

      
/**
 * If true, the revision was updated
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }
}


/**
 * Autogenerated return type of UpdateTagMutation.
 */
export class UpdateTagMutationPayload extends $Base<"UpdateTagMutationPayload"> {
  constructor() {
    super("UpdateTagMutationPayload")
  }

  
      
/**
 * Success Boolean
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }

      
/**
 * Updated Collection Tag
 */
      tag<Sel extends Selection<Tag>>(selectorFn: (s: Tag) => [...Sel]):$Field<"tag", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Tag)
      };
      return this.$_select("tag", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UpdateUserDonationPreferences.
 */
export class UpdateUserDonationPreferencesPayload extends $Base<"UpdateUserDonationPreferencesPayload"> {
  constructor() {
    super("UpdateUserDonationPreferencesPayload")
  }

  
      
/**
 * If true, the user's preferences were updated.
 */
      get success(): $Field<"success", boolean>  {
       return this.$_select("success") as any
      }

      
/**
 * If successful, the user's updated donation preferences.
 */
      userDonationPreferences<Sel extends Selection<LegacyUserDonationPreferences>>(selectorFn: (s: LegacyUserDonationPreferences) => [...Sel]):$Field<"userDonationPreferences", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new LegacyUserDonationPreferences)
      };
      return this.$_select("userDonationPreferences", options as any) as any
    }
  
}


export type Upload = string



/**
 * Autogenerated return type of UploadAttachmentMutation.
 */
export class UploadAttachmentMutationPayload extends $Base<"UploadAttachmentMutationPayload"> {
  constructor() {
    super("UploadAttachmentMutationPayload")
  }

  
      
/**
 * The uploaded file returns a signed_id that can be used to attach to objects.
 */
      attachment<Sel extends Selection<Attachment>>(selectorFn: (s: Attachment) => [...Sel]):$Field<"attachment", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Attachment)
      };
      return this.$_select("attachment", options as any) as any
    }
  
}


/**
 * Autogenerated return type of UploadGameArtworkV2Mutation.
 */
export class UploadGameArtworkV2MutationPayload extends $Base<"UploadGameArtworkV2MutationPayload"> {
  constructor() {
    super("UploadGameArtworkV2MutationPayload")
  }

  
      
/**
 * If true, the hero image was updated.
 */
      get successHero(): $Field<"successHero", boolean>  {
       return this.$_select("successHero") as any
      }

      
/**
 * If true, the thumbnail image was updated.
 */
      get successThumbnail(): $Field<"successThumbnail", boolean>  {
       return this.$_select("successThumbnail") as any
      }

      
/**
 * If true, the tile image was updated.
 */
      get successTile(): $Field<"successTile", boolean>  {
       return this.$_select("successTile") as any
      }
}


/**
 * Defines a Image Upload request object
 */
export type UploadImageInput = {
  altText?: string | null | undefined,
contentType: string,
id: string,
title?: string | null | undefined
}
    


/**
 * A list of upload
 */
export class UploadList extends $Base<"UploadList"> {
  constructor() {
    super("UploadList")
  }

  
      
/**
 * Number of uploads being filtered
 */
      get filteredCount(): $Field<"filteredCount", number>  {
       return this.$_select("filteredCount") as any
      }

      
/**
 * Total number of uploads
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }

      
/**
 * List of uploads
 */
      uploads<Sel extends Selection<ModUpload>>(selectorFn: (s: ModUpload) => [...Sel]):$Field<"uploads", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModUpload)
      };
      return this.$_select("uploads", options as any) as any
    }
  
}


/**
 * Defines a Video Upload request object
 */
export type UploadVideoInput = {
  url: string
}
    


/**
 * A Nexus Mods user
 */
export class User extends $Base<"User"> {
  constructor() {
    super("User")
  }

  
      
/**
 * User's bio
 */
      get about(): $Field<"about", string | null | undefined>  {
       return this.$_select("about") as any
      }

      
/**
 * The avatar for this user
 */
      get avatar(): $Field<"avatar", string>  {
       return this.$_select("avatar") as any
      }

      
/**
 * If true, this user has been banned
 */
      get banned(): $Field<"banned", boolean>  {
       return this.$_select("banned") as any
      }

      
/**
 * Timestamp at which user's new mods were blocked from earning DP
 */
      get blockedFromOptingInModsAt(): $Field<"blockedFromOptingInModsAt", DateTime | null | undefined>  {
       return this.$_select("blockedFromOptingInModsAt") as any
      }

      
/**
 * Number of collections uploaded by this user.
This does not include unlisted or moderated collections.
 */
      get collectionCount(): $Field<"collectionCount", number>  {
       return this.$_select("collectionCount") as any
      }

      
/**
 * The number of mods this user has contributed to
 */
      get contributedModCount(): $Field<"contributedModCount", number>  {
       return this.$_select("contributedModCount") as any
      }

      
/**
 * ISO Country Code
 */
      get country(): $Field<"country", string | null | undefined>  {
       return this.$_select("country") as any
      }

      
/**
 * If true, this user has been deleted
 */
      get deleted(): $Field<"deleted", boolean>  {
       return this.$_select("deleted") as any
      }

      
/**
 * If true, this user has enabled donations on their profile page
 */
      get donationsEnabled(): $Field<"donationsEnabled", boolean>  {
       return this.$_select("donationsEnabled") as any
      }

      
/**
 * If false, this user has specifically opted-out of the DP system. By default, all users are opted in.
 */
      get dpOptedIn(): $Field<"dpOptedIn", boolean>  {
       return this.$_select("dpOptedIn") as any
      }

      
/**
 * The user's email address. Users can only access their own protected data.
 */
      get email(): $Field<"email", string>  {
       return this.$_select("email") as any
      }

      
/**
 * Number of mod endorsements given by this user
 */
      get endorsementsGiven(): $Field<"endorsementsGiven", number>  {
       return this.$_select("endorsementsGiven") as any
      }

      
/**
 * The number of full page notifications this user has been served in the past.
 */
      get fullPageNotificationCount(): $Field<"fullPageNotificationCount", number | null | undefined>  {
       return this.$_select("fullPageNotificationCount") as any
      }

      
/**
 * If true, the viewer (current user) has
given kudos to this user.
 */
      get hasGivenKudos(): $Field<"hasGivenKudos", boolean>  {
       return this.$_select("hasGivenKudos") as any
      }

      
/**
 * Number of images uploaded by this user.
This does not include moderated images.
 */
      get imageCount(): $Field<"imageCount", number>  {
       return this.$_select("imageCount") as any
      }

      
/**
 * The user's last known IP Address. Users can only access their own protected data.
 */
      get ipAddress(): $Field<"ipAddress", string | null | undefined>  {
       return this.$_select("ipAddress") as any
      }

      
/**
 * If true, the viewer (current user) has
blocked this user.
 */
      get isBlocked(): $Field<"isBlocked", boolean>  {
       return this.$_select("isBlocked") as any
      }

      
/**
 * If true, the viewer (current user) is
tracking this user.
 */
      get isTracked(): $Field<"isTracked", boolean>  {
       return this.$_select("isTracked") as any
      }

      
/**
 * Date the user joined
 */
      get joined(): $Field<"joined", DateTime>  {
       return this.$_select("joined") as any
      }

      
/**
 * The number of 'kudos' given to this user
 */
      get kudos(): $Field<"kudos", number>  {
       return this.$_select("kudos") as any
      }

      
/**
 * Date the user was last active
 */
      get lastActive(): $Field<"lastActive", DateTime | null | undefined>  {
       return this.$_select("lastActive") as any
      }

      
/**
 * Legacy roles for this user. Returns an array of roles. E.g. "[SiteProgrammer, QA Tester]"
 */
      get legacyRoles(): $Field<"legacyRoles", Readonly<Array<string>>>  {
       return this.$_select("legacyRoles") as any
      }

      
/**
 * The database ID for this user.
 */
      get memberId(): $Field<"memberId", number>  {
       return this.$_select("memberId") as any
      }

      
/**
 * Membership status for this user. Returns an array of roles. E.g. all users are "member"
 */
      get membershipRoles(): $Field<"membershipRoles", Readonly<Array<string>>>  {
       return this.$_select("membershipRoles") as any
      }

      
/**
 * The analytics for the user's mods, grouped by month
 */
      modAnalyticsByMonth<Args extends VariabledInput<{
        affiliation?: ModAffiliation | null | undefined
page?: number | null | undefined
pageSize?: number | null | undefined
sortBy?: ModAnalyticsByMonthSortBy | null | undefined
sortDirection?: SortDirection | null | undefined,
      }>,Sel extends Selection<ModAnalyticsByMonthPage>>(args: ExactArgNames<Args, {
        affiliation?: ModAffiliation | null | undefined
page?: number | null | undefined
pageSize?: number | null | undefined
sortBy?: ModAnalyticsByMonthSortBy | null | undefined
sortDirection?: SortDirection | null | undefined,
      }>, selectorFn: (s: ModAnalyticsByMonthPage) => [...Sel]):$Field<"modAnalyticsByMonth", GetOutput<Sel> , GetVariables<Sel, Args>>
modAnalyticsByMonth<Sel extends Selection<ModAnalyticsByMonthPage>>(selectorFn: (s: ModAnalyticsByMonthPage) => [...Sel]):$Field<"modAnalyticsByMonth", GetOutput<Sel> , GetVariables<Sel>>
modAnalyticsByMonth(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              affiliation: "ModAffiliation",
page: "Int",
pageSize: "Int",
sortBy: "ModAnalyticsByMonthSortBy",
sortDirection: "SortDirection"
            },
        args,

        selection: selectorFn(new ModAnalyticsByMonthPage)
      };
      return this.$_select("modAnalyticsByMonth", options as any) as any
    }
  

      
/**
 * The analytics for the user's mods for a specific month
 */
      modAnalyticsForMonth<Args extends VariabledInput<{
        year: number
month: number
query?: string | null | undefined
affiliation?: ModAffiliation | null | undefined
page?: number | null | undefined
pageSize?: number | null | undefined
sortBy?: ModAnalyticsForMonthSortBy | null | undefined
sortDirection?: SortDirection | null | undefined,
      }>,Sel extends Selection<ModAnalyticsForMonthPage>>(args: ExactArgNames<Args, {
        year: number
month: number
query?: string | null | undefined
affiliation?: ModAffiliation | null | undefined
page?: number | null | undefined
pageSize?: number | null | undefined
sortBy?: ModAnalyticsForMonthSortBy | null | undefined
sortDirection?: SortDirection | null | undefined,
      }>, selectorFn: (s: ModAnalyticsForMonthPage) => [...Sel]):$Field<"modAnalyticsForMonth", GetOutput<Sel> , GetVariables<Sel, Args>> {
      
      const options = {
        argTypes: {
              year: "Int!",
month: "Int!",
query: "String",
affiliation: "ModAffiliation",
page: "Int",
pageSize: "Int",
sortBy: "ModAnalyticsForMonthSortBy",
sortDirection: "SortDirection"
            },
        args,

        selection: selectorFn(new ModAnalyticsForMonthPage)
      };
      return this.$_select("modAnalyticsForMonth", options as any) as any
    }
  

      
/**
 * Number of mods uploaded by this user.
This does not include hidden, moderated or unpublished mods.
 */
      get modCount(): $Field<"modCount", number>  {
       return this.$_select("modCount") as any
      }

      
/**
 * The number of moderation warnings this user has been served in the past.
 */
      get moderationHistoryCount(): $Field<"moderationHistoryCount", number | null | undefined>  {
       return this.$_select("moderationHistoryCount") as any
      }

      
/**
 * JWT token for submitting moderation reports
 */
      get moderationJwt(): $Field<"moderationJwt", string>  {
       return this.$_select("moderationJwt") as any
      }

      
/**
 * A list of mods blocked from earning dp
 */
      modsBlockedFromEarningDp<Args extends VariabledInput<{
        count?: number | null | undefined
offset?: number | null | undefined,
      }>,Sel extends Selection<BlockedModsPage>>(args: ExactArgNames<Args, {
        count?: number | null | undefined
offset?: number | null | undefined,
      }>, selectorFn: (s: BlockedModsPage) => [...Sel]):$Field<"modsBlockedFromEarningDp", GetOutput<Sel> , GetVariables<Sel, Args>>
modsBlockedFromEarningDp<Sel extends Selection<BlockedModsPage>>(selectorFn: (s: BlockedModsPage) => [...Sel]):$Field<"modsBlockedFromEarningDp", GetOutput<Sel> , GetVariables<Sel>>
modsBlockedFromEarningDp(arg1: any, arg2?: any) {
      const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

      const options = {
        argTypes: {
              count: "Int",
offset: "Int"
            },
        args,

        selection: selectorFn(new BlockedModsPage)
      };
      return this.$_select("modsBlockedFromEarningDp", options as any) as any
    }
  

      
/**
 * The user's username.
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }

      
/**
 * The number of mods this user has uploaded
 */
      get ownedModCount(): $Field<"ownedModCount", number>  {
       return this.$_select("ownedModCount") as any
      }

      
/**
 * Email address used for PayPal donations. Users can only access their own protected data.
 */
      get paypal(): $Field<"paypal", string | null | undefined>  {
       return this.$_select("paypal") as any
      }

      
/**
 * The number of forum posts by this user
 */
      get posts(): $Field<"posts", number>  {
       return this.$_select("posts") as any
      }

      
/**
 * If true, this user is a
recognised mod author
 */
      get recognizedAuthor(): $Field<"recognizedAuthor", boolean>  {
       return this.$_select("recognizedAuthor") as any
      }

      
/**
 * Roles for this user. Returns an array of roles. E.g. "[Admin, Moderator]"
 */
      get roles(): $Field<"roles", Readonly<Array<string>>>  {
       return this.$_select("roles") as any
      }

      
/**
 * If true, this user has opted to
show their activity feed on their user profile page
 */
      get showActivityFeed(): $Field<"showActivityFeed", boolean>  {
       return this.$_select("showActivityFeed") as any
      }

      
/**
 * If true, this user has opted to
show the date they were last active on their user profile page
 */
      get showLastActive(): $Field<"showLastActive", boolean>  {
       return this.$_select("showLastActive") as any
      }

      
/**
 * Number of unique mod downloads on this users mods
 */
      get uniqueModDownloads(): $Field<"uniqueModDownloads", number>  {
       return this.$_select("uniqueModDownloads") as any
      }

      
/**
 * Date the user last
changed their username. Only users can access their own protected data.
 */
      get usernameLastChangedAt(): $Field<"usernameLastChangedAt", DateTime | null | undefined>  {
       return this.$_select("usernameLastChangedAt") as any
      }

      
/**
 * Number of videos uploaded by this user.
This does not include moderated videos.
 */
      get videoCount(): $Field<"videoCount", number>  {
       return this.$_select("videoCount") as any
      }

      
/**
 * Whether the viewer has blocked the content owner.
 */
      get viewerHasBlocked(): $Field<"viewerHasBlocked", boolean | null | undefined>  {
       return this.$_select("viewerHasBlocked") as any
      }

      
/**
 * Whether the viewer has ignored the content owner.
 */
      get viewerHasIgnored(): $Field<"viewerHasIgnored", boolean>  {
       return this.$_select("viewerHasIgnored") as any
      }

      
/**
 * Number of profile views
 */
      get views(): $Field<"views", number>  {
       return this.$_select("views") as any
      }
}


/**
 * The connection type for User.
 */
export class UserConnection extends $Base<"UserConnection"> {
  constructor() {
    super("UserConnection")
  }

  
      
/**
 * A list of edges.
 */
      edges<Sel extends Selection<UserEdge>>(selectorFn: (s: UserEdge) => [...Sel]):$Field<"edges", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new UserEdge)
      };
      return this.$_select("edges", options as any) as any
    }
  

      
/**
 * A list of nodes.
 */
      nodes<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel> | undefined> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Information to aid in pagination.
 */
      pageInfo<Sel extends Selection<PageInfo>>(selectorFn: (s: PageInfo) => [...Sel]):$Field<"pageInfo", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new PageInfo)
      };
      return this.$_select("pageInfo", options as any) as any
    }
  

      
/**
 * Total # of objects returned from this Plural Query
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * An edge in a connection.
 */
export class UserEdge extends $Base<"UserEdge"> {
  constructor() {
    super("UserEdge")
  }

  
      
/**
 * A cursor for use in pagination.
 */
      get cursor(): $Field<"cursor", string>  {
       return this.$_select("cursor") as any
      }

      
/**
 * The item at the end of the edge.
 */
      node<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"node", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("node", options as any) as any
    }
  
}


/**
 * Monthly detailed report for for a particular user/account
    on how much DP/downloads they have received for which mod/game
 */
export class UserMonthlyReport extends $Base<"UserMonthlyReport"> {
  constructor() {
    super("UserMonthlyReport")
  }

  
      
/**
 * List of entries in this report
 */
      entries<Sel extends Selection<UserMonthlyReportEntry>>(selectorFn: (s: UserMonthlyReportEntry) => [...Sel]):$Field<"entries", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new UserMonthlyReportEntry)
      };
      return this.$_select("entries", options as any) as any
    }
  

      
/**
 * Type of report
 */
      get reportType(): $Field<"reportType", DonationReport>  {
       return this.$_select("reportType") as any
      }

      
/**
 * A Nexus Mods user
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * The database ID for this user.
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * A more detailed entry for UserMonthlyReport, with a breakdown for a specific month for each mod
 */
export class UserMonthlyReportEntry extends $Base<"UserMonthlyReportEntry"> {
  constructor() {
    super("UserMonthlyReportEntry")
  }

  
      
/**
 * A Nexus Mods user
 */
      author<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"author", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("author", options as any) as any
    }
  

      
/**
 * Number of authors that give this user DP
 */
      get authorCount(): $Field<"authorCount", number | null | undefined>  {
       return this.$_select("authorCount") as any
      }

      
/**
 * The database ID for this user.
 */
      get authorId(): $Field<"authorId", number | null | undefined>  {
       return this.$_select("authorId") as any
      }

      
/**
 * Total DP value from all authors this user gets DP from, including DP not shared with this
user.
 */
      get authorValue(): $Field<"authorValue", number | null | undefined>  {
       return this.$_select("authorValue") as any
      }

      
/**
 * A Game
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * The database ID for this game.
 */
      get gameId(): $Field<"gameId", number | null | undefined>  {
       return this.$_select("gameId") as any
      }

      
/**
 * A mod
 */
      mod<Sel extends Selection<Mod>>(selectorFn: (s: Mod) => [...Sel]):$Field<"mod", GetOutput<Sel> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Mod)
      };
      return this.$_select("mod", options as any) as any
    }
  

      
/**
 * Number of mods that this user appears in
 */
      get modCount(): $Field<"modCount", number | null | undefined>  {
       return this.$_select("modCount") as any
      }

      
/**
 * The database ID for this mod.
 */
      get modId(): $Field<"modId", number | null | undefined>  {
       return this.$_select("modId") as any
      }

      
/**
 * Total DP value from all mods this user appears in, including DP not shared with this user.
 */
      get modValue(): $Field<"modValue", number | null | undefined>  {
       return this.$_select("modValue") as any
      }

      
/**
 * Month that this entry is for
 */
      get month(): $Field<"month", number>  {
       return this.$_select("month") as any
      }

      
/**
 * Ratio of how much of the DP earned for a mod or author is given to this user
 */
      get ratio(): $Field<"ratio", number>  {
       return this.$_select("ratio") as any
      }

      
/**
 * The database ID for this donation report.
 */
      get reportId(): $Field<"reportId", number>  {
       return this.$_select("reportId") as any
      }

      
/**
 * Opt-in status of this mod
 */
      get status(): $Field<"status", number>  {
       return this.$_select("status") as any
      }

      
/**
 * Total DP granted to this user in this entry
 */
      get value(): $Field<"value", number>  {
       return this.$_select("value") as any
      }

      
/**
 * Year that this entry is for
 */
      get year(): $Field<"year", number>  {
       return this.$_select("year") as any
      }
}


/**
 * Monthly summary for for a particular user/account on how much DP/downloads they have received
 */
export class UserMonthlySummary extends $Base<"UserMonthlySummary"> {
  constructor() {
    super("UserMonthlySummary")
  }

  
      
/**
 * List of summary report entries for this month
 */
      entries<Sel extends Selection<UserMonthlySummaryEntry>>(selectorFn: (s: UserMonthlySummaryEntry) => [...Sel]):$Field<"entries", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new UserMonthlySummaryEntry)
      };
      return this.$_select("entries", options as any) as any
    }
  

      
/**
 * A Nexus Mods user
 */
      user<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"user", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("user", options as any) as any
    }
  

      
/**
 * The database ID for this user.
 */
      get userId(): $Field<"userId", number>  {
       return this.$_select("userId") as any
      }
}


/**
 * An entry for UserMonthlySummary, with a breakdown for a specific month
 */
export class UserMonthlySummaryEntry extends $Base<"UserMonthlySummaryEntry"> {
  constructor() {
    super("UserMonthlySummaryEntry")
  }

  
      
/**
 * Number of mods that this user appears in
 */
      get modCount(): $Field<"modCount", number>  {
       return this.$_select("modCount") as any
      }

      
/**
 * Total DP value from all mods this user appears in, including DP not shared with this user.
 */
      get modValue(): $Field<"modValue", number>  {
       return this.$_select("modValue") as any
      }

      
/**
 * Month that this entry is for
 */
      get month(): $Field<"month", number>  {
       return this.$_select("month") as any
      }

      
/**
 * Type of report
 */
      get reportType(): $Field<"reportType", DonationReport>  {
       return this.$_select("reportType") as any
      }

      
/**
 * Total DP granted to this user in this entry
 */
      get value(): $Field<"value", number>  {
       return this.$_select("value") as any
      }

      
/**
 * Year that this entry is for
 */
      get year(): $Field<"year", number>  {
       return this.$_select("year") as any
      }
}


export class UserPage extends $Base<"UserPage"> {
  constructor() {
    super("UserPage")
  }

  
      
/**
 * Facets available, if supported for this query and requested.
 */
      facets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"facets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("facets", options as any) as any
    }
  

      
/**
 * Facets available, if supported for this query and requested. Schema is {"facetName":{"facetValue":count}}
 */
      get facetsData(): $Field<"facetsData", JSON | null | undefined>  {
       return this.$_select("facetsData") as any
      }

      
/**
 * Nodes for pagination
 */
      nodes<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"nodes", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("nodes", options as any) as any
    }
  

      
/**
 * Number of nodes returned by this query
 */
      get nodesCount(): $Field<"nodesCount", number>  {
       return this.$_select("nodesCount") as any
      }

      
/**
 * Facets available, if supported for this query and requested.
 */
      nodesFacets<Sel extends Selection<NodesFacet>>(selectorFn: (s: NodesFacet) => [...Sel]):$Field<"nodesFacets", Array<GetOutput<Sel>> | undefined , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new NodesFacet)
      };
      return this.$_select("nodesFacets", options as any) as any
    }
  

      
/**
 * String representation of the filter query used to locate the nodes.
 */
      get nodesFilter(): $Field<"nodesFilter", string | null | undefined>  {
       return this.$_select("nodesFilter") as any
      }

      
/**
 * Total number of collections found.
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * A return type for the current warnings query
 */
export class UserWarnings extends $Base<"UserWarnings"> {
  constructor() {
    super("UserWarnings")
  }

  
      
/**
 * List of unread global notices
 */
      unreadGlobalNotices<Sel extends Selection<GlobalNotice>>(selectorFn: (s: GlobalNotice) => [...Sel]):$Field<"unreadGlobalNotices", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new GlobalNotice)
      };
      return this.$_select("unreadGlobalNotices", options as any) as any
    }
  

      
/**
 * List of unread warnings
 */
      unreadWarnings<Sel extends Selection<ModerationWarning>>(selectorFn: (s: ModerationWarning) => [...Sel]):$Field<"unreadWarnings", Array<GetOutput<Sel>> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new ModerationWarning)
      };
      return this.$_select("unreadWarnings", options as any) as any
    }
  
}


/**
 * Filter fields specific to a Users query
 */
export type UsersSearchFilter = {
  filter?: Readonly<Array<UsersSearchFilter>> | null | undefined,
nameExact?: Readonly<Array<BaseFilterValueEqualsMatches>> | null | undefined,
nameWildcard?: Readonly<Array<BaseFilterValue>> | null | undefined,
op?: FilterLogicalOperator | null | undefined
}
    


/**
 * Sort fields specific to a Users query.
 */
export type UsersSearchSort = {
  name?: BaseSortValue | null | undefined,
relevance?: BaseSortValue | null | undefined
}
    


/**
 * The result of a query to the age verification flow start from the API.
 */
export class VerificationResult extends $Base<"VerificationResult"> {
  constructor() {
    super("VerificationResult")
  }

  
      
/**
 * Age verification flow ID, used to track the verification process
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * URL of the age verify widget to embed in the page
 */
      get url(): $Field<"url", string>  {
       return this.$_select("url") as any
      }
}


/**
 * A video
 */
export class Video extends $Base<"Video"> {
  constructor() {
    super("Video")
  }

  
      
/**
 * Whether comments are allowed on the video.
 */
      get allowComments(): $Field<"allowComments", boolean | null | undefined>  {
       return this.$_select("allowComments") as any
      }

      
/**
 * Whether ratings are allowed on the video.
 */
      get allowRating(): $Field<"allowRating", boolean | null | undefined>  {
       return this.$_select("allowRating") as any
      }

      
/**
 * An video category
 */
      category<Sel extends Selection<VideoCategory>>(selectorFn: (s: VideoCategory) => [...Sel]):$Field<"category", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new VideoCategory)
      };
      return this.$_select("category", options as any) as any
    }
  

      
/**
 * Time of when this video was first created.
 */
      get createdAt(): $Field<"createdAt", DateTime>  {
       return this.$_select("createdAt") as any
      }

      
/**
 * The description of the video.
 */
      get description(): $Field<"description", string | null | undefined>  {
       return this.$_select("description") as any
      }

      
/**
 * Game this video belongs to
 */
      game<Sel extends Selection<Game>>(selectorFn: (s: Game) => [...Sel]):$Field<"game", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new Game)
      };
      return this.$_select("game", options as any) as any
    }
  

      
/**
 * ID of the object.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * The URL of the video.
 */
      get link(): $Field<"link", string>  {
       return this.$_select("link") as any
      }

      
/**
 * Status of this video
 */
      get mediaStatus(): $Field<"mediaStatus", MediaStatus>  {
       return this.$_select("mediaStatus") as any
      }

      
/**
 * Uploader of this video
 */
      owner<Sel extends Selection<User>>(selectorFn: (s: User) => [...Sel]):$Field<"owner", GetOutput<Sel> , GetVariables<Sel>> {
      
      const options = {
        
        

        selection: selectorFn(new User)
      };
      return this.$_select("owner", options as any) as any
    }
  

      
/**
 * The rating of the video.
 */
      get rating(): $Field<"rating", number>  {
       return this.$_select("rating") as any
      }

      
/**
 * URL of the site this video is hosted on
 */
      get siteUrl(): $Field<"siteUrl", string>  {
       return this.$_select("siteUrl") as any
      }

      
/**
 * The URL of the video thumbnail.
 */
      get thumbnailUrl(): $Field<"thumbnailUrl", string>  {
       return this.$_select("thumbnailUrl") as any
      }

      
/**
 * The title of the video.
 */
      get title(): $Field<"title", string | null | undefined>  {
       return this.$_select("title") as any
      }

      
/**
 * True if the viewer (current user) has ignored this video's author
 */
      get viewerBlocked(): $Field<"viewerBlocked", boolean>  {
       return this.$_select("viewerBlocked") as any
      }

      
/**
 * The number of views the video has.
 */
      get views(): $Field<"views", number>  {
       return this.$_select("views") as any
      }
}


/**
 * An video category
 */
export class VideoCategory extends $Base<"VideoCategory"> {
  constructor() {
    super("VideoCategory")
  }

  
      
/**
 * Unix timestamp of category creation
 */
      get date(): $Field<"date", number | null | undefined>  {
       return this.$_select("date") as any
      }

      
/**
 * The database ID for this video category.
 */
      get id(): $Field<"id", string>  {
       return this.$_select("id") as any
      }

      
/**
 * Name of this category
 */
      get name(): $Field<"name", string>  {
       return this.$_select("name") as any
      }
}

  
/**
 * Records the outcome of the virus scan for a mod file.
 */
export enum VirusScanStatus {
  
  NOT_SCANNED = "NOT_SCANNED",

  QUEUED = "QUEUED",

  WAITING_REPORT = "WAITING_REPORT",

  VERIFIED = "VERIFIED",

  INTERNALLY_VERIFIED = "INTERNALLY_VERIFIED",

  QUARANTINED = "QUARANTINED",

  MANUALLY_VERIFIED = "MANUALLY_VERIFIED",

  MOD_DOES_NOT_EXIST = "MOD_DOES_NOT_EXIST",

  FILE_NOT_FOUND = "FILE_NOT_FOUND",

  REPORT_ERROR = "REPORT_ERROR",

  TOO_LARGE = "TOO_LARGE"
}
  


/**
 * A list of wallets. Users must have admin access.
 */
export class WalletList extends $Base<"WalletList"> {
  constructor() {
    super("WalletList")
  }

  
      
/**
 * Number of wallets being filtered
 */
      get filteredCount(): $Field<"filteredCount", number>  {
       return this.$_select("filteredCount") as any
      }

      
/**
 * Total number of wallets in the system
 */
      get totalCount(): $Field<"totalCount", number>  {
       return this.$_select("totalCount") as any
      }
}


/**
 * Autogenerated return type of WriteFullPageNotificationToUserMutation.
 */
export class WriteFullPageNotificationToUserMutationPayload extends $Base<"WriteFullPageNotificationToUserMutationPayload"> {
  constructor() {
    super("WriteFullPageNotificationToUserMutationPayload")
  }

  
      
/**
 * Full page notification created successfully
 */
      get success(): $Field<"success", boolean | null | undefined>  {
       return this.$_select("success") as any
      }
}

  const $Root = {
    query: Query,
mutation: Mutation
  }

  namespace $RootTypes {
    export type query = Query
export type mutation = Mutation
  }
  

export function query<Sel extends Selection<$RootTypes.query>>(
  name: string,
  selectFn: (q: $RootTypes.query) => [...Sel]
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>
export function query<Sel extends Selection<$RootTypes.query>>(
  selectFn: (q: $RootTypes.query) => [...Sel]
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>
export function query<Sel extends Selection<$RootTypes.query>>(name: any, selectFn?: any) {
  if (!selectFn) {
    selectFn = name
    name = ''
  }
  let field = new $Field<'query', GetOutput<Sel>, GetVariables<Sel>>('query', {
    selection: selectFn(new $Root.query()),
  })
  const str = fieldToQuery(`query ${name}`, field)

  return gql(str) as any
}


export function mutation<Sel extends Selection<$RootTypes.mutation>>(
  name: string,
  selectFn: (q: $RootTypes.mutation) => [...Sel]
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>
export function mutation<Sel extends Selection<$RootTypes.mutation>>(
  selectFn: (q: $RootTypes.mutation) => [...Sel]
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>
export function mutation<Sel extends Selection<$RootTypes.query>>(name: any, selectFn?: any) {
  if (!selectFn) {
    selectFn = name
    name = ''
  }
  let field = new $Field<'mutation', GetOutput<Sel>, GetVariables<Sel>>('mutation', {
    selection: selectFn(new $Root.mutation()),
  })
  const str = fieldToQuery(`mutation ${name}`, field)

  return gql(str) as any
}


const $InputTypes: {[key: string]: {[key: string]: string}} = {
    BaseFilterValue: {
    op: "FilterComparisonOperator",
value: "String!"
  },
  BaseFilterValueEqualsMatches: {
    op: "FilterComparisonOperatorEqualsMatches",
value: "String!"
  },
  BaseFilterValueEqualsWildcard: {
    op: "FilterComparisonOperatorEqualsWildcard",
value: "String!"
  },
  BaseFilterValueNumeric: {
    op: "FilterComparisonOperatorNumeric",
value: "String!"
  },
  BaseSortValue: {
    direction: "SortDirection!"
  },
  BooleanFilterValue: {
    op: "FilterComparisonOperator",
value: "Boolean!"
  },
  CollectionGeneralSearchFilterValue: {
    op: "FilterComparisonOperator",
value: "String!"
  },
  CollectionManifest: {
    info: "CollectionManifestInfo!",
mods: "[CollectionManifestMod!]!"
  },
  CollectionManifestInfo: {
    author: "String!",
authorUrl: "String",
description: "String",
domainName: "String!",
gameVersions: "[String!]",
name: "String!",
summary: "String"
  },
  CollectionManifestMod: {
    author: "String",
domainName: "String!",
name: "String!",
optional: "Boolean!",
source: "CollectionManifestModSource!",
version: "String!"
  },
  CollectionManifestModSource: {
    adultContent: "Boolean",
fileExpression: "String",
fileId: "Int",
fileSize: "Int",
logicalFilename: "String",
md5: "String",
modId: "Int",
type: "ModSource!",
updatePolicy: "UpdatePolicy",
url: "String"
  },
  CollectionPayload: {
    adultContent: "Boolean!",
collectionManifest: "CollectionManifest!",
collectionSchemaId: "Int!"
  },
  CollectionsFacet: {
    adultContent: "[String!]",
badges: "[String!]",
categoryName: "[String!]",
collectionRating: "[String!]",
collectionStatus: "[String!]",
gameIds: "[String!]",
gameName: "[String!]",
gameVersion: "[String!]",
tag: "[String!]"
  },
  CollectionsFilter: {
    adultContent: "[BooleanFilterValue!]",
categoryId: "[BaseFilterValue!]",
categoryName: "[BaseFilterValue!]",
collectionRating: "[BaseFilterValue!]",
collectionStatus: "[BaseFilterValue!]",
filter: "[CollectionsFilter!]",
gameDomain: "[BaseFilterValue!]",
gameId: "[BaseFilterValue!]",
gameName: "[BaseFilterValue!]",
gameVersion: "[BaseFilterValue!]",
generalSearch: "[CollectionGeneralSearchFilterValue!]",
hasDraftRevision: "[BooleanFilterValue!]",
hasPublishedRevision: "[BooleanFilterValue!]",
modUid: "[BaseFilterValue!]",
name: "[BaseFilterValue!]",
op: "FilterLogicalOperator",
tag: "[BaseFilterValue!]"
  },
  CollectionsSearchFilter: {
    adultContent: "[BooleanFilterValue!]",
badges: "[ExistsFilter!]",
categoryId: "[BaseFilterValue!]",
categoryName: "[BaseFilterValue!]",
collectionRating: "[BaseFilterValue!]",
collectionStatus: "[BaseFilterValue!]",
createdAt: "[BaseFilterValue!]",
filter: "[CollectionsSearchFilter!]",
gameDomain: "[BaseFilterValue!]",
gameId: "[BaseFilterValue!]",
gameName: "[BaseFilterValue!]",
gameVersion: "[BaseFilterValue!]",
generalSearch: "[CollectionGeneralSearchFilterValue!]",
hasDraftRevision: "[BooleanFilterValue!]",
hasPublishedRevision: "[BooleanFilterValue!]",
modUid: "[BaseFilterValue!]",
name: "[BaseFilterValue!]",
op: "FilterLogicalOperator",
recentRating: "[FloatFilterValue!]",
recentRatingCount: "[IntFilterValue!]",
tag: "[BaseFilterValue!]",
updatedAt: "[BaseFilterValue!]",
userId: "[BaseFilterValue!]"
  },
  CollectionsSearchSort: {
    createdAt: "BaseSortValue",
downloads: "BaseSortValue",
endorsements: "BaseSortValue",
rating: "BaseSortValue",
recentRating: "BaseSortValue",
relevance: "BaseSortValue",
updatedAt: "BaseSortValue"
  },
  CommentsSearchFilter: {
    filter: "[CommentsSearchFilter!]",
op: "FilterLogicalOperator",
query: "[BaseFilterValue!]",
threadId: "[BaseFilterValue!]"
  },
  CommentsSearchSort: {
    relevance: "BaseSortValue"
  },
  CompositeDomainWithIdInput: {
    gameDomain: "String!",
modId: "Int!"
  },
  CompositeIdInput: {
    gameId: "Int!",
modId: "Int!"
  },
  CsamDeletionRequestCDNFilePathResult: {
    message: "String!",
path: "String!",
status: "String!"
  },
  CsamDeletionRequestCDNResult: {
    hostname: "String!",
processedAt: "DateTime!",
results: "[CsamDeletionRequestCDNUrlResult!]!",
summary: "CsamDeletionRequestCDNSummary!"
  },
  CsamDeletionRequestCDNSummary: {
    failed: "Int!",
succeeded: "Int!",
total: "Int!"
  },
  CsamDeletionRequestCDNUrlResult: {
    deletedCount: "Int!",
failedCount: "Int!",
filePaths: "[CsamDeletionRequestCDNFilePathResult!]!",
foundCount: "Int!",
message: "String!",
success: "Boolean!",
url: "String!"
  },
  ExistsFilter: {
    op: "FilterComparisonOperatorExists!"
  },
  FloatFilterValue: {
    op: "FilterComparisonOperator",
value: "Float!"
  },
  GameNameFieldFilterValue: {
    op: "FilterComparisonOperator",
value: "String!"
  },
  GamesFacet: {
    genre: "[String!]",
hasCollections: "[String!]",
supportsVortex: "[String!]"
  },
  GamesSearchFilter: {
    filter: "[GamesSearchFilter!]",
name: "[GameNameFieldFilterValue!]",
op: "FilterLogicalOperator"
  },
  GamesSearchSort: {
    approved: "BaseSortValue",
collections: "BaseSortValue",
downloads: "BaseSortValue",
mods: "BaseSortValue",
name: "BaseSortValue",
relevance: "BaseSortValue"
  },
  IntFilterValue: {
    op: "FilterComparisonOperator",
value: "Int!"
  },
  MediaFacet: {
    category: "[String!]",
gameId: "[String!]",
type: "[String!]"
  },
  MediaGeneralSearchFilterValue: {
    op: "FilterComparisonOperator",
value: "String!"
  },
  MediaSearchFilter: {
    adultContent: "[BooleanFilterValue!]",
createdAt: "[BaseFilterValue!]",
filter: "[MediaSearchFilter!]",
gameId: "[BaseFilterValue!]",
gameName: "[BaseFilterValue!]",
generalSearch: "[MediaGeneralSearchFilterValue!]",
mediaStatus: "[BaseFilterValue!]",
op: "FilterLogicalOperator",
owner: "[BaseFilterValue!]",
type: "[BaseFilterValue!]"
  },
  MediaSearchSort: {
    createdAt: "BaseSortValue",
random: "RandomSortValue",
rating: "BaseSortValue",
views: "BaseSortValue"
  },
  ModFileContentSearchFilter: {
    fileExtensionExact: "[BaseFilterValueEqualsMatches!]",
fileId: "[IntFilterValue!]",
fileNameWildcard: "[BaseFilterValueEqualsWildcard!]",
filePathPartsExact: "[BaseFilterValueEqualsMatches!]",
filePathWildcard: "[BaseFilterValueEqualsWildcard!]",
fileSize: "[BaseFilterValueNumeric!]",
filter: "[ModFileContentSearchFilter!]",
gameId: "[IntFilterValue!]",
modId: "[IntFilterValue!]",
op: "FilterLogicalOperator"
  },
  ModFileContentSearchSort: {
    fileId: "BaseSortValue",
gameId: "BaseSortValue",
modId: "BaseSortValue"
  },
  ModerationRestrictionInput: {
    gameId: "ID",
modId: "ID",
restriction: "ModerationRestrictions!",
timeframe: "Int!"
  },
  ModsFacet: {
    adult: "[String!]",
categoryName: "[String!]",
gameDomainName: "[String!]",
gameId: "[String!]",
gameName: "[String!]",
languageName: "[String!]",
status: "[String!]",
tag: "[String!]"
  },
  ModsFilter: {
    adultContent: "[BooleanFilterValue!]",
author: "[BaseFilterValue!]",
categoryName: "[BaseFilterValue!]",
createdAt: "[BaseFilterValue!]",
description: "[BaseFilterValueEqualsMatches!]",
downloads: "[IntFilterValue!]",
endorsements: "[IntFilterValue!]",
fileSize: "[IntFilterValue!]",
filter: "[ModsFilter!]",
gameDomainName: "[BaseFilterValue!]",
gameId: "[BaseFilterValue!]",
gameName: "[BaseFilterValue!]",
hasUpdated: "[BooleanFilterValue!]",
languageName: "[BaseFilterValue!]",
name: "[BaseFilterValueEqualsWildcard!]",
nameStemmed: "[BaseFilterValue!]",
op: "FilterLogicalOperator",
primaryImage: "[BaseFilterValue!]",
status: "[BaseFilterValue!]",
supportsVortex: "[BooleanFilterValue!]",
tag: "[BaseFilterValue!]",
updatedAt: "[BaseFilterValue!]",
uploader: "[BaseFilterValue!]",
uploaderId: "[BaseFilterValue!]"
  },
  ModsSort: {
    createdAt: "BaseSortValue",
downloads: "BaseSortValue",
endorsements: "BaseSortValue",
lastComment: "BaseSortValue",
name: "BaseSortValue",
random: "RandomSortValue",
relevance: "BaseSortValue",
size: "BaseSortValue",
uniqueDownloads: "BaseSortValue",
updatedAt: "BaseSortValue"
  },
  RandomSortValue: {
    seed: "Int"
  },
  UpdateImageInput: {
    altText: "String",
id: "ID!",
title: "String"
  },
  UploadImageInput: {
    altText: "String",
contentType: "String!",
id: "ID!",
title: "String"
  },
  UploadVideoInput: {
    url: "String!"
  },
  UsersSearchFilter: {
    filter: "[UsersSearchFilter!]",
nameExact: "[BaseFilterValueEqualsMatches!]",
nameWildcard: "[BaseFilterValue!]",
op: "FilterLogicalOperator"
  },
  UsersSearchSort: {
    name: "BaseSortValue",
relevance: "BaseSortValue"
  }
}

